
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2m4WS", function(module, exports) {

var $3hHGU = parcelRequire("3hHGU");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $bQm3c = parcelRequire("bQm3c");


var $7QM6o = parcelRequire("7QM6o");


var $jMyy4 = parcelRequire("jMyy4");


var $jpSPX = parcelRequire("jpSPX");


var $eiWUW = parcelRequire("eiWUW");

/* SmartSpaceOverview.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $gMc0m = parcelRequire("gMc0m");





var $cO1el = parcelRequire("cO1el");


var $dcJ7R = parcelRequire("dcJ7R");


var $lQS7C = parcelRequire("lQS7C");


var $e6lna = parcelRequire("e6lna");


var $ep3mz = parcelRequire("ep3mz");


var $8rneB = parcelRequire("8rneB");


var $ixL26 = parcelRequire("ixL26");





var $dhfse = parcelRequire("dhfse");

/**
 * @generated SignedSource<<2f3628aec35e8ddf6d415b11e76e8b9b>>
 * @relayHash ec77e57f60aaa31511bd727f2f353f97
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fd67ab74ba5b62e13ff5bd07bf1e02e64d32c6fffd623189814a572eb7d29d3f
const $74b7cbd9cf0b5f49$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": [
                                        "cover-picture-id-draft",
                                        "cover-picture-id-published"
                                    ]
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        },
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "number"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"])"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "SmartSpaceOverviewCoverPictureQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "SmartSpaceOverviewCoverPictureQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "ec77e57f60aaa31511bd727f2f353f97",
            "id": "fd67ab74ba5b62e13ff5bd07bf1e02e64d32c6fffd623189814a572eb7d29d3f",
            "metadata": {},
            "name": "SmartSpaceOverviewCoverPictureQuery",
            "operationKind": "query",
            "text": "query SmartSpaceOverviewCoverPictureQuery($contentId:ID,$status:[String],$draftShareId:String){content(id:$contentId,draftShareId:$draftShareId,status:$status){nodes{id,properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"]){nodes{id,key,value,version{number}}}}}}"
        }
    };
}();
$74b7cbd9cf0b5f49$var$node.hash = "890c0d7ea56280006fd23fc1dd1199b3";
var $74b7cbd9cf0b5f49$export$2e2bcd8739ae039 = $74b7cbd9cf0b5f49$var$node;









var $jPACe = parcelRequire("jPACe");


var $3WPGR = parcelRequire("3WPGR");


var $bKd7w = parcelRequire("bKd7w");


var $3oWMY = parcelRequire("3oWMY");




const $b9c2fb682b28c513$var$SmartSpaceOverviewCoverPictureQuery = (0, $74b7cbd9cf0b5f49$export$2e2bcd8739ae039);
const $b9c2fb682b28c513$var$SMART_SPACE_OVERVIEW_COVER_IMAGE_HEIGHT = 200;
const $b9c2fb682b28c513$export$4c3aaf664391b8c5 = ({ contentId: contentId, isAdmin: isAdmin, hasEmoji: hasEmoji })=>{
    const containerRef = (0, $42omo.useRef)(null);
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false);
    const { data: data } = (0, $jMyy4.useQueryInterop)($b9c2fb682b28c513$var$SmartSpaceOverviewCoverPictureQuery, {
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ]
        },
        __callerPackage__: "space-overview"
    });
    const { coverPicture: coverPicture, contentAppearance: contentAppearance, hasCoverPicture: hasPublishedCoverPicture } = (0, $3WPGR.getRendererCoverPictureInfo)(data, false);
    const properties = data?.content?.nodes?.[0]?.properties?.nodes || [];
    const draftCoverPicture = (0, $3WPGR.propertyToId)(properties.find((property)=>property?.key === (0, $bKd7w.CoverPictureIdPropertyKey).DRAFT));
    const hasDraftCoverPicture = !!draftCoverPicture?.value?.id;
    const hasCoverPicture = hasDraftCoverPicture || hasPublishedCoverPicture;
    const hasRenderableCoverPicture = isAdmin ? hasCoverPicture : hasPublishedCoverPicture;
    const content = isAdmin ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jPACe.EditorPageCoverPictureEntry), {
        key: `${contentId}-${hasCoverPicture ? 'filled' : 'empty'}`,
        contentId: contentId,
        isPublishingContent: false,
        contentType: "page",
        userOffline: false,
        hasCoverPicture: hasCoverPicture,
        contentPropertyKey: hasDraftCoverPicture ? (0, $bKd7w.CoverPictureIdPropertyKey).DRAFT : (0, $bKd7w.CoverPictureIdPropertyKey).PUBLISHED,
        isSmartSpaceOverview: true,
        isUnpublishedDraft: false,
        isReadOnly: false,
        dynamicCoverImageHeight: $b9c2fb682b28c513$var$SMART_SPACE_OVERVIEW_COVER_IMAGE_HEIGHT
    }) : hasPublishedCoverPicture ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3oWMY.RendererPageCoverPicture), {
        contentId: contentId,
        isPagePreview: false,
        coverPicture: coverPicture,
        contentAppearance: contentAppearance,
        isSmartSpaceOverview: true,
        hasEmoji: hasEmoji
    }) : null;
    if (!hasRenderableCoverPicture) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: containerRef,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        onFocus: ()=>setIsHovered(true),
        onBlur: ()=>setIsHovered(false),
        className: (0, $gMc0m.default)([
            $b9c2fb682b28c513$var$styles.root
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "space-overview-cover-placeholder",
        className: (0, $gMc0m.default)([
            $b9c2fb682b28c513$var$styles.placeholder
        ])
    }, content && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $b9c2fb682b28c513$var$styles.placeholderContent,
            isHovered && $b9c2fb682b28c513$var$styles.placeholderContentVisible
        ])
    }, content)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: containerRef,
        className: (0, $gMc0m.default)([
            $b9c2fb682b28c513$var$styles.root
        ])
    }, content);
};
const $b9c2fb682b28c513$var$styles = {
    root: "_kqswh2mm _7cca15wb _4t3iuuw1",
    placeholder: "_1r04idpf _2rkopb1k _kqswstnw _1e0c1txw _1bah1h6o _4cvr1h6o _1itk1tbc",
    placeholderContent: "_v564m7ou _tzy4idpf",
    placeholderContentVisible: "_tzy4kb7n"
};


/**
 * @generated SignedSource<<da327cc7727f78d9b8699df16d8996d2>>
 * @relayHash 7ed1e317e90fc777adf227a379521cab
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6dff29da4655f295cb5e263cd8e3e356822a1c949d5f9a9a278f3dd4f2922eb7
const $97dc1b18f616085f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "ConfluenceUpdateSmartSpaceOverviewPayload",
            "kind": "LinkedField",
            "name": "confluence_updateSmartSpaceOverview",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceSmartSpaceOverview",
                    "kind": "LinkedField",
                    "name": "overview",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceSmartSpaceOverviewSummary",
                            "kind": "LinkedField",
                            "name": "summary",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "body"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SmartSpaceOverviewSummaryUpdateMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SmartSpaceOverviewSummaryUpdateMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "7ed1e317e90fc777adf227a379521cab",
            "id": "6dff29da4655f295cb5e263cd8e3e356822a1c949d5f9a9a278f3dd4f2922eb7",
            "metadata": {},
            "name": "SmartSpaceOverviewSummaryUpdateMutation",
            "operationKind": "mutation",
            "text": "mutation SmartSpaceOverviewSummaryUpdateMutation($cloudId:ID!,$input:ConfluenceUpdateSmartSpaceOverviewInput!){confluence_updateSmartSpaceOverview(cloudId:$cloudId,input:$input){success,errors{message},overview{summary{body}}}}"
        }
    };
}();
$97dc1b18f616085f$var$node.hash = "c07da228d9ec183b11eb802e583c9e4e";
var $97dc1b18f616085f$export$2e2bcd8739ae039 = $97dc1b18f616085f$var$node;









var $aXWIB = parcelRequire("aXWIB");


var $1qfLF = parcelRequire("1qfLF");


var $cvXh8 = parcelRequire("cvXh8");


var $hmuev = parcelRequire("hmuev");


var $1Zr9M = parcelRequire("1Zr9M");


var $d8ohW = parcelRequire("d8ohW");


var $9FnLD = parcelRequire("9FnLD");


var $9zIwY = parcelRequire("9zIwY");


var $3sFtD = parcelRequire("3sFtD");


var $9EtP6 = parcelRequire("9EtP6");


var $3gadb = parcelRequire("3gadb");


var $6gQN0 = parcelRequire("6gQN0");

var $22hCZ = parcelRequire("22hCZ");





var $9wGTI = parcelRequire("9wGTI");


var $308Wd = parcelRequire("308Wd");


var $86okN = parcelRequire("86okN");





var $2m4WS = parcelRequire("2m4WS");




function $75b7ce46cf4dcbf4$export$95779ae96ff09d4a({ durationMs: durationMs = 2000 } = {}) {
    const timeoutRef = (0, $42omo.useRef)(null);
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        return function cleanup() {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, []);
    function startLoading() {
        setIsLoading(true);
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(()=>{
            setIsLoading(false);
        }, durationMs);
    }
    return [
        startLoading,
        isLoading
    ];
}


const $d3f4a8c5a2c21120$var$SmartSpaceOverviewSummaryViewInner = ({ body: body, spaceKey: spaceKey, isPinned: isPinned, onSave: onSave })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { showFlag: showFlag } = (0, $22hCZ.useFlags)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false);
    const [isEditing, setIsEditing] = (0, $42omo.useState)(false);
    const [editText, setEditText] = (0, $42omo.useState)(body);
    const [vote, setVote] = (0, $42omo.useState)(null);
    const [startRefresh, isRefreshing] = (0, $75b7ce46cf4dcbf4$export$95779ae96ff09d4a)();
    const handleMouseEnter = (0, $42omo.useCallback)(()=>setIsHovered(true), []);
    const handleMouseLeave = (0, $42omo.useCallback)(()=>setIsHovered(false), []);
    const showFeedbackFlag = (0, $42omo.useCallback)(()=>{
        showFlag({
            title: formatMessage($d3f4a8c5a2c21120$var$i18n.feedbackFlagTitle),
            description: formatMessage($d3f4a8c5a2c21120$var$i18n.feedbackFlagDescription),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
                color: "var(--ds-icon-success, #6A9A23)",
                label: "success"
            }),
            isAutoDismiss: true
        });
    }, [
        showFlag,
        formatMessage
    ]);
    const fireFeedbackEvent = (0, $42omo.useCallback)((wasHelpful)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'submitted',
                actionSubject: 'feedback',
                actionSubjectId: 'summary',
                source: 'smartSpaceOverview',
                attributes: {
                    moduleType: 'summary',
                    spaceKey: spaceKey,
                    wasHelpful: wasHelpful,
                    isPinned: isPinned
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        spaceKey,
        isPinned
    ]);
    const fireEditedEvent = (0, $42omo.useCallback)((previousBody, newBody)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'edited',
                actionSubject: 'text',
                actionSubjectId: 'summary',
                source: 'smartSpaceOverview',
                attributes: {
                    moduleType: 'summary',
                    spaceKey: spaceKey,
                    previousSummaryLength: previousBody.length,
                    newSummaryLength: newBody.length,
                    isPinned: isPinned
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        spaceKey,
        isPinned
    ]);
    const handleThumbsUp = (0, $42omo.useCallback)(()=>{
        setVote('up');
        showFeedbackFlag();
        fireFeedbackEvent(true);
    }, [
        showFeedbackFlag,
        fireFeedbackEvent
    ]);
    const handleThumbsDown = (0, $42omo.useCallback)(()=>{
        setVote('down');
        showFeedbackFlag();
        fireFeedbackEvent(false);
    }, [
        showFeedbackFlag,
        fireFeedbackEvent
    ]);
    const handleRefresh = (0, $42omo.useCallback)(()=>{
        setVote(null);
        startRefresh();
    }, [
        startRefresh
    ]);
    const onEdit = (0, $42omo.useCallback)(()=>{
        setEditText(body);
        setIsEditing(true);
    }, [
        body
    ]);
    const onConfirm = (0, $42omo.useCallback)(()=>{
        if (body !== editText) {
            fireEditedEvent(body, editText);
            onSave(editText);
        }
        setIsEditing(false);
    }, [
        body,
        editText,
        fireEditedEvent,
        onSave
    ]);
    const onCancel = (0, $42omo.useCallback)(()=>{
        setEditText(body);
        setIsEditing(false);
    }, [
        body
    ]);
    const onKeyDown = (0, $42omo.useCallback)((e)=>{
        if (e.key === 'Escape') onCancel();
    }, [
        onCancel
    ]);
    if (isEditing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "smart-space-overview-summary-edit",
        className: (0, $gMc0m.default)([
            $d3f4a8c5a2c21120$var$styles.editContainer
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9EtP6.default), {
        value: editText,
        onChange: (e)=>setEditText(e.target.value),
        onKeyDown: onKeyDown,
        minimumRows: 3,
        resize: "vertical",
        testId: "smart-space-overview-summary-edit-input"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $d3f4a8c5a2c21120$var$styles.editActions
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: formatMessage($d3f4a8c5a2c21120$var$i18n.confirm)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))),
        label: formatMessage($d3f4a8c5a2c21120$var$i18n.confirm),
        appearance: "default",
        onClick: onConfirm,
        testId: "smart-space-overview-summary-confirm-button"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: formatMessage($d3f4a8c5a2c21120$var$i18n.cancel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
        label: formatMessage($d3f4a8c5a2c21120$var$i18n.cancel),
        appearance: "default",
        onClick: onCancel,
        testId: "smart-space-overview-summary-cancel-button"
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "smart-space-overview-summary",
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleMouseEnter,
        onBlur: handleMouseLeave,
        className: (0, $gMc0m.default)([
            $d3f4a8c5a2c21120$var$styles.summaryContainer
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $d3f4a8c5a2c21120$var$styles.summaryBody,
            "_vwz4qslr",
            isRefreshing && $d3f4a8c5a2c21120$var$styles.contentBlurred
        ])
    }, body), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        style: {
            opacity: isHovered ? 1 : 0,
            pointerEvents: isHovered ? 'auto' : 'none'
        },
        className: (0, $gMc0m.default)([
            $d3f4a8c5a2c21120$var$styles.actionsContainer,
            "_v564m7ou"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $d3f4a8c5a2c21120$var$styles.actionsContent
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: formatMessage($d3f4a8c5a2c21120$var$i18n.edit)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
                label: "",
                color: "var(--ds-icon-subtlest, #6B6E76)"
            }),
        label: formatMessage($d3f4a8c5a2c21120$var$i18n.edit),
        appearance: "subtle",
        spacing: "compact",
        onClick: onEdit,
        testId: "smart-space-overview-summary-edit-button"
    })), (0, $9wGTI.fg)('smart-space-overview-refresh') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: formatMessage($d3f4a8c5a2c21120$var$i18n.refresh)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d8ohW))), {
                label: "",
                color: "var(--ds-icon-subtlest, #6B6E76)"
            }),
        label: formatMessage($d3f4a8c5a2c21120$var$i18n.refresh),
        appearance: "subtle",
        spacing: "compact",
        isLoading: isRefreshing,
        onClick: handleRefresh,
        testId: "smart-space-overview-summary-refresh-button"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9FnLD))), {
                label: "",
                color: vote === 'up' ? "var(--ds-icon-accent-blue, #357DE8)" : "var(--ds-icon-subtlest, #6B6E76)"
            }),
        label: formatMessage($d3f4a8c5a2c21120$var$i18n.thumbsUp),
        appearance: "subtle",
        spacing: "compact",
        isSelected: vote === 'up',
        isTooltipDisabled: false,
        onClick: ()=>{
            if (vote !== 'up') handleThumbsUp();
        },
        testId: "smart-space-overview-summary-thumbs-up-button"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9zIwY))), {
                label: "",
                color: vote === 'down' ? "var(--ds-icon-accent-blue, #357DE8)" : "var(--ds-icon-subtlest, #6B6E76)"
            }),
        label: formatMessage($d3f4a8c5a2c21120$var$i18n.thumbsDown),
        appearance: "subtle",
        spacing: "compact",
        isSelected: vote === 'down',
        isTooltipDisabled: false,
        onClick: ()=>{
            if (vote !== 'down') handleThumbsDown();
        },
        testId: "smart-space-overview-summary-thumbs-down-button"
    }))));
};
const $d3f4a8c5a2c21120$export$cb21a8674ed8fd22 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6gQN0.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d3f4a8c5a2c21120$var$SmartSpaceOverviewSummaryViewInner, props));
const $d3f4a8c5a2c21120$export$54ca75a6425bb521 = ({ summaryData: summaryData, spaceKey: spaceKey })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const queryDocumentNode = (0, $86okN.toDocumentNode)((0, $2m4WS.SpaceOverviewSwitcherQuery));
    const [updateSummary] = (0, $308Wd.useMutationInterop)($d3f4a8c5a2c21120$var$UpdateSmartSpaceOverviewSummaryMutation, {
        __callerPackage__: "space-overview"
    });
    const onSave = (0, $42omo.useCallback)((newBody)=>{
        updateSummary({
            variables: {
                cloudId: cloudId,
                input: {
                    spaceKey: spaceKey,
                    summary: {
                        body: newBody
                    }
                }
            },
            optimisticResponse: {
                confluence_updateSmartSpaceOverview: {
                    success: true,
                    errors: null,
                    overview: {
                        summary: {
                            body: newBody
                        }
                    }
                }
            },
            update: (cache, { data: mutationData })=>{
                const updatedBody = mutationData?.confluence_updateSmartSpaceOverview?.overview?.summary?.body;
                if (updatedBody == null) return;
                cache.writeQuery({
                    query: queryDocumentNode,
                    variables: {
                        cloudId: cloudId,
                        spaceKey: spaceKey
                    },
                    data: {
                        confluence_smartSpaceOverview: {
                            __typename: 'ConfluenceSmartSpaceOverview',
                            summary: {
                                __typename: 'ConfluenceSmartSpaceOverviewSummary',
                                body: updatedBody
                            }
                        }
                    }
                });
            }
        });
    }, [
        cloudId,
        spaceKey,
        updateSummary,
        queryDocumentNode
    ]);
    const body = summaryData?.body;
    if (!body) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d3f4a8c5a2c21120$export$cb21a8674ed8fd22, {
        body: body,
        spaceKey: spaceKey,
        isPinned: summaryData?.isPinned ?? false,
        onSave: onSave
    });
};
const $d3f4a8c5a2c21120$var$UpdateSmartSpaceOverviewSummaryMutation = (0, $97dc1b18f616085f$export$2e2bcd8739ae039);
const $d3f4a8c5a2c21120$var$i18n = (0, $aXWIB.defineMessages)({
    edit: {
        id: "space-overview.smart-space-overview.summary.edit",
        defaultMessage: "Edit"
    },
    confirm: {
        id: "space-overview.smart-space-overview.summary.confirm",
        defaultMessage: "Confirm"
    },
    cancel: {
        id: "space-overview.smart-space-overview.summary.cancel",
        defaultMessage: "Cancel"
    },
    refresh: {
        id: "space-overview.smart-space-overview.summary.refresh",
        defaultMessage: "Refresh"
    },
    thumbsUp: {
        id: "space-overview.smart-space-overview.summary.thumbs-up",
        defaultMessage: "Good summary"
    },
    thumbsDown: {
        id: "space-overview.smart-space-overview.summary.thumbs-down",
        defaultMessage: "Bad summary"
    },
    feedbackFlagTitle: {
        id: "space-overview.smart-space-overview.summary.feedback-flag-title",
        defaultMessage: "Thanks!"
    },
    feedbackFlagDescription: {
        id: "space-overview.smart-space-overview.summary.feedback-flag-description",
        defaultMessage: "We appreciate you taking the time to send this feedback."
    }
}); // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
const $d3f4a8c5a2c21120$var$summaryBodyLineHeightStyle = null;
const $d3f4a8c5a2c21120$var$actionsContainerTransitionStyle = null;
const $d3f4a8c5a2c21120$var$styles = {
    summaryContainer: "_kqswh2mm",
    summaryBody: "_11c8fhey _syazi7uo _o5721jtm",
    actionsContainer: "_1e0c1txw _kqswstnw _154iidpf _rjxpidpf _bozg1ejb _1itk13yu",
    actionsContent: "_1e0c1txw _4cvr1h6o _1n261q9c _1o9zidpf",
    editContainer: "_zulp1b66 _2rko1qi0 _1yt41b66 _1e0c1txw _2lx21bp4 _bfhksm61",
    editActions: "_zulp1b66 _1e0c1txw _1bahesu3 _4cvr1h6o",
    contentBlurred: "_v5641bup _tzy42wxo _lcxvglyw"
};


/* PopularQuestions.tsx generated by @compiled/babel-plugin v2.0.0 */ 


















var $eyWa4 = parcelRequire("eyWa4");


var $i25hX = parcelRequire("i25hX");


var $jlIaF = parcelRequire("jlIaF");


var $1NBp8 = parcelRequire("1NBp8");





/* QuestionItem.tsx generated by @compiled/babel-plugin v2.0.0 */ 









var $ghftu = parcelRequire("ghftu");


var $2AytZ = parcelRequire("2AytZ");








var $cOQz3 = parcelRequire("cOQz3");













var $fVUfS = parcelRequire("fVUfS");





var $iXCQx = parcelRequire("iXCQx");











/* FollowUpQuestions.tsx generated by @compiled/babel-plugin v2.0.0 */ 














const $b8b7b04208de7a0b$var$FollowUpButton = ({ followUp: followUp, followUpPosition: followUpPosition, onFollowUp: onFollowUp })=>{
    const handleClick = (0, $42omo.useCallback)(()=>{
        onFollowUp(followUp, followUpPosition);
    }, [
        onFollowUp,
        followUp,
        followUpPosition
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.Pressable), {
        xcss: $b8b7b04208de7a0b$var$styles.followUpButton,
        onClick: handleClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cOQz3))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.Text), {
        size: "medium",
        color: "color.text.subtle"
    }, followUp));
};
const $b8b7b04208de7a0b$export$9d9f2e3275d0d624 = ({ questions: questions, onFollowUp: onFollowUp })=>{
    if (questions.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $b8b7b04208de7a0b$var$styles.followUpContainer
        ])
    }, questions.map((followUp, index)=>followUp ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b8b7b04208de7a0b$var$FollowUpButton, {
            key: followUp,
            followUp: followUp,
            followUpPosition: index,
            onFollowUp: onFollowUp
        }) : null));
};
const $b8b7b04208de7a0b$var$styles = {
    followUpContainer: "_zulpu2gc _1e0c1txw _1n261g80 _4cvrv2br",
    followUpButton: "_zulpu2gc _2rko1mok _189ee4h9 _1dqonqa1 _1h6d1l7x _1e0c116y _4cvr1h6o _1q51u2gc _85i5u2gc _bozgutpp _y4tiutpp _bfhk1j28 _80omtlke _y3gnv2br _irr31dpa"
};


/* RovoInput.tsx generated by @compiled/babel-plugin v2.0.0 */ 












var $lAFHW = parcelRequire("lAFHW");


var $euUgw = parcelRequire("euUgw");

const $bb5f5999bd84aada$export$995e9427a9b39595 = ({ onSend: onSend })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [value, setValue] = (0, $42omo.useState)('');
    const handleSend = (0, $42omo.useCallback)(()=>{
        if (value.trim()) {
            onSend(value.trim());
            setValue('');
        }
    }, [
        value,
        onSend
    ]);
    const handleKeyDown = (0, $42omo.useCallback)((e)=>{
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSend();
        }
    }, [
        handleSend
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $bb5f5999bd84aada$var$styles.rovoInputContainer
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $bb5f5999bd84aada$var$styles.rovoIcon
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.RovoIcon), {
        size: "xsmall",
        appearance: "brand",
        shouldUseNewLogoDesign: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
        type: "text",
        placeholder: formatMessage($bb5f5999bd84aada$var$i18n.askRovoPlaceholder),
        value: value,
        onChange: (e)=>setValue(e.target.value),
        onKeyDown: handleKeyDown,
        className: (0, $gMc0m.default)([
            $bb5f5999bd84aada$var$styles.rovoInput
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($euUgw))),
        label: formatMessage($bb5f5999bd84aada$var$i18n.sendQuestion),
        appearance: "primary",
        shape: "circle",
        isDisabled: !value.trim(),
        onClick: handleSend
    }));
};
const $bb5f5999bd84aada$var$i18n = (0, $aXWIB.defineMessages)({
    askRovoPlaceholder: {
        id: "space-overview.smart-space-overview.popular-questions.ask-rovo-placeholder",
        defaultMessage: "Ask Rovo anything"
    },
    sendQuestion: {
        id: "space-overview.smart-space-overview.popular-questions.send-question",
        defaultMessage: "Send question"
    }
});
const $bb5f5999bd84aada$var$styles = {
    rovoInputContainer: "_zulpu2gc _2rkopb1k _1rjcutpp _189ee4h9 _1dqonqa1 _1h6d1l7x _1e0c1txw _4cvr1h6o _bozgpxbi _y4tipxbi _bfhkvuon",
    rovoIcon: "_1o9zidpf _1e0c1txw _4cvr1h6o",
    rovoInput: "_16jlkb7n _1o9zkb7n _i0dlf1ug _12ji1r31 _1qu2glyw _12y31o36 _11c8fhey _189eidpf _bfhk1j28 _syazi7uo _1idr1rpy"
};


/* SourcesSection.tsx generated by @compiled/babel-plugin v2.0.0 */ 






var $1Whri = parcelRequire("1Whri");








var $gdv5Z = parcelRequire("gdv5Z");


var $u9agA = parcelRequire("u9agA");











var $hpUsb = parcelRequire("hpUsb");


var $8zS2j = parcelRequire("8zS2j");


var $5znEc = parcelRequire("5znEc");





var $lsxnT = parcelRequire("lsxnT");





var $6M71K = parcelRequire("6M71K");


var $5d01x = parcelRequire("5d01x");

/* SourceItem.tsx generated by @compiled/babel-plugin v2.0.0 */ 



var $auNCB = parcelRequire("auNCB");














var $4Nwes = parcelRequire("4Nwes");



const $7781dafab97bcef1$var$iconOverrides = {
    Confluence: (0, $lAFHW.ConfluenceIcon),
    Jira: (0, $lAFHW.JiraIcon),
    Loom: (0, $lAFHW.LoomIcon),
    Bitbucket: (0, $lAFHW.BitbucketIcon),
    Goals: (0, $lAFHW.GoalsIcon),
    Projects: (0, $lAFHW.ProjectsIcon),
    Teams: (0, $lAFHW.TeamsIcon),
    Home: (0, $lAFHW.HomeIcon)
};
const $7781dafab97bcef1$export$aa172d33ca929727 = ({ url: url, completeKey: completeKey })=>{
    if (completeKey) {
        const IconOverride = $7781dafab97bcef1$var$iconOverrides[completeKey];
        if (IconOverride) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(IconOverride, {
            size: "xxsmall",
            shouldUseNewLogoDesign: true
        });
    }
    if (!url) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4Nwes.AtlassianIcon), {
        appearance: "neutral",
        label: "",
        size: "xxsmall"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        viewBox: "0 0 16 16",
        width: "16",
        height: "16",
        "aria-hidden": "true",
        "data-testid": "app-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("filter", {
        id: "changeFillColor"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0.02, 0, 0, 0, 0, 0, 0.04, 0, 0, 0, 0, 0, 0.07, 0, 0, 0, 0, 0, 1, 0"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("image", {
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        xlinkHref: url,
        width: "16",
        height: "16",
        x: "0",
        y: "0",
        filter: $7781dafab97bcef1$var$isSvg(url) ? 'url(#changeFillColor)' : ''
    }));
};
const $7781dafab97bcef1$var$isSvg = (url)=>{
    const fileType = url.split(/\#|\?/)[0].split('.').pop();
    return !!fileType && fileType.trim() === 'svg';
};


const $d05f38054d846c18$export$64eb96c340cb75b = ({ source: source })=>{
    const { title: title, links: links, embeddedProduct: embeddedProduct, excerpt: excerpt } = source.content ?? {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.Stack), {
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.Inline), {
        alignBlock: "center",
        space: "space.100"
    }, (0, $7781dafab97bcef1$export$aa172d33ca929727)({
        url: links?.webui,
        completeKey: embeddedProduct
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.Text), {
        weight: "regular",
        maxLines: 1
    }, title)), excerpt && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.Text), {
        size: "small",
        color: "color.text.subtle",
        maxLines: 2
    }, excerpt));
};
const $d05f38054d846c18$export$7432640a758da4b1 = ({ source: source })=>{
    const webui = source.content?.links?.webui;
    if (!webui) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d05f38054d846c18$export$64eb96c340cb75b, {
        source: source
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auNCB.Anchor), {
        href: webui,
        rel: "noopener noreferrer",
        xcss: $d05f38054d846c18$var$styles.noUnderline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d05f38054d846c18$export$64eb96c340cb75b, {
        source: source
    }));
};
const $d05f38054d846c18$var$styles = {
    noUnderline: "_4bfu1r31 _1hmsglyw _ajmmnqa1"
};


const $1f92641a13bcc754$export$99bd007203d2166e = ({ sources: sources, spaceKey: spaceKey, questionPosition: questionPosition })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { Popup: Popup } = (0, $lsxnT.useChoreographerAssets)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const validSources = (0, $42omo.useMemo)(()=>sources.filter((source)=>source.content != null), [
        sources
    ]);
    const sourceUrls = (0, $42omo.useMemo)(()=>validSources.flatMap((source)=>{
            const webui = source.content?.links?.webui;
            return webui ? [
                `${window.location.origin}${(0, $jlIaF.CONTEXT_PATH)}${webui}`
            ] : [];
        }), [
        validSources
    ]);
    const fireSourcesEvent = (0, $42omo.useCallback)((action)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: action,
                actionSubject: 'popup',
                actionSubjectId: 'sources',
                source: 'smartSpaceOverview',
                attributes: {
                    moduleType: 'faq',
                    spaceKey: spaceKey,
                    questionPosition: questionPosition,
                    sourceCount: validSources.length
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        spaceKey,
        questionPosition,
        validSources
    ]);
    const handleToggle = (0, $42omo.useCallback)((event)=>{
        event.stopPropagation();
        setIsOpen((prev)=>{
            fireSourcesEvent(prev ? 'collapsed' : 'expanded');
            return !prev;
        });
    }, [
        fireSourcesEvent
    ]);
    const handleClose = (0, $42omo.useCallback)(()=>{
        setIsOpen(false);
        fireSourcesEvent('collapsed');
    }, [
        fireSourcesEvent
    ]);
    if (validSources.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
        xcss: $1f92641a13bcc754$var$styles.triggerWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Popup, {
        placement: "bottom-end",
        isOpen: isOpen,
        onClose: handleClose,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6M71K.ConfluenceSmartCardProvider), {
                authFlow: "disabled"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
                xcss: $1f92641a13bcc754$var$styles.popupContent
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.Inline), {
                space: "space.0",
                spread: "space-between",
                alignBlock: "center",
                xcss: $1f92641a13bcc754$var$styles.popupHeader
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
                xcss: $1f92641a13bcc754$var$styles.popupHeaderText
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.Text), {
                size: "medium",
                weight: "medium"
            }, formatMessage($1f92641a13bcc754$var$i18n.sourcesCount, {
                count: validSources.length
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                appearance: "subtle",
                icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                        ...props,
                        size: "small"
                    }),
                label: formatMessage($1f92641a13bcc754$var$i18n.closeSources),
                shape: "circle",
                onClick: handleClose
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.Stack), {
                as: "ul",
                xcss: $1f92641a13bcc754$var$styles.sourcesList,
                space: "space.050"
            }, validSources.map((source, index)=>{
                const webui = source.content?.links?.webui;
                const absoluteUrl = webui ? `${window.location.origin}${0, $jlIaF.CONTEXT_PATH}${webui}` : undefined;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", {
                    key: source.content?.id
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.Pressable), {
                    xcss: $1f92641a13bcc754$var$styles.sourceListItem,
                    onClick: (e)=>{
                        e.stopPropagation();
                        createAnalyticsEvent({
                            type: 'sendUIEvent',
                            data: {
                                action: 'clicked',
                                actionSubject: 'link',
                                actionSubjectId: 'sourceLink',
                                source: 'smartSpaceOverview',
                                attributes: {
                                    moduleType: 'faq',
                                    spaceKey: spaceKey,
                                    questionPosition: questionPosition,
                                    sourceIndex: index,
                                    sourceProduct: source.content?.embeddedProduct ?? null
                                }
                            }
                        }).fire();
                        if (absoluteUrl) window.open(absoluteUrl, '_blank', 'noopener,noreferrer');
                    }
                }, absoluteUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hpUsb.Card), {
                    appearance: "block",
                    url: absoluteUrl,
                    showHoverPreview: false,
                    fallbackComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d05f38054d846c18$export$64eb96c340cb75b), {
                            source: source
                        }),
                    ui: {
                        hideBackground: true,
                        hideElevation: true,
                        hidePadding: true
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5znEc.default), {
                    maxLines: 1
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8zS2j.default), {
                    maxLines: 2
                })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d05f38054d846c18$export$64eb96c340cb75b), {
                    source: source
                })));
            })))),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.Pressable), {
                ...triggerProps,
                onClick: handleToggle,
                xcss: (0, $1Whri.cx)($1f92641a13bcc754$var$styles.sourcesButton, isOpen && $1f92641a13bcc754$var$styles.sourcesButtonSelected)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.Inline), {
                space: "space.075",
                alignBlock: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5d01x.SourceLogoStack), {
                sources: sourceUrls
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.Text), {
                size: "medium",
                weight: "medium",
                color: isOpen ? 'color.text.selected' : 'color.text.subtle'
            }, formatMessage($1f92641a13bcc754$var$i18n.sourcesCount, {
                count: validSources.length
            }))))
    }));
};
const $1f92641a13bcc754$var$i18n = (0, $aXWIB.defineMessages)({
    sourcesCount: {
        id: "space-overview.smart-space-overview.popular-questions.sources-count",
        defaultMessage: "{count, plural, one {# Source} other {# Sources}}"
    },
    closeSources: {
        id: "space-overview.smart-space-overview.popular-questions.close-sources",
        defaultMessage: "Close sources"
    }
});
const $1f92641a13bcc754$var$styles = {
    sourcesButton: "_2rko1mok _zulp1b66 _1h6d1l7x _189ee4h9 _1dqonqa1 _19bvu2gc _u5f3u2gc _ca0qze3t _n3tdze3t _4t3i1ul9 _bfhksm61 _syazazsu _k48p1wq8 _ect4ttxp _80omtlke _1e0c1txw _4cvr1h6o _irr31dpa",
    sourcesButtonSelected: "_1h6dq98m _bfhk15s3 _syaz6x5g _irr3ufnl",
    triggerWrapper: "_1e0c1o8l _1o9zidpf",
    popupContent: "_2rkopb1k _ca0qu2gc _u5f3utpp _n3tdpxbi _19bvutpp _1bsbp2n4 _c71l1kdj _18m91wug",
    popupHeader: "_otyrv77o",
    popupHeaderText: "_19bvu2gc",
    sourcesList: "_qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _19bvze3t",
    sourceCard: "_19itglyw _1reo15vq _18m915vq _y3gn1e5h _1bsb1osq",
    sourceListItem: "_2rko1qi0 _1reo15vq _18m915vq _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _80omtlke _bfhk1j28 _1bsb1osq _y3gn1e5h _irr31dpa"
};


/**
 * Tracks how long a user dwells on an expanded FAQ question.
 *
 * Measures two durations per expansion:
 *  - `dwellTimeMs`     — time the expanded content was visible in the viewport.
 *  - `expandDurationMs` — wall-clock time from expand to collapse.
 *
 * Both are capped at MAX_DWELL_DURATION_MS. A "dwelled" analytics event is
 * fired automatically when the expansion ends, tagged with an end reason:
 *  - `manualCollapse` — user clicked to close.
 *  - `switchQuestion` — another question was expanded.
 *  - `navigated`      — the component unmounted (e.g. page navigation).
 */ 





// Filter out stale expansions (e.g. user expanded a question and walked away).
const $20b6fea54848571f$var$MAX_DWELL_DURATION_MS = 300000;
const $20b6fea54848571f$export$d5c16baac6dcf544 = ({ isExpanded: isExpanded, expandedContentRef: expandedContentRef, spaceKey: spaceKey, questionPosition: questionPosition })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const sessionRef = (0, $42omo.useRef)(null);
    const isMountedRef = (0, $42omo.useRef)(true);
    (0, $42omo.useEffect)(()=>()=>{
            isMountedRef.current = false;
        }, []);
    (0, $42omo.useEffect)(()=>{
        if (!isExpanded) return;
        const expandStart = Date.now();
        let accumulatedDwellMs = 0;
        let viewportEnteredAt = null;
        const computeMetrics = ()=>{
            let dwellTimeMs = accumulatedDwellMs;
            if (viewportEnteredAt != null) dwellTimeMs += Date.now() - viewportEnteredAt;
            return {
                dwellTimeMs: Math.min(dwellTimeMs, $20b6fea54848571f$var$MAX_DWELL_DURATION_MS),
                expandDurationMs: Math.min(Date.now() - expandStart, $20b6fea54848571f$var$MAX_DWELL_DURATION_MS)
            };
        };
        sessionRef.current = {
            manualCollapse: false,
            computeMetrics: computeMetrics
        };
        const node = expandedContentRef.current;
        let observer;
        let isInViewport = false;
        const pauseDwell = ()=>{
            if (viewportEnteredAt != null) accumulatedDwellMs += Date.now() - viewportEnteredAt;
            viewportEnteredAt = null;
        };
        const resumeDwell = ()=>{
            viewportEnteredAt = Date.now();
        };
        if (node) {
            observer = new IntersectionObserver(([entry])=>{
                isInViewport = entry.isIntersecting;
                if (entry.isIntersecting) // Only resume if the tab is currently visible
                {
                    if (document.visibilityState === 'visible') resumeDwell();
                } else pauseDwell();
            });
            observer.observe(node);
        }
        const handleVisibilityChange = ()=>{
            if (document.visibilityState === 'hidden') pauseDwell();
            else if (isInViewport) resumeDwell();
        };
        document.addEventListener('visibilitychange', handleVisibilityChange);
        return ()=>{
            observer?.disconnect();
            document.removeEventListener('visibilitychange', handleVisibilityChange);
            const session = sessionRef.current;
            sessionRef.current = null;
            let endReason;
            if (!isMountedRef.current) endReason = 'navigated';
            else if (session?.manualCollapse) endReason = 'manualCollapse';
            else endReason = 'switchQuestion';
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'dwelled',
                    actionSubject: 'section',
                    actionSubjectId: 'expandedQuestion',
                    source: 'smartSpaceOverview',
                    attributes: {
                        moduleType: 'faq',
                        spaceKey: spaceKey,
                        questionPosition: questionPosition,
                        dwellEndReason: endReason,
                        ...computeMetrics()
                    }
                }
            }).fire();
        };
    }, [
        isExpanded,
        expandedContentRef,
        spaceKey,
        questionPosition,
        createAnalyticsEvent
    ]);
    return {
        markManualCollapse: ()=>{
            if (!sessionRef.current) return null;
            sessionRef.current.manualCollapse = true;
            return sessionRef.current.computeMetrics();
        }
    };
};


const $01328549e0c14588$var$FeedbackButtons = ({ vote: vote, onVoteUp: onVoteUp, onVoteDown: onVoteDown, upLabel: upLabel, downLabel: downLabel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9FnLD))), {
                label: "",
                color: vote === 'up' ? "var(--ds-icon-accent-blue, #357DE8)" : "var(--ds-icon-subtlest, #6B6E76)"
            }),
        label: upLabel,
        appearance: "subtle",
        spacing: "compact",
        shape: "default",
        onClick: (e)=>{
            e.stopPropagation();
            if (vote !== 'up') onVoteUp();
        },
        isTooltipDisabled: false,
        isSelected: vote === 'up'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9zIwY))), {
                label: "",
                color: vote === 'down' ? "var(--ds-icon-accent-blue, #357DE8)" : "var(--ds-icon-subtlest, #6B6E76)"
            }),
        label: downLabel,
        appearance: "subtle",
        spacing: "compact",
        shape: "default",
        onClick: (e)=>{
            e.stopPropagation();
            if (vote !== 'down') onVoteDown();
        },
        isTooltipDisabled: false,
        isSelected: vote === 'down'
    }));
const $01328549e0c14588$var$RefreshButton = ({ label: label, isLoading: isLoading, onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d8ohW))),
        label: label,
        appearance: "subtle",
        spacing: "compact",
        isLoading: isLoading,
        onClick: onClick,
        isTooltipDisabled: false
    });
const $01328549e0c14588$var$QuestionHeader = ({ questionText: questionText, isExpanded: isExpanded, onToggle: onToggle, isRefreshing: isRefreshing, onRefresh: onRefresh, questionVote: questionVote, onVoteUp: onVoteUp, onVoteDown: onVoteDown })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const handleQuestionRefresh = (e)=>{
        e.stopPropagation();
        onRefresh(e);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $01328549e0c14588$var$styles.questionRow,
            isExpanded ? $01328549e0c14588$var$styles.questionRowExpanded : $01328549e0c14588$var$styles.questionRowCollapsed
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.Pressable), {
        xcss: $01328549e0c14588$var$styles.questionTrigger,
        onClick: onToggle,
        "aria-expanded": isExpanded,
        "aria-label": formatMessage(isExpanded ? $01328549e0c14588$var$i18n.collapseQuestion : $01328549e0c14588$var$i18n.expandQuestion, {
            question: questionText
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $01328549e0c14588$var$styles.questionIcon
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cOQz3))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $01328549e0c14588$var$styles.questionText
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.Text), {
        size: "medium",
        color: "color.text.subtle"
    }, questionText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $01328549e0c14588$var$styles.questionFeedbackButtons,
            !(0, $9wGTI.fg)('smart-space-overview-faq-always-show-feedback') && $01328549e0c14588$var$styles.hideQuestionActions
        ])
    }, (0, $9wGTI.fg)('smart-space-overview-individual-faq-regeneration') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($01328549e0c14588$var$RefreshButton, {
        label: formatMessage($01328549e0c14588$var$i18n.refreshQuestion),
        isLoading: isRefreshing,
        onClick: handleQuestionRefresh
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($01328549e0c14588$var$FeedbackButtons, {
        vote: questionVote,
        onVoteUp: onVoteUp,
        onVoteDown: onVoteDown,
        upLabel: formatMessage($01328549e0c14588$var$i18n.thumbsUpQuestion),
        downLabel: formatMessage($01328549e0c14588$var$i18n.thumbsDownQuestion)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $01328549e0c14588$var$styles.chevron
        ])
    }, isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
        label: formatMessage($01328549e0c14588$var$i18n.collapseQuestion, {
            question: questionText
        }),
        color: "var(--ds-icon-subtle, #505258)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
        label: formatMessage($01328549e0c14588$var$i18n.expandQuestion, {
            question: questionText
        }),
        color: "var(--ds-icon-subtle, #505258)"
    })));
};
const $01328549e0c14588$var$QuestionItemInner = ({ question: question, questionPosition: questionPosition, spaceKey: spaceKey, isExpanded: isExpanded, onToggle: onToggle, onFollowUp: onFollowUp, onAskRovo: onAskRovo })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $22hCZ.useFlags)();
    const [questionVote, setQuestionVote] = (0, $42omo.useState)(null);
    const [answerVote, setAnswerVote] = (0, $42omo.useState)(null);
    const [startQuestionRefresh, isQuestionRefreshing] = (0, $75b7ce46cf4dcbf4$export$95779ae96ff09d4a)();
    const [startAnswerRefresh, isAnswerRefreshing] = (0, $75b7ce46cf4dcbf4$export$95779ae96ff09d4a)();
    const expandedContentRef = (0, $42omo.useRef)(null);
    const answerTextRef = (0, $42omo.useRef)(null);
    const { markManualCollapse: markManualCollapse } = (0, $20b6fea54848571f$export$d5c16baac6dcf544)({
        isExpanded: isExpanded,
        expandedContentRef: answerTextRef,
        spaceKey: spaceKey,
        questionPosition: questionPosition
    });
    const showFeedbackFlag = (0, $42omo.useCallback)(()=>{
        showFlag({
            title: formatMessage($01328549e0c14588$var$i18n.feedbackFlagTitle),
            description: formatMessage($01328549e0c14588$var$i18n.feedbackFlagDescription),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
                color: "var(--ds-icon-success, #6A9A23)",
                label: "success"
            }),
            isAutoDismiss: true
        });
    }, [
        showFlag,
        formatMessage
    ]);
    const handleToggle = (0, $42omo.useCallback)(()=>{
        const dwellMetrics = markManualCollapse();
        onToggle(question.question);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: isExpanded ? 'questionCollapse' : 'questionExpand',
                source: 'smartSpaceOverview',
                attributes: {
                    moduleType: 'faq',
                    spaceKey: spaceKey,
                    questionPosition: questionPosition,
                    ...dwellMetrics ?? {}
                }
            }
        }).fire();
    }, [
        onToggle,
        question.question,
        isExpanded,
        createAnalyticsEvent,
        questionPosition,
        spaceKey,
        markManualCollapse
    ]);
    const handleFollowUp = (0, $42omo.useCallback)((followUpQuestion, followUpPosition)=>{
        onFollowUp?.(followUpQuestion, question);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'followUpQuestion',
                source: 'smartSpaceOverview',
                attributes: {
                    moduleType: 'faq',
                    spaceKey: spaceKey,
                    questionPosition: questionPosition,
                    followUpPosition: followUpPosition
                }
            }
        }).fire();
    }, [
        onFollowUp,
        question,
        createAnalyticsEvent,
        questionPosition,
        spaceKey
    ]);
    const handleAskRovo = (0, $42omo.useCallback)((message)=>{
        onAskRovo?.(message, question);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'askRovoSubmit',
                source: 'smartSpaceOverview',
                attributes: {
                    moduleType: 'faq',
                    spaceKey: spaceKey,
                    questionPosition: questionPosition,
                    queryLength: message.length
                }
            }
        }).fire();
    }, [
        onAskRovo,
        question,
        createAnalyticsEvent,
        questionPosition,
        spaceKey
    ]);
    const fireFeedbackEvent = (0, $42omo.useCallback)((actionSubjectId, wasHelpful)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'submitted',
                actionSubject: 'feedback',
                actionSubjectId: actionSubjectId,
                source: 'smartSpaceOverview',
                attributes: {
                    moduleType: 'faq',
                    spaceKey: spaceKey,
                    questionPosition: questionPosition,
                    wasHelpful: wasHelpful
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        questionPosition,
        spaceKey
    ]);
    const handleQuestionThumbsUp = (0, $42omo.useCallback)(()=>{
        setQuestionVote('up');
        showFeedbackFlag();
        fireFeedbackEvent('question', true);
    }, [
        showFeedbackFlag,
        fireFeedbackEvent
    ]);
    const handleQuestionThumbsDown = (0, $42omo.useCallback)(()=>{
        setQuestionVote('down');
        showFeedbackFlag();
        fireFeedbackEvent('question', false);
    }, [
        showFeedbackFlag,
        fireFeedbackEvent
    ]);
    const handleAnswerThumbsUp = (0, $42omo.useCallback)(()=>{
        setAnswerVote('up');
        showFeedbackFlag();
        fireFeedbackEvent('answer', true);
    }, [
        showFeedbackFlag,
        fireFeedbackEvent
    ]);
    const handleAnswerThumbsDown = (0, $42omo.useCallback)(()=>{
        setAnswerVote('down');
        showFeedbackFlag();
        fireFeedbackEvent('answer', false);
    }, [
        showFeedbackFlag,
        fireFeedbackEvent
    ]);
    const handleQuestionRefresh = (e)=>{
        e.stopPropagation();
        setQuestionVote(null);
        setAnswerVote(null);
        startQuestionRefresh();
    };
    const handleAnswerRefresh = (_e)=>{
        setAnswerVote(null);
        startAnswerRefresh();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $01328549e0c14588$var$styles.cardWrapper,
            isQuestionRefreshing && $01328549e0c14588$var$styles.contentBlurred
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($01328549e0c14588$var$QuestionHeader, {
        questionText: question.question,
        isExpanded: isExpanded,
        onToggle: handleToggle,
        isRefreshing: isQuestionRefreshing,
        onRefresh: handleQuestionRefresh,
        questionVote: questionVote,
        onVoteUp: handleQuestionThumbsUp,
        onVoteDown: handleQuestionThumbsDown
    }), isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: expandedContentRef,
        className: (0, $gMc0m.default)([
            $01328549e0c14588$var$styles.expandedContent,
            isAnswerRefreshing && $01328549e0c14588$var$styles.contentBlurred
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.Stack), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $01328549e0c14588$var$styles.sectionLabel
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.Text), {
        size: "small",
        weight: "medium",
        color: "color.text.subtle"
    }, formatMessage($01328549e0c14588$var$i18n.answerLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $01328549e0c14588$var$styles.answerActions
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $01328549e0c14588$var$styles.answerFeedbackButtons,
            !(0, $9wGTI.fg)('smart-space-overview-faq-always-show-feedback') && $01328549e0c14588$var$styles.hideAnswerActions
        ])
    }, (0, $9wGTI.fg)('smart-space-overview-individual-faq-regeneration') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($01328549e0c14588$var$RefreshButton, {
        label: formatMessage($01328549e0c14588$var$i18n.refreshAnswer),
        isLoading: isAnswerRefreshing,
        onClick: handleAnswerRefresh
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($01328549e0c14588$var$FeedbackButtons, {
        vote: answerVote,
        onVoteUp: handleAnswerThumbsUp,
        onVoteDown: handleAnswerThumbsDown,
        upLabel: formatMessage($01328549e0c14588$var$i18n.thumbsUpAnswer),
        downLabel: formatMessage($01328549e0c14588$var$i18n.thumbsDownAnswer)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1f92641a13bcc754$export$99bd007203d2166e), {
        sources: question.sources,
        spaceKey: spaceKey,
        questionPosition: questionPosition
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: answerTextRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.Text), {
        size: "medium",
        color: "color.text.subtle"
    }, question.answer))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b8b7b04208de7a0b$export$9d9f2e3275d0d624), {
        questions: question.followUpQuestions,
        onFollowUp: handleFollowUp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bb5f5999bd84aada$export$995e9427a9b39595), {
        onSend: handleAskRovo
    }))));
};
const $01328549e0c14588$export$2f31fc0a7a44451 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6gQN0.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($01328549e0c14588$var$QuestionItemInner, props));
const $01328549e0c14588$var$i18n = (0, $aXWIB.defineMessages)({
    expandQuestion: {
        id: "space-overview.smart-space-overview.popular-questions.expand",
        defaultMessage: "Expand question: {question}"
    },
    collapseQuestion: {
        id: "space-overview.smart-space-overview.popular-questions.collapse",
        defaultMessage: "Collapse question: {question}"
    },
    answerLabel: {
        id: "space-overview.smart-space-overview.popular-questions.answer-label",
        defaultMessage: "Answer"
    },
    thumbsUpQuestion: {
        id: "space-overview.smart-space-overview.popular-questions.thumbs-up",
        defaultMessage: "Good question"
    },
    thumbsDownQuestion: {
        id: "space-overview.smart-space-overview.popular-questions.thumbs-down",
        defaultMessage: "Bad question"
    },
    thumbsUpAnswer: {
        id: "space-overview.smart-space-overview.popular-questions.thumbs-up-answer",
        defaultMessage: "Good answer"
    },
    thumbsDownAnswer: {
        id: "space-overview.smart-space-overview.popular-questions.thumbs-down-answer",
        defaultMessage: "Bad answer"
    },
    refreshQuestion: {
        id: "space-overview.smart-space-overview.popular-questions.refresh-question",
        defaultMessage: "Refresh question"
    },
    refreshAnswer: {
        id: "space-overview.smart-space-overview.popular-questions.refresh-answer",
        defaultMessage: "Refresh answer"
    },
    feedbackFlagTitle: {
        id: "space-overview.smart-space-overview.popular-questions.feedback-flag-title",
        defaultMessage: "Thanks!"
    },
    feedbackFlagDescription: {
        id: "space-overview.smart-space-overview.popular-questions.feedback-flag-description",
        defaultMessage: "We appreciate you taking the time to send this feedback."
    }
});
const $01328549e0c14588$var$styles = {
    cardWrapper: "_2rkopb1k _1reo15vq _18m915vq _bfhkhfxm",
    questionRow: "_11c8fhey _189eidpf _kqswh2mm _1e0c11p5 _yv0e1bke _1lmc1ye3 _4cvr1h6o _gy1pv77o _80omtlke _bfhkhfxm _1bsb1osq _syazi7uo _y3gnv2br _gsm2idpf _irr31dpa _rmwnkb7n",
    questionRowExpanded: "_2rkoidpf",
    questionRowCollapsed: "_2rkopb1k",
    questionTrigger: "_1r04ze3t _kqswstnw _bfhk1j28",
    questionIcon: "_nd5l2ec4 _kqswh2mm _1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf _bozgv47k _lcxvglyw",
    questionText: "_nd5l1kdv _18zru2gc _1rjcpxbi _kqswh2mm _1ul9idpf _lcxvglyw",
    questionFeedbackButtons: "_nd5l1v4b _kqswh2mm _1e0c1txw _4cvr1h6o _1n261q9c _1o9zidpf",
    chevron: "_nd5ludx4 _kqswh2mm _1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf _y4tiv47k _lcxvglyw",
    expandedContent: "_1rjcpxbi _18zrv47k _bfhkhfxm _uwhke4h9 _15a5nqa1 _1i531l7x _1u0nidpf _t79pkb7n",
    sectionLabel: "_85i51b66 _1e0c1txw _4cvr1h6o _1bah1yb4",
    answerActions: "_1e0c1txw _4cvr1h6o _1bahesu3 _1n261q9c _gy1p1b66 _1o9zidpf",
    answerFeedbackButtons: "_1e0c1txw _4cvr1h6o _1n261q9c _1o9zidpf",
    hideQuestionActions: "_v5641bup _tzy41vth",
    hideAnswerActions: "_v5641bup _tzy4g3vr",
    contentBlurred: "_v5641bup _tzy42wxo _lcxvglyw"
};








const $747111b28549b837$var$THRESHOLDS = [
    0,
    0.5,
    1.0
];
const $747111b28549b837$var$getThresholdLabel = (ratio)=>{
    if (ratio >= 1.0) return 'full';
    if (ratio >= 0.5) return 'half';
    return 'partial';
};
const $747111b28549b837$export$7fe9c12e9689f54b = ({ spaceKey: spaceKey, questionCount: questionCount })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const sectionRef = (0, $42omo.useRef)(null);
    const firedThresholdsRef = (0, $42omo.useRef)(new Set());
    // questionCount may change when refetching data, but we only need the latest value
    // when the intersection fires — not as a trigger to re-observe.
    const questionCountRef = (0, $42omo.useRef)(questionCount);
    questionCountRef.current = questionCount;
    (0, $42omo.useEffect)(()=>{
        const node = sectionRef.current;
        if (!node) return;
        const observer = new IntersectionObserver(([entry])=>{
            if (!entry.isIntersecting) return;
            const label = $747111b28549b837$var$getThresholdLabel(entry.intersectionRatio);
            const thresholdLabels = [
                'partial',
                'half',
                'full'
            ];
            const currentIndex = thresholdLabels.indexOf(label);
            for(let i = 0; i <= currentIndex; i++){
                const threshold = thresholdLabels[i];
                if (!firedThresholdsRef.current.has(threshold)) {
                    firedThresholdsRef.current.add(threshold);
                    createAnalyticsEvent({
                        type: 'sendUIEvent',
                        data: {
                            action: 'viewed',
                            actionSubject: 'module',
                            actionSubjectId: 'faq',
                            source: 'smartSpaceOverview',
                            attributes: {
                                moduleType: 'faq',
                                spaceKey: spaceKey,
                                questionCount: questionCountRef.current,
                                threshold: threshold
                            }
                        }
                    }).fire();
                }
            }
            if (firedThresholdsRef.current.size === thresholdLabels.length) observer.disconnect();
        }, {
            threshold: [
                ...$747111b28549b837$var$THRESHOLDS
            ]
        });
        observer.observe(node);
        return ()=>{
            observer.disconnect();
        };
    }, [
        spaceKey,
        createAnalyticsEvent
    ]);
    return {
        sectionRef: sectionRef
    };
};


const $b940e14642ad4976$export$5f1dbecc17d9b4ee = ({ faqData: faqData, spaceKey: spaceKey })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [expandedId, setExpandedId] = (0, $42omo.useState)(null);
    const [startRefreshAll, isRefreshingAll] = (0, $75b7ce46cf4dcbf4$export$95779ae96ff09d4a)();
    const publish = (0, $i25hX.usePublish)('ai-mate');
    const questionCount = faqData?.entries?.length ?? 0;
    const { sectionRef: sectionRef } = (0, $747111b28549b837$export$7fe9c12e9689f54b)({
        spaceKey: spaceKey,
        questionCount: questionCount
    });
    const handleToggle = (0, $42omo.useCallback)((id)=>{
        setExpandedId((prev)=>prev === id ? null : id);
    }, []);
    const formatSourcesContext = (0, $42omo.useCallback)((sources)=>{
        if (sources.length === 0) return '';
        const sourceLines = sources.map((source)=>`- [${source?.content?.title}](${window.location.origin}${0, $jlIaF.CONTEXT_PATH}${source?.content?.links?.webui})`);
        return `\n\n${formatMessage($b940e14642ad4976$var$i18n.sourcesLabel)}\n${sourceLines.join('\n')}`;
    }, [
        formatMessage
    ]);
    const createSpaceContext = (0, $42omo.useCallback)((parentQuestion)=>{
        const spaceOverviewUrl = `${window.location.origin}${(0, $1NBp8.SPACE_OVERVIEW).toUrl({
            spaceKey: spaceKey
        })}`;
        const humanMessageContent = formatMessage($b940e14642ad4976$var$i18n.humanMessagePrompt, {
            link: spaceOverviewUrl,
            question: parentQuestion.question
        });
        const agentMessageContent = `${parentQuestion.answer}${formatSourcesContext(parentQuestion.sources)}`;
        return {
            human_message: {
                content: humanMessageContent
            },
            agent_message: {
                content: agentMessageContent
            }
        };
    }, [
        spaceKey,
        formatSourcesContext,
        formatMessage
    ]);
    const publishRovoChat = (0, $42omo.useCallback)((questionText, parentQuestion)=>{
        const context = createSpaceContext(parentQuestion);
        publish({
            type: 'chat-new',
            source: 'space-overview-popular-questions',
            data: {
                name: questionText.substring(0, 30),
                dialogues: [
                    context
                ],
                prompt: questionText
            }
        });
    }, [
        publish,
        createSpaceContext
    ]);
    const handleFollowUp = (0, $42omo.useCallback)((followUpQuestion, parentQuestion)=>publishRovoChat(followUpQuestion, parentQuestion), [
        publishRovoChat
    ]);
    const handleAskRovo = (0, $42omo.useCallback)((customQuestion, parentQuestion)=>publishRovoChat(customQuestion, parentQuestion), [
        publishRovoChat
    ]);
    const handleRefreshAll = (0, $42omo.useCallback)(()=>{
        // TODO: Implement refresh all questions
        setExpandedId(null);
        startRefreshAll();
    }, [
        startRefreshAll
    ]);
    if ((faqData?.entries?.length ?? 0) > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("section", {
        ref: sectionRef,
        "aria-label": formatMessage($b940e14642ad4976$var$i18n.heading)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.Stack), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $b940e14642ad4976$var$styles.headingRow
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "small",
        as: "h2"
    }, formatMessage($b940e14642ad4976$var$i18n.heading)), (0, $9wGTI.fg)('smart-space-overview-refresh') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $b940e14642ad4976$var$styles.refreshAllButton,
            isRefreshingAll && $b940e14642ad4976$var$styles.refreshAllButtonVisible
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d8ohW))),
        label: formatMessage($b940e14642ad4976$var$i18n.refreshAll),
        appearance: "subtle",
        spacing: "compact",
        isLoading: isRefreshingAll,
        onClick: handleRefreshAll,
        isTooltipDisabled: false
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            isRefreshingAll && $b940e14642ad4976$var$styles.contentBlurred
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.Stack), {
        space: "space.150"
    }, faqData?.entries?.map((question, index)=>{
        const questionKey = question.question;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $01328549e0c14588$export$2f31fc0a7a44451), {
            key: questionKey,
            question: question,
            isExpanded: expandedId === questionKey,
            onToggle: handleToggle,
            onFollowUp: handleFollowUp,
            onAskRovo: handleAskRovo,
            spaceKey: spaceKey,
            questionPosition: index
        });
    })))));
    return null;
};
const $b940e14642ad4976$var$i18n = (0, $aXWIB.defineMessages)({
    heading: {
        id: "space-overview.smart-space-overview.popular-questions.heading",
        defaultMessage: "Popular questions"
    },
    humanMessagePrompt: {
        id: "space-overview.smart-space-overview.popular-questions.human-message-prompt",
        defaultMessage: "Question about space {link}: {question}"
    },
    sourcesLabel: {
        id: "space-overview.smart-space-overview.popular-questions.sources-label",
        defaultMessage: "Sources:"
    },
    refreshAll: {
        id: "space-overview.smart-space-overview.popular-questions.refresh-all",
        defaultMessage: "Refresh all questions"
    }
});
const $b940e14642ad4976$var$styles = {
    headingRow: "_1e0c1txw _4cvr1h6o _1bah1yb4 _19ejidpf _5ekskb7n",
    refreshAllButton: "_v5641bup _tzy4nkvk",
    refreshAllButtonVisible: "_tzy4kb7n",
    contentBlurred: "_v5641bup _tzy42wxo _lcxvglyw"
};


/* SmartSpaceOverviewHeader.tsx generated by @compiled/babel-plugin v2.0.0 */ 









var $hrGQb = parcelRequire("hrGQb");


var $7yOcR = parcelRequire("7yOcR");








var $ccHMk = parcelRequire("ccHMk");








var $2mqmH = parcelRequire("2mqmH");


var $jNtYE = parcelRequire("jNtYE");


var $6mKj3 = parcelRequire("6mKj3");





var $17wUi = parcelRequire("17wUi");

const $e1b54ae933da37d5$var$i18n = (0, $aXWIB.defineMessages)({
    feedbackButtonLabel: {
        id: "space-overview.smart-space-overview.feedback-button-label",
        defaultMessage: "Give feedback"
    },
    feedbackTitle: {
        id: "space-overview.smart-space-overview.feedback-title",
        defaultMessage: "What do you think of the new Spaces overview?"
    },
    feedbackPreamble: {
        id: "space-overview.smart-space-overview.feedback-preamble",
        defaultMessage: "Help make it even better with your feedback."
    },
    organizedByRovo: {
        id: "space-overview.smart-space-overview.organized-by-rovo",
        defaultMessage: "Organized by Rovo"
    },
    popupDismissLabel: {
        id: "space-overview.smart-space-overview.popup-dismiss-label",
        defaultMessage: "Dismiss"
    },
    popupDescription: {
        id: "space-overview.smart-space-overview.popup-description",
        defaultMessage: "This is where your team's work comes together."
    },
    popupBullet1: {
        id: "space-overview.smart-space-overview.popup-bullet-1",
        defaultMessage: "See the summary of the space"
    },
    popupBullet2: {
        id: "space-overview.smart-space-overview.popup-bullet-2",
        defaultMessage: "Pin key documents"
    },
    popupBullet3: {
        id: "space-overview.smart-space-overview.popup-bullet-3",
        defaultMessage: "Get answers to your team's most important questions"
    }
});
const $e1b54ae933da37d5$var$FEEDBACK_OPENED_STORAGE_KEY = 'smart-space-overview-feedback-opened';
const $e1b54ae933da37d5$var$FEEDBACK_CONTEXT_FIELD_ID = 'customfield_10047';
const $e1b54ae933da37d5$var$FEEDBACK_ENTRYPOINT_ID = '6b7a459d-eab0-4b18-b825-481b90b7a262';
const $e1b54ae933da37d5$var$FEEDBACK_SOURCE = 'smartSpaceOverviewHeader';
const $e1b54ae933da37d5$var$hasFeedbackCollectorBeenOpened = ()=>{
    try {
        return (0, $17wUi.confluenceLocalStorageInstance).getItem($e1b54ae933da37d5$var$FEEDBACK_OPENED_STORAGE_KEY) === 'true';
    } catch  {
        return false;
    }
};
const $e1b54ae933da37d5$var$persistFeedbackCollectorOpened = ()=>{
    try {
        (0, $17wUi.confluenceLocalStorageInstance).setItem($e1b54ae933da37d5$var$FEEDBACK_OPENED_STORAGE_KEY, 'true');
    } catch  {}
};
const $e1b54ae933da37d5$export$2359131f9fa9ca50 = ()=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $aXWIB.useIntl)();
    const { displayName: displayName, userId: userId } = (0, $bQm3c.useSessionData)();
    const autoOpenTimeoutRef = (0, $42omo.useRef)(null);
    const [isFeedbackCollectorOpen, setIsFeedbackCollectorOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(false);
    const [isHovered, setIsHovered] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(false);
    const [isPopupOpen, setIsPopupOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(false);
    const togglePopup = (0, $42omo.useCallback)(()=>{
        setIsPopupOpen((prev)=>!prev);
    }, []);
    const closePopup = (0, $42omo.useCallback)(()=>{
        setIsPopupOpen(false);
    }, []);
    const openFeedbackCollector = (0, $42omo.useCallback)(()=>{
        $e1b54ae933da37d5$var$persistFeedbackCollectorOpened();
        if (autoOpenTimeoutRef.current !== null) {
            window.clearTimeout(autoOpenTimeoutRef.current);
            autoOpenTimeoutRef.current = null;
        }
        setIsFeedbackCollectorOpen(true);
    }, []);
    const closeFeedbackCollector = (0, $42omo.useCallback)(()=>{
        setIsFeedbackCollectorOpen(false);
    }, []);
    (0, $42omo.useEffect)(()=>{
        if ((0, $6mKj3.expVal)('confluence_space_overview_feedback_auto_open_delay', 'value', 0) <= 0) return;
        autoOpenTimeoutRef.current = window.setTimeout(()=>{
            autoOpenTimeoutRef.current = null;
            if (!$e1b54ae933da37d5$var$hasFeedbackCollectorBeenOpened()) openFeedbackCollector();
        }, (0, $6mKj3.expVal)('confluence_space_overview_feedback_auto_open_delay', 'value', 0));
        return ()=>{
            if (autoOpenTimeoutRef.current !== null) {
                window.clearTimeout(autoOpenTimeoutRef.current);
                autoOpenTimeoutRef.current = null;
            }
        };
    }, [
        openFeedbackCollector
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $e1b54ae933da37d5$var$styles.overviewHeaderActions
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2mqmH.Popup), {
        isOpen: isPopupOpen,
        onClose: closePopup,
        placement: "bottom-start",
        offset: [
            0,
            -32
        ],
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("button", {
                ...triggerProps,
                type: "button",
                onClick: togglePopup,
                onMouseEnter: ()=>setIsHovered(true),
                onMouseLeave: ()=>setIsHovered(false),
                onFocus: ()=>setIsHovered(true),
                onBlur: ()=>setIsHovered(false),
                className: (0, $gMc0m.default)([
                    $e1b54ae933da37d5$var$styles.organizedByRovo
                ])
            }, isHovered ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jNtYE.LazyAnimatedRovoIcon), {
                width: "20",
                height: "20"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.RovoIcon), {
                size: "xsmall",
                appearance: "brand",
                shouldUseNewLogoDesign: true
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                "aria-hidden": "true",
                className: (0, $gMc0m.default)([
                    $e1b54ae933da37d5$var$styles.preload
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jNtYE.LazyAnimatedRovoIcon), {
                width: "20",
                height: "20"
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $e1b54ae933da37d5$var$i18n.organizedByRovo)),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                className: (0, $gMc0m.default)([
                    $e1b54ae933da37d5$var$styles.popupContent
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                className: (0, $gMc0m.default)([
                    $e1b54ae933da37d5$var$styles.popupHeader
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                className: (0, $gMc0m.default)([
                    $e1b54ae933da37d5$var$styles.popupHeaderLeft
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.RovoIcon), {
                size: "xsmall",
                appearance: "brand",
                shouldUseNewLogoDesign: true
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $e1b54ae933da37d5$var$i18n.organizedByRovo)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                appearance: "subtle",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
                label: formatMessage($e1b54ae933da37d5$var$i18n.popupDismissLabel),
                onClick: closePopup
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                className: (0, $gMc0m.default)([
                    $e1b54ae933da37d5$var$styles.popupBody
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.Text), {
                size: "small",
                color: "color.text.subtle"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $e1b54ae933da37d5$var$i18n.popupDescription))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ul", {
                className: (0, $gMc0m.default)([
                    $e1b54ae933da37d5$var$styles.popupList
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $e1b54ae933da37d5$var$i18n.popupBullet1)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $e1b54ae933da37d5$var$i18n.popupBullet2)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $e1b54ae933da37d5$var$i18n.popupBullet3))))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        onClick: openFeedbackCollector,
        testId: "smart-space-overview-feedback-button",
        iconBefore: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7yOcR))), {
                ...iconProps,
                spacing: "spacious",
                label: ""
            }),
        className: (0, $gMc0m.default)([
            $e1b54ae933da37d5$var$styles.feedbackButton
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $e1b54ae933da37d5$var$i18n.feedbackButtonLabel))), isFeedbackCollectorOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hrGQb.default), {
        locale: locale,
        onClose: closeFeedbackCollector,
        onSubmit: closeFeedbackCollector,
        atlassianAccountId: userId || '',
        name: displayName || '',
        entrypointId: $e1b54ae933da37d5$var$FEEDBACK_ENTRYPOINT_ID,
        feedbackTitle: formatMessage($e1b54ae933da37d5$var$i18n.feedbackTitle),
        feedbackTitleDetails: formatMessage($e1b54ae933da37d5$var$i18n.feedbackPreamble),
        additionalFields: [
            {
                id: $e1b54ae933da37d5$var$FEEDBACK_CONTEXT_FIELD_ID,
                value: $e1b54ae933da37d5$var$FEEDBACK_SOURCE
            }
        ]
    }));
};
const $e1b54ae933da37d5$var$styles = {
    overviewHeaderActions: "_zulpv47k _1rjc1b66 _1e0c1txw _4cvr1h6o _1bah1yb4 _1tkeoahv",
    organizedByRovo: "_zulp1b66 _11c8fhey _11q7glyw _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c116y _4cvr1h6o _syaz1rpy _80omtlke _9oik1r31 _1bnx8stv _jf4cnqa1",
    preload: "_1reo15vq _18m915vq _kqswstnw _1bsbt94y _4t3it94y _tzy4idpf _lcxvglyw",
    feedbackButton: "_2rko1qi0 _189ee4h9 _1dqonqa1 _1h6d1l7x _1rjc1b66 _18zru2gc _1e0c116y _4cvr1h6o _1bah1h6o _bfhkvuon _syazi7uo _80omtlke",
    popupContent: "_1yt4pxbi _p12fnklw",
    popupHeader: "_1e0c1txw _4cvr1h6o _1bah1yb4 _6rthu2gc",
    popupHeaderLeft: "_zulp1b66 _11c8wadc _1e0c116y _4cvr1h6o _k48p1wq8 _syazi7uo",
    popupBody: "_6rth1b66",
    popupList: "_11c8wadc _19pkidpf _2hwxidpf _otyridpf _18u0idpf _syazazsu _bozgv47k"
};


/* SmartSpaceOverviewLogo.tsx generated by @compiled/babel-plugin v2.0.0 */ 





















var $di8q4 = parcelRequire("di8q4");


var $Qlykt = parcelRequire("Qlykt");


var $eWwvy = parcelRequire("eWwvy");

const $c0f874fe2d27e0c7$var$i18n = (0, $aXWIB.defineMessages)({
    editSpaceLogoTooltip: {
        id: "space-overview.smart-space-overview.logo.edit-space-logo-tooltip",
        defaultMessage: "Edit space logo"
    }
});
const $c0f874fe2d27e0c7$export$36f67a5ef9dc0044 = ({ spaceKey: spaceKey, spaceId: spaceId, isAdmin: isAdmin, isPersonalSpace: isPersonalSpace, emoji: emoji, spaceIconPath: spaceIconPath })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const [shouldRenderEditSpaceLogoDialog, setShouldRenderEditSpaceLogoDialog] = (0, $42omo.useState)(false);
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false);
    const onOpen = (0, $42omo.useCallback)(()=>setIsOpen(true), []);
    const onClose = (0, $42omo.useCallback)(()=>setIsOpen(false), []);
    const handleIconClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'editSpaceDetails',
                source: 'smartSpaceOverview',
                containerType: 'space',
                containerId: spaceId,
                attributes: {
                    entryPoint: 'smartSpaceOverview',
                    spaceKey: spaceKey
                }
            }
        }).fire();
        setShouldRenderEditSpaceLogoDialog(true);
        onOpen();
    }, [
        createAnalyticsEvent,
        onOpen,
        spaceId,
        spaceKey
    ]);
    const renderEditSpaceLogoDialog = (0, $42omo.useCallback)(()=>{
        setShouldRenderEditSpaceLogoDialog(true);
    }, []);
    const hasEmoji = Boolean(emoji);
    const hasIcon = hasEmoji || Boolean(spaceIconPath);
    if (!hasIcon) return null;
    const iconContent = hasEmoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
        emoji: emoji,
        context: "spaceHeader",
        height: (0, $Qlykt.EMOJI_SIZE_LARGE),
        renderResourcedEmoji: true,
        isPageTitleComponent: true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        width: (0, $Qlykt.EMOJI_SIZE_LARGE),
        height: (0, $Qlykt.EMOJI_SIZE_LARGE),
        src: `${(0, $jlIaF.CONTEXT_PATH)}${spaceIconPath}`,
        alt: "",
        "data-testid": "smart-space-overview-logo-icon",
        className: (0, $gMc0m.default)([
            $c0f874fe2d27e0c7$var$styles.spaceIcon
        ])
    });
    if (!isAdmin || isPersonalSpace) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-testid": "smart-space-overview-logo",
        className: (0, $gMc0m.default)([
            $c0f874fe2d27e0c7$var$styles.logoRoot
        ])
    }, iconContent);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-testid": "smart-space-overview-logo",
        className: (0, $gMc0m.default)([
            $c0f874fe2d27e0c7$var$styles.logoRoot
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: intl.formatMessage($c0f874fe2d27e0c7$var$i18n.editSpaceLogoTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("button", {
        onClick: handleIconClick,
        onMouseEnter: ()=>{
            setIsHovered(true);
            renderEditSpaceLogoDialog();
        },
        onMouseLeave: ()=>setIsHovered(false),
        onFocus: ()=>{
            setIsHovered(true);
            renderEditSpaceLogoDialog();
        },
        onBlur: ()=>setIsHovered(false),
        "aria-label": intl.formatMessage($c0f874fe2d27e0c7$var$i18n.editSpaceLogoTooltip),
        "data-testid": "smart-space-overview-logo-edit-button",
        type: "button",
        className: (0, $gMc0m.default)([
            $c0f874fe2d27e0c7$var$styles.spaceIconContainer
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        className: (0, $gMc0m.default)([
            $c0f874fe2d27e0c7$var$styles.iconWrapper
        ])
    }, iconContent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $c0f874fe2d27e0c7$var$styles.editIconOverlay,
            isHovered && $c0f874fe2d27e0c7$var$styles.editIconOverlayVisible
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
        label: "",
        color: "var(--ds-icon-inverse, #FFFFFF)"
    }))))), shouldRenderEditSpaceLogoDialog && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eWwvy.EditSpaceLogo), {
        spaceKey: spaceKey,
        isOpen: isOpen,
        onOpen: onOpen,
        onClose: onClose,
        showSpaceNameField: false,
        entryPoint: "smartSpaceOverview"
    }));
};
const $c0f874fe2d27e0c7$var$styles = {
    spaceIcon: "_2rko1crf _1e0c1ule",
    editIconOverlay: "_v5641hrg _2rko1crf _kqswstnw _4t3i1osq _1bsb1osq _154ize3t _1ltvze3t _tzy4idpf _bfhk1i5c _1e0c1txw _4cvr1h6o _1bah1h6o",
    editIconOverlayVisible: "_tzy4kb7n",
    spaceIconContainer: "_1yt4ze3t _19itglyw _11q7glyw _80omtlke _1e0c116y _4cvr1h6o _1bah1h6o",
    iconWrapper: "_kqswh2mm _1e0c116y",
    logoRoot: "_19it1ebf _2rkof6fq _1e0c116y"
};


/**
 * @generated SignedSource<<88310f22e31f024870884e0ad937b0f4>>
 * @relayHash 028bc8cd44ccfe555825b862cac7175f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2ce20ec099abc7671f8f67b49755cda9c9a35f69466c5cc3cf77aada23721aa9
const $096db6ea15398f90$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "ConfluenceUpdateSmartSpaceOverviewPayload",
            "kind": "LinkedField",
            "name": "confluence_refreshSmartSpaceOverview",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceSmartSpaceOverview",
                    "kind": "LinkedField",
                    "name": "overview",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceSmartSpaceOverviewTopLinks",
                            "kind": "LinkedField",
                            "name": "topLinks",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "contentId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "lastRefreshed"
                                },
                                {
                                    "concreteType": "ConfluenceSmartSpaceOverviewTopLink",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isPinned"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "title"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "url"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "TopLinksCardRefreshTopLinksMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "TopLinksCardRefreshTopLinksMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "028bc8cd44ccfe555825b862cac7175f",
            "id": "2ce20ec099abc7671f8f67b49755cda9c9a35f69466c5cc3cf77aada23721aa9",
            "metadata": {},
            "name": "TopLinksCardRefreshTopLinksMutation",
            "operationKind": "mutation",
            "text": "mutation TopLinksCardRefreshTopLinksMutation($cloudId:ID!,$input:ConfluenceRefreshSmartSpaceOverviewInput!){confluence_refreshSmartSpaceOverview(cloudId:$cloudId,input:$input){success,errors{message},overview{topLinks{contentId,lastRefreshed,links{isPinned,title,url}}}}}"
        }
    };
}();
$096db6ea15398f90$var$node.hash = "8e825f319472bd53e49e1decd81de040";
var $096db6ea15398f90$export$2e2bcd8739ae039 = $096db6ea15398f90$var$node;


/**
 * @generated SignedSource<<2e70fc9c92e85942fa2ba0b08bee4eef>>
 * @relayHash c2729e34ecfb9542d89cbc2054efd8fb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 92a99b2c1c8dd2c8f53891a1479eba53324c36973488f79bda3ef7677b9d3850
const $71c53debaf0f9345$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "ConfluenceUpdateSmartSpaceOverviewPayload",
            "kind": "LinkedField",
            "name": "confluence_updateSmartSpaceOverview",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceSmartSpaceOverview",
                    "kind": "LinkedField",
                    "name": "overview",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceSmartSpaceOverviewTopLinks",
                            "kind": "LinkedField",
                            "name": "topLinks",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "contentId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "lastRefreshed"
                                },
                                {
                                    "concreteType": "ConfluenceSmartSpaceOverviewTopLink",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isPinned"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "title"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "url"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "TopLinksCardUpdateTopLinksMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "TopLinksCardUpdateTopLinksMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "c2729e34ecfb9542d89cbc2054efd8fb",
            "id": "92a99b2c1c8dd2c8f53891a1479eba53324c36973488f79bda3ef7677b9d3850",
            "metadata": {},
            "name": "TopLinksCardUpdateTopLinksMutation",
            "operationKind": "mutation",
            "text": "mutation TopLinksCardUpdateTopLinksMutation($cloudId:ID!,$input:ConfluenceUpdateSmartSpaceOverviewInput!){confluence_updateSmartSpaceOverview(cloudId:$cloudId,input:$input){success,errors{message},overview{topLinks{contentId,lastRefreshed,links{isPinned,title,url}}}}}"
        }
    };
}();
$71c53debaf0f9345$var$node.hash = "7c3c5220e6a36be3e1b0a3a57c4f0e9b";
var $71c53debaf0f9345$export$2e2bcd8739ae039 = $71c53debaf0f9345$var$node;















var $eIleF = parcelRequire("eIleF");





var $btIEy = parcelRequire("btIEy");


var $i6Ps3 = parcelRequire("i6Ps3");







/* Card.tsx generated by @compiled/babel-plugin v2.0.0 */ 












var $g5gZt = parcelRequire("g5gZt");




const $fe608f906a4fdf3e$var$i18n = (0, $aXWIB.defineMessages)({
    add: {
        id: "space-overview.smart-space-overview.card.add",
        defaultMessage: "Add"
    }
});
const $fe608f906a4fdf3e$var$styles = {
    card: "_2rkopb1k _1yt4v47k _bfhkhfxm",
    header: "_1e0c1txw _4cvr1h6o _otyrutpp",
    titleGroup: "_zulp12x7 _16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1h6o",
    itemsRow: "_zulpu2gc _1e0c1txw _2lx2vrvc _1n261g80",
    itemWrapper: "_1ul9idpf _1e0c1txw _2lx21bp4"
};
const $fe608f906a4fdf3e$export$60332b2344f7fe41 = ({ title: title, count: count, maxCount: maxCount, onAdd: onAdd, actionButton: actionButton, children: children, renderItemWrapper: renderItemWrapper })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isAtCapacity = maxCount !== undefined && count !== undefined && count >= maxCount; // Use actionButton if provided, otherwise fall back to onAdd for backward compatibility
    const renderActionButton = ()=>{
        if (actionButton) return actionButton;
        if (onAdd) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))),
            label: formatMessage($fe608f906a4fdf3e$var$i18n.add),
            appearance: "subtle",
            spacing: "compact",
            isDisabled: isAtCapacity,
            onClick: onAdd
        });
        return null;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $fe608f906a4fdf3e$var$styles.card
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $fe608f906a4fdf3e$var$styles.header
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $fe608f906a4fdf3e$var$styles.titleGroup
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        as: "h2",
        size: "small"
    }, formatMessage(title))), renderActionButton()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $fe608f906a4fdf3e$var$styles.itemsRow
        ])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(child)) return child;
        if (renderItemWrapper) return renderItemWrapper(child, index);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            key: child.key ?? index,
            className: (0, $gMc0m.default)([
                $fe608f906a4fdf3e$var$styles.itemWrapper
            ])
        }, child);
    })));
};


function $708b3e73f2b8fa2a$export$c42d680a28a18ad7(links, linkId) {
    const idx = links.findIndex((l)=>l.id === linkId);
    if (idx === -1) return {
        nextLinks: links,
        didReorder: false
    };
    const link = links[idx];
    // When unpinning the last pinned item (nothing pinned after it), toggle in place.
    if (link.isPinned && !links.slice(idx + 1).some((l)=>l.isPinned)) return {
        nextLinks: links.map((l, i)=>i === idx ? {
                ...l,
                isPinned: false
            } : l),
        didReorder: false
    };
    // Both pin and unpin place the link right after the last pinned item.
    const newPinned = !link.isPinned;
    const without = links.filter((_, i)=>i !== idx);
    let insertAt = 0;
    for(let i = without.length - 1; i >= 0; i--)if (without[i].isPinned) {
        insertAt = i + 1;
        break;
    }
    const updatedLink = {
        ...link,
        isPinned: newPinned
    };
    const nextLinks = [
        ...without.slice(0, insertAt),
        updatedLink,
        ...without.slice(insertAt)
    ];
    return {
        nextLinks: nextLinks,
        didReorder: insertAt !== idx
    };
}
function $708b3e73f2b8fa2a$export$9b320488069db95e(links, newLink, maxCount) {
    let insertAt = 0;
    for(let i = links.length - 1; i >= 0; i--)if (links[i].isPinned) {
        insertAt = i + 1;
        break;
    }
    return [
        ...links.slice(0, insertAt),
        newLink,
        ...links.slice(insertAt)
    ].slice(0, maxCount);
}









var $4iPjq = parcelRequire("4iPjq");

















var $8fW0f = parcelRequire("8fW0f");


var $3W9OD = parcelRequire("3W9OD");

const $2d6c8d1397947730$var$i18n = (0, $aXWIB.defineMessages)({
    add: {
        id: "space-overview.smart-space-overview.link-picker.add",
        defaultMessage: "Add link"
    },
    disabledTooltip: {
        id: "space-overview.smart-space-overview.link-picker.disabled-tooltip",
        defaultMessage: "Max of 4 links. Remove one to add another."
    }
});
const $2d6c8d1397947730$var$POPUP_OFFSET = [
    0,
    8
];
const $2d6c8d1397947730$export$b665e181ecd1797 = ({ showPicker: showPicker = false, disabled: disabled = false, onLinkSubmit: onLinkSubmit, existingLinks: existingLinks = [], ...props })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [isPickerOpen, setIsPickerOpen] = (0, $42omo.useState)(showPicker);
    const searchProvider = (0, $3W9OD.useSearchProvider)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const plugins = (0, $42omo.useMemo)(()=>[
            new (0, $8fW0f.default)({
                searchProvider: searchProvider,
                activityClientEndpoint: `${window.location.origin}/gateway/api/graphql`
            })
        ], [
        searchProvider
    ]);
    const handleAddClick = (0, $42omo.useCallback)(()=>{
        if (disabled) return;
        setIsPickerOpen(true);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'openLinkPicker',
                source: 'smartSpaceOverview',
                attributes: {
                    moduleType: 'topDocs'
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        disabled
    ]);
    const handlePickerClose = (0, $42omo.useCallback)(()=>{
        setIsPickerOpen(false);
        props.onCancel?.();
    }, [
        props
    ]);
    const handleSubmit = (0, $42omo.useCallback)((payload)=>{
        const isDuplicate = existingLinks.some((link)=>link.url === payload.url);
        if (isDuplicate) {
            setIsPickerOpen(false);
            return;
        }
        let inputMethod = 'manual';
        if (payload.meta.inputMethod === 'manual') inputMethod = 'manual';
        else if (payload.data?.prefetch === true) inputMethod = 'suggestion';
        else inputMethod = 'search';
        onLinkSubmit?.({
            url: payload.url,
            title: payload.title ?? payload.displayText ?? payload.url,
            inputMethod: inputMethod
        });
        setIsPickerOpen(false);
        props.onSubmit?.(payload);
    }, [
        existingLinks,
        onLinkSubmit,
        props
    ]);
    const renderContent = (0, $42omo.useCallback)(({ update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4iPjq.default), {
            ...props,
            plugins: plugins,
            onCancel: handlePickerClose,
            onSubmit: handleSubmit,
            onContentResize: update
        }), [
        props,
        plugins,
        handlePickerClose,
        handleSubmit
    ]);
    const renderTrigger = (0, $42omo.useCallback)((triggerProps)=>{
        const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            ...triggerProps,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))),
            label: formatMessage($2d6c8d1397947730$var$i18n.add),
            appearance: "subtle",
            spacing: "compact",
            isDisabled: disabled,
            onClick: handleAddClick
        });
        if (disabled && formatMessage($2d6c8d1397947730$var$i18n.disabledTooltip)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: formatMessage($2d6c8d1397947730$var$i18n.disabledTooltip)
        }, button);
        return button;
    }, [
        formatMessage,
        disabled,
        handleAddClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2mqmH.Popup), {
        isOpen: isPickerOpen,
        onClose: handlePickerClose,
        content: renderContent,
        trigger: renderTrigger,
        placement: "bottom-start",
        offset: $2d6c8d1397947730$var$POPUP_OFFSET,
        autoFocus: false
    });
};


/* LinkItem.tsx generated by @compiled/babel-plugin v2.0.0 */ 















var $5TXU5 = parcelRequire("5TXU5");





var $1s5hv = parcelRequire("1s5hv");





var $lE8sM = parcelRequire("lE8sM");


var $2Nwuj = parcelRequire("2Nwuj");


var $90Y9A = parcelRequire("90Y9A");


var $6V1ly = parcelRequire("6V1ly");


var $brxEJ = parcelRequire("brxEJ");





var $bYRk6 = parcelRequire("bYRk6");







const $2a4c4438bdd7c14c$var$i18n = (0, $aXWIB.defineMessages)({
    pin: {
        id: "space-overview.smart-space-overview.link-item.pin",
        defaultMessage: "Pin"
    },
    unpin: {
        id: "space-overview.smart-space-overview.link-item.unpin",
        defaultMessage: "Unpin"
    },
    remove: {
        id: "space-overview.smart-space-overview.link-item.remove",
        defaultMessage: "Remove"
    }
});
/* Compiled css for the SmartCard wrapper — allows child selectors for internal element overrides */ const $2a4c4438bdd7c14c$var$smartCardWrapperStyle = null; /* Variant used when an IconTile is provided — hides SmartCard's own icon element */ 
const $2a4c4438bdd7c14c$var$smartCardWrapperStyleWithTile = null; /* Icon column: Smart Card’s layered link only covers the Card; DS Link opens the URL in a new tab */ 
const $2a4c4438bdd7c14c$var$iconColumnWrapperStyles = null;
const $2a4c4438bdd7c14c$var$hoverCardContainerStyles = null;
const $2a4c4438bdd7c14c$var$hoverCardTriggerStyles = null;
const $2a4c4438bdd7c14c$var$itemStyles = {
    outerWrapper: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4",
    row: "_2rko1mok _16jlkb7n _1o9zkb7n _i0dlf1ug _1rjc12x7 _18zru2gc _80omtlke _10j71dpa _irr31dpa",
    actions: "_zulpv77o _v564cklq _1o9zidpf _1e0cglyw _4cvr1h6o _tzy4idpf",
    actionsVisible: "_zulpv77o _v564cklq _1o9zidpf _1e0c1txw _4cvr1h6o _tzy4kb7n"
};
const $2a4c4438bdd7c14c$var$cardUiProps = {
    hideBackground: true,
    hideElevation: true,
    hidePadding: true,
    /* TitleBlock anchorTarget is applied to the full-area LayeredLink <a> when this is true */ clickableContainer: true,
    size: (0, $5TXU5.SmartLinkSize).Medium,
    hideActions: true
};
const $2a4c4438bdd7c14c$var$titleBlockSubtitle = [
    {
        name: (0, $5TXU5.ElementName).CreatedBy
    }
];
const $2a4c4438bdd7c14c$var$hoverCardActionOptions = {
    hide: false,
    exclude: [
        (0, $5TXU5.CardAction).AutomationAction,
        (0, $5TXU5.CardAction).ChangeStatusAction,
        (0, $5TXU5.CardAction).CopyLinkAction,
        (0, $5TXU5.CardAction).DownloadAction,
        (0, $5TXU5.CardAction).FollowAction,
        (0, $5TXU5.CardAction).PreviewAction,
        (0, $5TXU5.CardAction).RovoChatAction,
        (0, $5TXU5.CardAction).ViewAction
    ]
};
const $2a4c4438bdd7c14c$export$532cb6865ebe8946 = ({ link: link, onRemove: onRemove, onPin: onPin, isPinned: isPinned = false, docPosition: docPosition, spaceKey: spaceKey, spaceId: spaceId })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const pinnedAtRef = (0, $42omo.useRef)(null); // Provide Top Docs attribution context to analytics events fired inside the
    // HoverCard popup (e.g. `smartLink clicked titleGoToLink`). Events fired
    // inside will carry this data in their context array, making hover preview
    // clicks attributable to the SmartSpaceOverview Top Docs module.
    const hoverCardAnalyticsContext = (0, $42omo.useMemo)(()=>({
            attributes: {
                originSpaceKey: spaceKey,
                originSpaceId: spaceId,
                spaceOverviewTopDocsPosition: docPosition
            }
        }), [
        docPosition,
        spaceKey,
        spaceId
    ]);
    const handleMouseEnter = (0, $42omo.useCallback)(()=>setIsHovered(true), []);
    const handleMouseLeave = (0, $42omo.useCallback)(()=>setIsHovered(false), []);
    const handleFocus = (0, $42omo.useCallback)(()=>setIsHovered(true), []);
    const handleBlur = (0, $42omo.useCallback)((e)=>{
        if (!e.currentTarget.contains(e.relatedTarget)) setIsHovered(false);
    }, []);
    const { store: store } = (0, $eIleF.useSmartLinkContext)();
    const getContentType = (0, $42omo.useCallback)(()=>{
        const cardState = store.getState()[link.url];
        const data = cardState?.details?.data;
        const generator = data && 'generator' in data ? data.generator : undefined;
        const platform = generator && typeof generator === 'object' && '@type' in generator && generator['@type'] !== 'Link' ? generator.name : undefined;
        return {
            platform: platform,
            contentType: cardState?.details?.meta?.resourceType
        };
    }, [
        store,
        link.url
    ]);
    const handlePin = (0, $42omo.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
        if (isPinned) {
            const pinnedDurationMs = pinnedAtRef.current !== null ? Date.now() - pinnedAtRef.current : undefined;
            pinnedAtRef.current = null;
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'unpinButton',
                    source: 'smartSpaceOverview',
                    attributes: {
                        moduleType: 'topDocs',
                        docId: link.id,
                        contentType: getContentType(),
                        pinnedDurationMs: pinnedDurationMs,
                        spaceKey: spaceKey
                    }
                }
            }).fire();
        } else {
            pinnedAtRef.current = Date.now();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'pinButton',
                    source: 'smartSpaceOverview',
                    attributes: {
                        moduleType: 'topDocs',
                        docId: link.id,
                        contentType: getContentType(),
                        previousPosition: docPosition,
                        spaceKey: spaceKey
                    }
                }
            }).fire();
        }
        onPin?.(link.id);
    }, [
        createAnalyticsEvent,
        getContentType,
        onPin,
        isPinned,
        link.id,
        docPosition,
        spaceKey
    ]);
    const handleRemove = (0, $42omo.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
        onRemove?.(link.id);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'removeDocButton',
                source: 'smartSpaceOverview',
                attributes: {
                    moduleType: 'topDocs',
                    docId: link.id,
                    contentType: getContentType(),
                    docPosition: docPosition,
                    spaceKey: spaceKey
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        getContentType,
        onRemove,
        link.id,
        docPosition,
        spaceKey
    ]);
    const handleLinkClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'card',
                actionSubjectId: 'topDoc',
                source: 'smartSpaceOverview',
                attributes: {
                    moduleType: 'topDocs',
                    docId: link.id,
                    contentType: getContentType(),
                    docPosition: docPosition,
                    spaceKey: spaceKey
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        getContentType,
        link.id,
        docPosition,
        spaceKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
        testId: "link-item",
        xcss: $2a4c4438bdd7c14c$var$itemStyles.outerWrapper,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.Flex), {
        xcss: $2a4c4438bdd7c14c$var$itemStyles.row,
        justifyContent: "space-between",
        alignItems: "center",
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bYRk6.default), {
        data: hoverCardAnalyticsContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $90Y9A.StandaloneHoverCard), {
        url: link.url,
        actionOptions: $2a4c4438bdd7c14c$var$hoverCardActionOptions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_zulpu2gc _1e0c1txw _4cvr1h6o _1bsb1osq _1ul9idpf"
        ])
    }, link.icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o _1o9zidpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        href: link.url,
        target: "_blank",
        rel: "noopener noreferrer",
        appearance: "subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lE8sM.default), {
        icon: link.icon,
        label: link.title,
        appearance: link.iconAppearance ?? 'gray',
        size: "large"
    }))), link.icon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf _fj13idpf _k1o1idpf _1rgbidpf _mto2idpf _1h2bu2gc _quenidpf _h5wdfhey _1jfl1r31 _cqjfglyw _wo36nqa1 _iv9li7uo _1eqa1wq8 _cphqglyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hpUsb.Card), {
        appearance: "inline",
        url: link.url,
        placeholder: link.title,
        disablePreviewPanel: true,
        ui: $2a4c4438bdd7c14c$var$cardUiProps,
        onClick: handleLinkClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5znEc.default), {
        direction: (0, $5TXU5.SmartLinkDirection).Horizontal,
        maxLines: 1,
        position: (0, $5TXU5.SmartLinkPosition).Center,
        text: link.title,
        anchorTarget: "_blank",
        hideTitleTooltip: true,
        subtitle: $2a4c4438bdd7c14c$var$titleBlockSubtitle
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf _fj13idpf _k1o1idpf _1rgbidpf _mto2idpf _1h2bu2gc _quenidpf _10as1mok _1c3d15vq _vwcq15vq _1h5mi8nm _13bx1ylp _1bqq1ylp _cphq1txw _1wdi1h6o _19s11h6o _gjdeidpf _h5wdfhey _1jfl1r31 _cqjfglyw _wo36nqa1 _iv9li7uo _1eqa1wq8"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hpUsb.Card), {
        appearance: "inline",
        url: link.url,
        placeholder: link.title,
        disablePreviewPanel: true,
        ui: $2a4c4438bdd7c14c$var$cardUiProps,
        onClick: handleLinkClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5znEc.default), {
        direction: (0, $5TXU5.SmartLinkDirection).Horizontal,
        maxLines: 1,
        position: (0, $5TXU5.SmartLinkPosition).Center,
        text: link.title,
        anchorTarget: "_blank",
        hideTitleTooltip: true,
        subtitle: $2a4c4438bdd7c14c$var$titleBlockSubtitle
    }))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
        xcss: isPinned || isHovered ? $2a4c4438bdd7c14c$var$itemStyles.actionsVisible : $2a4c4438bdd7c14c$var$itemStyles.actions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: isPinned ? (0, (/*@__PURE__*/$parcel$interopDefault($brxEJ))) : (0, (/*@__PURE__*/$parcel$interopDefault($6V1ly))),
        label: isPinned ? formatMessage($2a4c4438bdd7c14c$var$i18n.unpin) : formatMessage($2a4c4438bdd7c14c$var$i18n.pin),
        appearance: "subtle",
        spacing: "compact",
        onClick: handlePin
    }), !isPinned && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
        label: formatMessage($2a4c4438bdd7c14c$var$i18n.remove),
        appearance: "subtle",
        spacing: "compact",
        onClick: handleRemove
    }))));
};


/* TopLinksEmptyState.tsx generated by @compiled/babel-plugin v2.0.0 */ 















var $e2ZTm = parcelRequire("e2ZTm");




const $b5b2252444058be7$export$d16cbb23892d5ea = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "58",
        height: "60",
        viewBox: "0 0 58 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M5.37109 50.0781C5.37109 50.0781 30.9568 53.1209 44.1256 49.9399V3.60754C44.1256 3.60754 23.2435 8.72303 5.37109 3.33118C5.37109 3.33118 5.65298 50.2881 5.37109 50.0809V50.0781Z",
        fill: "var(--ds-background-accent-gray-subtler, #DDDEE1)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M38.6446 16.4585H10.8535V14.5239H38.6446V16.4585Z",
        fill: "var(--ds-icon-inverse, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M38.6446 23.2653H10.8535V21.3308H38.6446V23.2653Z",
        fill: "var(--ds-icon-inverse, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M38.6446 30.0749H10.8535V28.1404H38.6446V30.0749Z",
        fill: "var(--ds-icon-inverse, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M38.6446 36.8818H10.8535V34.9472H38.6446V36.8818Z",
        fill: "var(--ds-icon-inverse, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M52.3777 50.0975C52.4883 49.4784 52.5463 48.8207 52.5463 48.1242C52.5463 47.4278 52.4883 46.7507 52.375 46.1261C51.7062 42.398 49.1139 40.0986 45.4825 39.5072C44.8634 39.4077 44.214 39.3552 43.5369 39.3552C42.8321 39.3552 42.155 39.4105 41.5111 39.5183C37.8769 40.1263 35.2902 42.4173 34.6186 46.1261C34.5053 46.7535 34.4473 47.4195 34.4473 48.1242C34.4473 48.829 34.5053 49.4784 34.6158 50.0975C35.2819 53.8008 37.8686 56.0973 41.5111 56.7053C42.155 56.8131 42.8321 56.8684 43.5369 56.8684C44.214 56.8684 44.8634 56.8159 45.4825 56.7164C49.1194 56.125 51.7145 53.8229 52.3777 50.0975Z",
        fill: "var(--ds-chart-blue-bolder-hovered, #1868DB)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M44.1254 39.3718C43.9319 39.3635 43.7357 39.358 43.5339 39.358C42.8292 39.358 42.1521 39.4132 41.5082 39.521C37.874 40.1263 35.2872 42.4201 34.6157 46.1289C34.5024 46.7562 34.4443 47.4223 34.4443 48.127C34.4443 48.8234 34.5024 49.4812 34.6129 50.1002C34.682 50.4788 34.7732 50.8381 34.881 51.1891C38.2609 50.9791 41.4474 50.5894 44.1226 49.9427V39.3718H44.1254Z",
        fill: "var(--ds-text-accent-blue-bolder, #123263)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M49.5754 49.2905H37.8438V47.3559H49.5754V49.2905Z",
        fill: "var(--ds-icon-inverse, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M42.7432 54.1876V42.4588H44.6777V54.1876H42.7432Z",
        fill: "var(--ds-icon-inverse, #FFFFFF)"
    }));


const $a0273ad7ea242640$export$9aefb52db43407b5 = ({ onSuggestDocs: onSuggestDocs, isLoading: isLoading })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $a0273ad7ea242640$var$styles.container
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b5b2252444058be7$export$d16cbb23892d5ea), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.Text), {
        size: "large",
        weight: "medium",
        color: "color.text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $a0273ad7ea242640$var$i18n.pinImportantDocs)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $a0273ad7ea242640$var$styles.buttonWrapper
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "default",
        onClick: onSuggestDocs,
        isLoading: isLoading,
        iconBefore: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e2ZTm))), {
                ...iconProps,
                label: ""
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $a0273ad7ea242640$var$i18n.suggestDocs))));
const $a0273ad7ea242640$var$styles = {
    container: "_18zrv47k _1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _1bsb1osq",
    buttonWrapper: "_1q51u2gc"
};
const $a0273ad7ea242640$var$i18n = (0, $aXWIB.defineMessages)({
    pinImportantDocs: {
        id: "space-overview.smart-space-overview.top-docs-card.empty-state.pin-docs",
        defaultMessage: "Pin important docs here"
    },
    suggestDocs: {
        id: "space-overview.smart-space-overview.top-docs-card.empty-state.suggest-docs",
        defaultMessage: "Suggest docs"
    }
});


const $33f02f0950ddab6e$var$i18n = (0, $aXWIB.defineMessages)({
    topDocs: {
        id: "space-overview.smart-space-overview.top-docs-card.title",
        defaultMessage: "Top docs"
    }
});
const $33f02f0950ddab6e$var$topLinksItemWrapperStyles = {
    itemWrapper: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf _kqswh2mm _8hrz1qre",
    itemWrapperHalf: "_16jlkb7n _1o9zkb7n _i0dlhwvj _1ul9idpf _kqswh2mm _8hrz1qre"
};
const $33f02f0950ddab6e$var$TAB_PIN_FLIP_MS = 200;
const $33f02f0950ddab6e$var$TAB_PIN_FLIP_EASING = 'cubic-bezier(0.2, 0.85, 0.3, 1)';
const $33f02f0950ddab6e$var$TAB_PIN_COMPRESS_SCALE = 0.86;
const $33f02f0950ddab6e$var$maxCount = 4; /** Same URLs (multiset) as `next`, but row order follows `prev`. Refreshes `title` / `isPinned` from `next`. */ 
function $33f02f0950ddab6e$var$mergeTopLinksPreservingOrder(prev, next) {
    if (prev.length === 0 || next.length === 0 || prev.length !== next.length) return next;
    const nextByUrl = new Map(next.map((l)=>[
            l.url,
            l
        ]));
    const prevSig = [
        ...prev.map((l)=>l.url)
    ].sort().join('\0');
    const nextSig = [
        ...next.map((l)=>l.url)
    ].sort().join('\0');
    if (prevSig !== nextSig) return next;
    return prev.map((p)=>{
        const n = nextByUrl.get(p.url);
        if (!n) return p;
        return {
            ...p,
            title: n.title,
            isPinned: n.isPinned
        };
    });
} /**
   * Builds update input with `topLinks.add` (see `topLinksUpdateMutationInput.types.ts` — Relay artifact
   * input type lags the schema for `topLinks`).
   */ 
function $33f02f0950ddab6e$var$buildAddTopLinkMutationInput(spaceKey, link) {
    return {
        spaceKey: spaceKey,
        topLinks: {
            add: {
                url: link.url,
                title: link.title,
                isPinned: link.isPinned
            }
        }
    };
} /**
   * `input.topLinks` → `edit` → `ConfluenceEditTopLinkInput` (`url`, `isPinned` only — no `title`).
   */ 
function $33f02f0950ddab6e$var$buildEditTopLinkMutationInput(spaceKey, link) {
    return {
        spaceKey: spaceKey,
        topLinks: {
            edit: {
                url: link.url,
                isPinned: link.isPinned
            }
        }
    };
} /**
   * `input.topLinks` → `remove` → `ConfluenceRemoveTopLinkInput`.
   */ 
function $33f02f0950ddab6e$var$buildRemoveTopLinkMutationInput(spaceKey, url) {
    return {
        spaceKey: spaceKey,
        topLinks: {
            remove: {
                url: url
            }
        }
    };
}
const $33f02f0950ddab6e$var$topLinksCardUpdateTopLinksMutation = (0, $71c53debaf0f9345$export$2e2bcd8739ae039);
const $33f02f0950ddab6e$var$topLinksCardRefreshTopLinksMutation = (0, $096db6ea15398f90$export$2e2bcd8739ae039);
const $33f02f0950ddab6e$export$61bde326403f45f = ({ topLinks: topLinks, spaceKey: spaceKey, spaceId: spaceId })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [commitUpdateTopLinks] = (0, $308Wd.useMutationInterop)($33f02f0950ddab6e$var$topLinksCardUpdateTopLinksMutation, {
        __callerPackage__: "space-overview"
    });
    const [commitRefreshTopLinks, { loading: isRefreshLoading }] = (0, $308Wd.useMutationInterop)($33f02f0950ddab6e$var$topLinksCardRefreshTopLinksMutation, {
        __callerPackage__: "space-overview"
    });
    const queryLinks = (0, $42omo.useMemo)(()=>{
        const rawLinks = topLinks?.links;
        if (!rawLinks) return [];
        const mapped = rawLinks.reduce((acc, link)=>{
            if (link?.url && link?.title) acc.push({
                id: link.url,
                url: link.url,
                title: link.title,
                isPinned: link.isPinned ?? false
            });
            return acc;
        }, []);
        return mapped.slice(0, $33f02f0950ddab6e$var$maxCount);
    }, [
        topLinks
    ]);
    const [links, setLinks] = (0, $42omo.useState)(queryLinks);
    const applyPayload = (0, $42omo.useCallback)((payload, rollback, orderHint)=>{
        if (payload?.success) {
            const serverTopLinks = payload.overview?.topLinks;
            const list = serverTopLinks?.links?.filter((link)=>link != null && link.url != null && link.url !== '' && link.title != null);
            if (list != null && list.length > 0) {
                const fromServer = list.map((link)=>({
                        id: link.url,
                        url: link.url,
                        title: link.title,
                        subtitle: new URL(link.url).hostname,
                        isPinned: link.isPinned ?? false
                    }));
                const merged = orderHint != null ? $33f02f0950ddab6e$var$mergeTopLinksPreservingOrder(orderHint, fromServer) : fromServer;
                setLinks(merged);
            }
            return;
        }
        rollback();
    }, [
        setLinks
    ]);
    const applyTopLinksMutationResponse = (0, $42omo.useCallback)((data, rollback, orderHint)=>{
        applyPayload(data?.confluence_updateSmartSpaceOverview, rollback, orderHint);
    }, [
        applyPayload
    ]);
    const linksRef = (0, $42omo.useRef)(links);
    linksRef.current = links;
    const { store: store } = (0, $eIleF.useSmartLinkContext)();
    const getContentType = (url)=>{
        const cardState = store.getState()[url];
        const data = cardState?.details?.data;
        const generator = data && 'generator' in data ? data.generator : undefined;
        const platform = generator && typeof generator === 'object' && '@type' in generator && generator['@type'] !== 'Link' ? generator.name : undefined;
        return {
            platform: platform,
            contentType: cardState?.details?.meta?.resourceType
        };
    };
    const isModuleHoveredRef = (0, $42omo.useRef)(false);
    const handleModuleMouseEnter = (0, $42omo.useCallback)(()=>{
        if (isModuleHoveredRef.current) return;
        isModuleHoveredRef.current = true;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'hovered',
                actionSubject: 'module',
                actionSubjectId: 'topDocsModule',
                source: 'smartSpaceOverview',
                attributes: {
                    moduleType: 'topDocs',
                    spaceKey: spaceKey
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        spaceKey
    ]);
    const handleModuleMouseLeave = (0, $42omo.useCallback)(()=>{
        isModuleHoveredRef.current = false;
    }, []);
    const itemWrapperRefs = (0, $42omo.useRef)(new Map());
    const prevItemRectsRef = (0, $42omo.useRef)(new Map());
    const runTabReorderFlipRef = (0, $42omo.useRef)(false);
    const primaryMotionLinkIdRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        setLinks((prev)=>$33f02f0950ddab6e$var$mergeTopLinksPreservingOrder(prev, queryLinks));
    }, [
        queryLinks
    ]);
    const isAtCapacity = links.length >= $33f02f0950ddab6e$var$maxCount;
    const handleAddLink = (linkData)=>{
        const newLink = {
            id: `${linkData.url}-${linkData.title}`,
            url: linkData.url,
            title: linkData.title,
            subtitle: new URL(linkData.url).hostname,
            isPinned: true
        };
        const nextLinks = (0, $708b3e73f2b8fa2a$export$9b320488069db95e)(links, newLink, $33f02f0950ddab6e$var$maxCount);
        runTabReorderFlipRef.current = true;
        primaryMotionLinkIdRef.current = newLink.id;
        setLinks(nextLinks);
        const variables = {
            cloudId: cloudId,
            input: $33f02f0950ddab6e$var$buildAddTopLinkMutationInput(spaceKey, newLink)
        };
        commitUpdateTopLinks({
            variables: variables
        }).then(({ data: data })=>applyTopLinksMutationResponse(data, ()=>setLinks((prevLinks)=>prevLinks.filter((link)=>link.id !== newLink.id)), nextLinks)).catch(()=>{
            setLinks((prevLinks)=>prevLinks.filter((link)=>link.id !== newLink.id));
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'submitLinkButton',
                source: 'smartSpaceOverview',
                attributes: {
                    moduleType: 'topDocs',
                    docId: newLink.id,
                    contentType: getContentType(linkData.url),
                    inputMethod: linkData.inputMethod,
                    spaceKey: spaceKey
                }
            }
        }).fire();
    };
    const handleRemoveLink = (linkId)=>{
        const link = links.find((l)=>l.id === linkId);
        if (!link) return;
        const previousLinks = links;
        const afterRemove = previousLinks.filter((l)=>l.id !== linkId);
        setLinks(afterRemove);
        const variables = {
            cloudId: cloudId,
            input: $33f02f0950ddab6e$var$buildRemoveTopLinkMutationInput(spaceKey, link.url)
        };
        commitUpdateTopLinks({
            variables: variables
        }).then(({ data: data })=>applyTopLinksMutationResponse(data, ()=>setLinks(previousLinks), afterRemove)).catch(()=>{
            setLinks(previousLinks);
        });
    }; /** Pin and unpin both persist with `topLinks.edit` (`isPinned` true/false). */ 
    const handlePinLink = (linkId)=>{
        const previousLinks = links;
        const { nextLinks: nextLinks, didReorder: didReorder } = (0, $708b3e73f2b8fa2a$export$c42d680a28a18ad7)(previousLinks, linkId);
        const updatedLink = nextLinks.find((l)=>l.id === linkId);
        if (!updatedLink) return;
        if (didReorder) {
            runTabReorderFlipRef.current = true;
            primaryMotionLinkIdRef.current = linkId;
        }
        setLinks(nextLinks);
        const variables = {
            cloudId: cloudId,
            input: $33f02f0950ddab6e$var$buildEditTopLinkMutationInput(spaceKey, updatedLink)
        };
        commitUpdateTopLinks({
            variables: variables
        }).then(({ data: data })=>applyTopLinksMutationResponse(data, ()=>setLinks(previousLinks), nextLinks)).catch(()=>{
            setLinks(previousLinks);
        });
    };
    const handleSuggestDocs = (0, $42omo.useCallback)(()=>{
        const variables = {
            cloudId: cloudId,
            input: {
                spaceKey: spaceKey,
                topLinks: {
                    overridePinned: false
                }
            }
        };
        commitRefreshTopLinks({
            variables: variables
        }).then(({ data: data })=>{
            applyPayload(data?.confluence_refreshSmartSpaceOverview, ()=>{});
        }).catch(()=>{});
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'suggestDocsButton',
                source: 'smartSpaceOverview',
                attributes: {
                    moduleType: 'topDocs',
                    spaceKey: spaceKey
                }
            }
        }).fire();
    }, [
        cloudId,
        spaceKey,
        commitRefreshTopLinks,
        applyPayload,
        createAnalyticsEvent
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        const currentRects = new Map();
        for (const link of links){
            const el = itemWrapperRefs.current.get(link.id);
            if (el) currentRects.set(link.id, el.getBoundingClientRect());
        }
        if (runTabReorderFlipRef.current) {
            runTabReorderFlipRef.current = false;
            const primaryMotionId = primaryMotionLinkIdRef.current;
            const elementsToAnimate = new Set();
            for (const link of links){
                const el = itemWrapperRefs.current.get(link.id);
                const prev = prevItemRectsRef.current.get(link.id);
                const curr = currentRects.get(link.id);
                if (!el || !prev || !curr) continue;
                const dx = prev.left - curr.left;
                const dy = prev.top - curr.top;
                if (Math.abs(dx) > 0.5 || Math.abs(dy) > 0.5) {
                    const isPrimaryMotionTile = primaryMotionId !== null && link.id === primaryMotionId;
                    const compress = isPrimaryMotionTile ? ` scale(${$33f02f0950ddab6e$var$TAB_PIN_COMPRESS_SCALE})` : '';
                    el.style.transition = 'none';
                    el.style.willChange = 'transform';
                    el.style.zIndex = isPrimaryMotionTile ? '3' : '2';
                    el.style.transform = `translate(${dx}px, ${dy}px)${compress}`;
                    elementsToAnimate.add(el);
                }
            }
            if (elementsToAnimate.size > 0) requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    for (const el of elementsToAnimate){
                        el.style.transition = `transform ${$33f02f0950ddab6e$var$TAB_PIN_FLIP_MS}ms ${$33f02f0950ddab6e$var$TAB_PIN_FLIP_EASING}`;
                        el.style.transform = '';
                    }
                    window.setTimeout(()=>{
                        for (const el of elementsToAnimate){
                            el.style.transition = '';
                            el.style.transform = '';
                            el.style.willChange = '';
                            el.style.zIndex = '';
                        }
                        primaryMotionLinkIdRef.current = null;
                    }, $33f02f0950ddab6e$var$TAB_PIN_FLIP_MS + 50);
                });
            });
            else primaryMotionLinkIdRef.current = null;
        }
        prevItemRectsRef.current = currentRects;
    }, [
        links
    ]);
    const renderTopLinkItemWrapperFull = (0, $42omo.useCallback)((child, index)=>{
        const linkId = linksRef.current[index]?.id ?? (child.key != null ? String(child.key) : '');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            key: linkId || (child.key ?? index),
            ref: (el)=>{
                if (!linkId) return;
                if (el) itemWrapperRefs.current.set(linkId, el);
                else itemWrapperRefs.current.delete(linkId);
            },
            className: (0, $gMc0m.default)([
                $33f02f0950ddab6e$var$topLinksItemWrapperStyles.itemWrapper
            ])
        }, child);
    }, []);
    const renderTopLinkItemWrapperHalf = (0, $42omo.useCallback)((child, index)=>{
        const linkId = linksRef.current[index]?.id ?? (child.key != null ? String(child.key) : '');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            key: linkId || (child.key ?? index),
            ref: (el)=>{
                if (!linkId) return;
                if (el) itemWrapperRefs.current.set(linkId, el);
                else itemWrapperRefs.current.delete(linkId);
            },
            className: (0, $gMc0m.default)([
                $33f02f0950ddab6e$var$topLinksItemWrapperStyles.itemWrapperHalf
            ])
        }, child);
    }, []);
    const renderTopLinkItemWrapper = isAtCapacity ? renderTopLinkItemWrapperHalf : renderTopLinkItemWrapperFull;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "top-links-module",
        onMouseEnter: handleModuleMouseEnter,
        onMouseLeave: handleModuleMouseLeave,
        onFocus: handleModuleMouseEnter,
        onBlur: handleModuleMouseLeave
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fe608f906a4fdf3e$export$60332b2344f7fe41), {
        title: $33f02f0950ddab6e$var$i18n.topDocs,
        count: links.length,
        maxCount: $33f02f0950ddab6e$var$maxCount,
        renderItemWrapper: renderTopLinkItemWrapper,
        actionButton: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2d6c8d1397947730$export$b665e181ecd1797), {
            onLinkSubmit: handleAddLink,
            disabled: isAtCapacity,
            existingLinks: links
        })
    }, links.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a0273ad7ea242640$export$9aefb52db43407b5), {
        onSuggestDocs: handleSuggestDocs,
        isLoading: isRefreshLoading
    }) : links.map((link, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2a4c4438bdd7c14c$export$532cb6865ebe8946), {
            key: link.id,
            link: link,
            onRemove: handleRemoveLink,
            onPin: handlePinLink,
            isPinned: link.isPinned,
            docPosition: index,
            spaceKey: spaceKey,
            spaceId: spaceId
        }))));
};
const $33f02f0950ddab6e$export$3e180c03b339583e = ({ topLinks: topLinks, spaceKey: spaceKey, spaceId: spaceId })=>{
    const initialState = window['__SSR_TOP_DOCS__'];
    const storeData = (0, $btIEy.useStoreOptions)(initialState, (0, $i6Ps3.isPageSSRd)());
    const storeOptions = (0, $i6Ps3.isPageSSRd)() ? storeData : {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6M71K.ConfluenceSmartCardProvider), {
        authFlow: "disabled",
        ...storeOptions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($33f02f0950ddab6e$export$61bde326403f45f, {
        topLinks: topLinks,
        spaceKey: spaceKey,
        spaceId: spaceId
    }));
};


const $ca3580c7763f9e9f$export$56d49a1a95eb0a18 = ({ spaceKey: spaceKey, smartSpaceOverviewData: smartSpaceOverviewData, cloudId: cloudId })=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const spaceOverviewQueryResult = (0, $jMyy4.useQueryInterop)((0, $ixL26.default), {
        variables: {
            spaceKey: spaceKey,
            excludeOperations: true
        },
        __callerPackage__: "space-overview"
    });
    const spaceData = spaceOverviewQueryResult.data;
    const isAdminLoading = spaceOverviewQueryResult.loading;
    const isAdmin = spaceData?.space?.currentUser?.isAdmin ?? false;
    const isPersonalSpace = spaceData?.space?.type === 'personal';
    const spaceId = spaceData?.space?.id ?? '';
    const spaceName = spaceData?.space?.name ?? '';
    const emoji = (0, $8rneB.getEmojiFromPublishedPageProperties)(spaceData?.space?.homepage ?? null);
    const spaceIconPath = spaceData?.space?.icon?.path;
    const hasEmoji = !!emoji || !!spaceIconPath;
    const topLinks = smartSpaceOverviewData.topLinks;
    if (!contentId || !spaceKey || isAdminLoading) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $ca3580c7763f9e9f$var$styles.container
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e1b54ae933da37d5$export$2359131f9fa9ca50), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dhfse.RecommendedSpaceBannerLoader), {
        spaceKey: spaceKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $ca3580c7763f9e9f$var$styles.coverWrapper
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b9c2fb682b28c513$export$4c3aaf664391b8c5), {
        contentId: contentId,
        isAdmin: isAdmin,
        hasEmoji: hasEmoji
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $ca3580c7763f9e9f$var$styles.logoPositioner
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c0f874fe2d27e0c7$export$36f67a5ef9dc0044), {
        spaceKey: spaceKey,
        spaceId: spaceId,
        isAdmin: isAdmin,
        isPersonalSpace: isPersonalSpace,
        emoji: emoji,
        spaceIconPath: spaceIconPath
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $ca3580c7763f9e9f$var$styles.contentContainer
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $ca3580c7763f9e9f$var$styles.titleSummarySection
        ])
    }, spaceName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        as: "h1",
        size: "xxlarge"
    }, spaceName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e6lna.ConfluenceTeamButton), {
        containerId: (0, $lQS7C.ConfluenceSpaceAri).create({
            siteId: cloudId,
            spaceId: spaceId
        }).toString(),
        numberOfTeams: 1,
        orgId: cloudId
    })) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d3f4a8c5a2c21120$export$54ca75a6425bb521), {
        summaryData: smartSpaceOverviewData.summary,
        spaceKey: spaceKey
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $33f02f0950ddab6e$export$3e180c03b339583e), {
        topLinks: topLinks,
        spaceKey: spaceKey,
        spaceId: spaceId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b940e14642ad4976$export$5f1dbecc17d9b4ee), {
        faqData: smartSpaceOverviewData.faq,
        spaceKey: spaceKey
    })));
};
const $ca3580c7763f9e9f$var$styles = {
    container: "_1yt4oahv _19pkidpf _2hwx1wug _otyridpf _18u01wug _zulpze3t _bfhkvuon _ca0qidpf _p12f1fra _1e0c1txw _2lx21bp4",
    coverWrapper: "_kqswh2mm",
    logoPositioner: "_kqswstnw _94n5ze3t _1ltvxy5q _t9ecpqlc _1pbykb7n",
    contentContainer: "_zulpxy5q _18zrxy5q _1q518vuz _1e0c1txw _2lx21bp4",
    titleSummarySection: "_zulppxbi _1e0c1txw _2lx21bp4"
};


const $3bd39c5a85a3f0c2$export$d9d632754278a62e = (0, $3hHGU.default);
const $3bd39c5a85a3f0c2$export$145c4eaf64607c26 = ({ spaceKey: spaceKey, children: children, onExperienceResolved: onExperienceResolved })=>{
    const { isRovoEnabled: isRovoEnabled, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const spaceId = (0, $7QM6o.useSpaceId)(spaceKey);
    const trackedResolvedExperienceRef = (0, $42omo.useRef)(null);
    const smartSpaceOverviewEnabled = (0, $jpSPX.isSmartSpaceOverviewEnabled)({
        spaceKey: spaceKey,
        isRovoEnabled: isRovoEnabled,
        cloudId: cloudId
    });
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)($3bd39c5a85a3f0c2$export$d9d632754278a62e, {
        variables: {
            cloudId: cloudId,
            spaceKey: spaceKey
        },
        skip: !smartSpaceOverviewEnabled,
        __callerPackage__: "space-overview"
    });
    const smartSpaceOverviewData = data?.confluence_smartSpaceOverview;
    const hasSummary = smartSpaceOverviewData?.summary?.body !== null && smartSpaceOverviewData?.summary?.body !== undefined;
    const resolvedExperience = smartSpaceOverviewEnabled ? loading ? null : hasSummary ? 'smart' : 'regular' : 'regular';
    (0, $42omo.useEffect)(()=>{
        if (resolvedExperience) {
            onExperienceResolved?.(resolvedExperience);
            if (spaceId && trackedResolvedExperienceRef.current !== resolvedExperience) {
                trackedResolvedExperienceRef.current = resolvedExperience;
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'resolved',
                        actionSubject: 'spaceOverviewExperience',
                        source: 'spaceOverviewScreen',
                        containerId: spaceId,
                        attributes: {
                            spaceOverviewExperience: resolvedExperience,
                            spaceKey: spaceKey
                        }
                    }
                }).fire();
            }
        }
    }, [
        createAnalyticsEvent,
        resolvedExperience,
        onExperienceResolved,
        spaceId,
        spaceKey
    ]);
    if (smartSpaceOverviewEnabled) {
        if (loading) return null;
        if (hasSummary) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ca3580c7763f9e9f$export$56d49a1a95eb0a18), {
            spaceKey: spaceKey,
            smartSpaceOverviewData: smartSpaceOverviewData,
            cloudId: cloudId
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eiWUW.SpaceOverview), {
        spaceKey: spaceKey
    }, children);
};
module.exports["SpaceOverviewSwitcherQuery"] = $3bd39c5a85a3f0c2$export$d9d632754278a62e;
module.exports["SpaceOverviewSwitcher"] = $3bd39c5a85a3f0c2$export$145c4eaf64607c26;

});

parcelRegister("3hHGU", function(module, exports) {
/**
 * @generated SignedSource<<97883e4f3341dc8eee867b0d2022b8b6>>
 * @relayHash 167c1a5fbdbb53604f3f562e570f1f91
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9aa276284b5516cde1d9f7f8b3fe7215cd9ebb9294f9ac504abc7c452e599030
const $02fb880a65c09e36$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "isPinned"
    }, v2 = {
        "kind": "ScalarField",
        "name": "title"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "ConfluenceSmartSpaceOverview",
            "kind": "LinkedField",
            "name": "confluence_smartSpaceOverview",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceSmartSpaceOverviewSummary",
                    "kind": "LinkedField",
                    "name": "summary",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "body"
                        },
                        v1 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceSmartSpaceOverviewFAQ",
                    "kind": "LinkedField",
                    "name": "faq",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceSmartSpaceOverviewFAQEntry",
                            "kind": "LinkedField",
                            "name": "entries",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "question"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "answer"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "followUpQuestions"
                                },
                                {
                                    "concreteType": "ConfluenceSmartSpaceOverviewFAQSource",
                                    "kind": "LinkedField",
                                    "name": "sources",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "content",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                },
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "excerpt"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "embeddedProduct"
                                                },
                                                {
                                                    "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                                                    "kind": "LinkedField",
                                                    "name": "links",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "webui"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceSmartSpaceOverviewTopLinks",
                    "kind": "LinkedField",
                    "name": "topLinks",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "contentId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "lastRefreshed"
                        },
                        {
                            "concreteType": "ConfluenceSmartSpaceOverviewTopLink",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "url"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceOverviewSwitcherQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceOverviewSwitcherQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "167c1a5fbdbb53604f3f562e570f1f91",
            "id": "9aa276284b5516cde1d9f7f8b3fe7215cd9ebb9294f9ac504abc7c452e599030",
            "metadata": {},
            "name": "SpaceOverviewSwitcherQuery",
            "operationKind": "query",
            "text": "query SpaceOverviewSwitcherQuery($cloudId:ID!,$spaceKey:String!){confluence_smartSpaceOverview(cloudId:$cloudId,spaceKey:$spaceKey){summary{body,isPinned},faq{entries{question,answer,followUpQuestions,sources{content{id,title,excerpt,embeddedProduct,links{webui}}}}},topLinks{contentId,lastRefreshed,links{isPinned,title,url}}}}"
        }
    };
}();
$02fb880a65c09e36$var$node.hash = "1b64f396256f01419c73a81884314905";
var $02fb880a65c09e36$export$2e2bcd8739ae039 = $02fb880a65c09e36$var$node;
module.exports["default"] = $02fb880a65c09e36$export$2e2bcd8739ae039;

});

parcelRegister("jpSPX", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $cEgMD = parcelRequire("cEgMD");


var $8Psje = parcelRequire("8Psje");

const $d271b30f20f80b69$export$bb12d233342ab079 = ({ spaceKey: spaceKey, isRovoEnabled: isRovoEnabled, cloudId: cloudId })=>Boolean(cloudId) && !(0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) && !(0, $8Psje.isRovoSystemSpaceKey)(spaceKey) && isRovoEnabled && (0, $6mKj3.expVal)('smart_space_overview', 'isEnabled', false);
module.exports["isSmartSpaceOverviewEnabled"] = $d271b30f20f80b69$export$bb12d233342ab079;

});

parcelRegister("jPACe", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4ff4f509ac781670$export$e8a47c72fec9e984 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "SUzCl",
    name: "EditorPageCoverPictureEntry",
    loader: async ()=>{
        const { EditorPageCoverPictureEntry: EditorPageCoverPictureEntry } = await (parcelRequire("kV2bw"));
        return EditorPageCoverPictureEntry;
    }
});
module.exports["EditorPageCoverPictureEntry"] = $4ff4f509ac781670$export$e8a47c72fec9e984;

});

parcelRegister("kV2bw", function(module, exports) {

let $f3aad3600c4fdb02$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f3aad3600c4fdb02$var$load("02AxE"),
    $f3aad3600c4fdb02$var$load("dVM1q")
]).then(()=>parcelRequire('5tKh7'));

});

parcelRegister("5d01x", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");


var $2wGhm = parcelRequire("2wGhm");

const $48dbefd9a27e4f40$export$bbe9fefbd7814f35 = 3;
const $48dbefd9a27e4f40$var$styles = {
    outerContainer: "_1e0c116y _4cvr1h6o",
    overflowCount: "_12l21b66",
    container: "_1e0c116y _4cvr1h6o _kqswh2mm",
    logoWrapper: "_kqswh2mm _1e0c116y _4cvr1h6o _1bah1h6o _1bsb1tcg _4t3i1tcg _ahbqx0bf",
    firstLogo: "_ahbq1i6y",
    logo: "_2rko1qi0 _189e1dm9 _1dqonqa1 _1h6dveue _1bsbgktf _4t3igktf"
};
const $48dbefd9a27e4f40$export$3b2450ab8d88608 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(19);
    const { sources: sources, hideOverflowCount: t1 } = t0;
    const hideOverflowCount = t1 === undefined ? false : t1;
    if (sources.length === 0) return null;
    let T0;
    let T1;
    let overflowCount;
    let t2;
    let t3;
    let t4;
    if ($[0] !== sources) {
        const allUniqueSourceTypes = Array.from(new Set(sources.map((0, $2wGhm.getSourceType))));
        const visibleSourceTypes = allUniqueSourceTypes.slice(0, $48dbefd9a27e4f40$export$bbe9fefbd7814f35);
        overflowCount = sources.length - visibleSourceTypes.length;
        T1 = (0, $gdv5Z.Box);
        t4 = $48dbefd9a27e4f40$var$styles.outerContainer;
        T0 = (0, $gdv5Z.Box);
        t2 = $48dbefd9a27e4f40$var$styles.container;
        t3 = visibleSourceTypes.map((sourceType, index)=>{
            const Logo = (0, $2wGhm.getLogoForSourceType)(sourceType);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
                key: sourceType,
                xcss: (0, $1Whri.cx)($48dbefd9a27e4f40$var$styles.logoWrapper, index === 0 && $48dbefd9a27e4f40$var$styles.firstLogo),
                style: {
                    zIndex: visibleSourceTypes.length - index
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
                xcss: $48dbefd9a27e4f40$var$styles.logo
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Logo, {
                size: "xxsmall",
                shouldUseNewLogoDesign: true
            })));
        });
        $[0] = sources;
        $[1] = T0;
        $[2] = T1;
        $[3] = overflowCount;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[1];
        T1 = $[2];
        overflowCount = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t2 || $[9] !== t3) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            xcss: t2
        }, t3);
        $[7] = T0;
        $[8] = t2;
        $[9] = t3;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== hideOverflowCount || $[12] !== overflowCount) {
        t6 = !hideOverflowCount && overflowCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
            xcss: $48dbefd9a27e4f40$var$styles.overflowCount
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.Text), {
            size: "small",
            color: "color.text.subtlest"
        }, "+", overflowCount));
        $[11] = hideOverflowCount;
        $[12] = overflowCount;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] !== T1 || $[15] !== t4 || $[16] !== t5 || $[17] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T1, {
            xcss: t4
        }, t5, t6);
        $[14] = T1;
        $[15] = t4;
        $[16] = t5;
        $[17] = t6;
        $[18] = t7;
    } else t7 = $[18];
    return t7;
} : ({ sources: sources, hideOverflowCount: hideOverflowCount = false })=>{
    if (sources.length === 0) return null;
    const allUniqueSourceTypes = Array.from(new Set(sources.map((0, $2wGhm.getSourceType))));
    const visibleSourceTypes = allUniqueSourceTypes.slice(0, $48dbefd9a27e4f40$export$bbe9fefbd7814f35);
    const overflowCount = sources.length - visibleSourceTypes.length;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
        xcss: $48dbefd9a27e4f40$var$styles.outerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
        xcss: $48dbefd9a27e4f40$var$styles.container
    }, visibleSourceTypes.map((sourceType, index)=>{
        const Logo = (0, $2wGhm.getLogoForSourceType)(sourceType);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
            key: sourceType,
            xcss: (0, $1Whri.cx)($48dbefd9a27e4f40$var$styles.logoWrapper, index === 0 && $48dbefd9a27e4f40$var$styles.firstLogo),
            style: {
                zIndex: visibleSourceTypes.length - index
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
            xcss: $48dbefd9a27e4f40$var$styles.logo
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Logo, {
            size: "xxsmall",
            shouldUseNewLogoDesign: true
        })));
    })), !hideOverflowCount && overflowCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
        xcss: $48dbefd9a27e4f40$var$styles.overflowCount
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, "+", overflowCount)));
};
module.exports["MAX_VISIBLE_LOGOS"] = $48dbefd9a27e4f40$export$bbe9fefbd7814f35;
module.exports["SourceLogoStack"] = $48dbefd9a27e4f40$export$3b2450ab8d88608;

});

parcelRegister("2wGhm", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $4Nwes = parcelRequire("4Nwes");

var $lAFHW = parcelRequire("lAFHW");

/** Fallback icon for unrecognized source URLs. */ const $47223c9953757ad7$var$UnknownIcon = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4Nwes.AtlassianIcon), {
            appearance: "neutral",
            label: "",
            size: "xxsmall"
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4Nwes.AtlassianIcon), {
        appearance: "neutral",
        label: "",
        size: "xxsmall"
    });
const $47223c9953757ad7$var$LogoMap = {
    jira: (0, $lAFHW.JiraIcon),
    confluence: (0, $lAFHW.ConfluenceIcon),
    bitbucket: (0, $lAFHW.BitbucketIcon),
    loom: (0, $lAFHW.LoomIcon),
    goals: (0, $lAFHW.GoalsIcon),
    projects: (0, $lAFHW.ProjectsIcon),
    teams: (0, $lAFHW.TeamsIcon),
    home: (0, $lAFHW.HomeIcon),
    unknown: $47223c9953757ad7$var$UnknownIcon
};
function $47223c9953757ad7$export$369d94b7632e2acd(source) {
    const lowerSource = source.toLowerCase();
    if (lowerSource.includes('/browse/') || lowerSource.includes('/jira/')) return 'jira';
    if (lowerSource.includes('/wiki/')) return 'confluence';
    if (lowerSource.includes('bitbucket')) return 'bitbucket';
    if (lowerSource.includes('loom.com')) return 'loom';
    if (lowerSource.includes('home.atlassian.com') && lowerSource.includes('/goal/')) return 'goals';
    if (lowerSource.includes('home.atlassian.com') && lowerSource.includes('/project/')) return 'projects';
    if (lowerSource.includes('home.atlassian.com') && lowerSource.includes('/people/')) return 'teams';
    if (lowerSource.includes('home.atlassian.com')) return 'home';
    return 'unknown';
}
function $47223c9953757ad7$export$70ffc3122e8f5e93(sourceType) {
    return $47223c9953757ad7$var$LogoMap[sourceType];
}
module.exports["getSourceType"] = $47223c9953757ad7$export$369d94b7632e2acd;
module.exports["getLogoForSourceType"] = $47223c9953757ad7$export$70ffc3122e8f5e93;

});

parcelRegister("eWwvy", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $49b80c0b2fd2c306$export$9c32b7bc3af8de64 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "5liJC",
    name: "EditSpaceLogo",
    loader: async ()=>(await (parcelRequire("fIdAJ"))).EditSpaceLogo
});
module.exports["EditSpaceLogo"] = $49b80c0b2fd2c306$export$9c32b7bc3af8de64;

});

parcelRegister("fIdAJ", function(module, exports) {

let $b7058211b83db610$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b7058211b83db610$var$load("kyxdN").then(()=>parcelRequire('asonV'));

});

parcelRegister("4iPjq", function(module, exports) {

var $aqrhZ = parcelRequire("aqrhZ");


var $5wEPK = parcelRequire("5wEPK");


const $74848600c16eb369$var$LazyLinkPickerComponent = (0, $aqrhZ.lazyForPaint)(()=>(parcelRequire("5kVpB")).then(({ LinkPicker: LinkPicker })=>({
            default: LinkPicker
        })));
// Must be a default export to be able to support prop docs
// eslint-disable-next-line import/no-default-export
const $74848600c16eb369$var$_default_1 = (0, $5wEPK.composeLinkPicker)($74848600c16eb369$var$LazyLinkPickerComponent);
var $74848600c16eb369$export$2e2bcd8739ae039 = $74848600c16eb369$var$_default_1;
module.exports["default"] = $74848600c16eb369$export$2e2bcd8739ae039;

});

parcelRegister("5wEPK", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aqrhZ = parcelRequire("aqrhZ");


var $bYRk6 = parcelRequire("bYRk6");


var $2lNr8 = parcelRequire("2lNr8");


var $knjgj = parcelRequire("knjgj");


var $918lS = parcelRequire("918lS");


var $jrfDA = parcelRequire("jrfDA");


var $lQSkW = parcelRequire("lQSkW");

const $99bf16152ad1d840$export$800daf5fbbe96aff = {
    linkPickerRoot: 'link-picker-root'
};
const $99bf16152ad1d840$export$a2495bb1f182689d = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local",
    componentName: (0, $2lNr8.COMPONENT_NAME),
    source: (0, $2lNr8.COMPONENT_NAME)
};
const $99bf16152ad1d840$var$DefaultRootComponent = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": $99bf16152ad1d840$export$800daf5fbbe96aff.linkPickerRoot
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": $99bf16152ad1d840$export$800daf5fbbe96aff.linkPickerRoot
    }, children);
};
const $99bf16152ad1d840$var$fixedWidthContainerStyles = null;
const $99bf16152ad1d840$var$FixedWidthContainer = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $gMc0m.default)([
            "_1bsb1ubl"
        ]);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            role: "dialog",
            "aria-modal": "false",
            "aria-label": "link-picker",
            ...props,
            className: t0
        });
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        role: "dialog",
        "aria-modal": "false",
        "aria-label": "link-picker",
        ...props,
        className: (0, $gMc0m.default)([
            "_1bsb1ubl"
        ])
    });
};
const $99bf16152ad1d840$export$922eb685ceb4a294 = (Component)=>{
    return /*#__PURE__*/ (0, $42omo.memo)((props)=>{
        const { component: component } = props;
        const RootComponent = component ?? $99bf16152ad1d840$var$DefaultRootComponent;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bYRk6.default), {
            data: $99bf16152ad1d840$export$a2495bb1f182689d
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $knjgj.LinkPickerSessionProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lQSkW.MessagesProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: {
                ['--link-picker-width']: props.disableWidth ? '100%' : `${0, $2lNr8.LINK_PICKER_WIDTH_IN_PX}px`,
                ['--link-picker-padding-left']: props.paddingLeft ?? "var(--ds-space-200, 16px)",
                ['--link-picker-padding-right']: props.paddingRight ?? "var(--ds-space-200, 16px)",
                ['--link-picker-padding-top']: props.paddingTop ?? "var(--ds-space-200, 16px)",
                ['--link-picker-padding-bottom']: props.paddingBottom ?? "var(--ds-space-200, 16px)"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($99bf16152ad1d840$var$FixedWidthContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $918lS.ErrorBoundary), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aqrhZ.LazySuspense), {
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jrfDA.LoaderFallback), {
                url: props.url,
                hideDisplayText: props.hideDisplayText,
                isLoadingPlugins: props.isLoadingPlugins,
                plugins: props.plugins
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(RootComponent, {
            ...props,
            "data-testid": $99bf16152ad1d840$export$800daf5fbbe96aff.linkPickerRoot
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, props)))))))));
    });
};
module.exports["composeLinkPicker"] = $99bf16152ad1d840$export$922eb685ceb4a294;

});

parcelRegister("2lNr8", function(module, exports) {
const $7282d690d6f118fb$export$85183a312807388d = 'media';
const $7282d690d6f118fb$export$fc44104665f4d1e5 = 'linkPicker';
const $7282d690d6f118fb$export$452f1062ecf44be7 = 5;
const $7282d690d6f118fb$export$bf31a09f182d5584 = 342;
const $7282d690d6f118fb$export$542fb16962bf430c = '290px';
module.exports["ANALYTICS_CHANNEL"] = $7282d690d6f118fb$export$85183a312807388d;
module.exports["COMPONENT_NAME"] = $7282d690d6f118fb$export$fc44104665f4d1e5;
module.exports["RECENT_SEARCH_LIST_SIZE"] = $7282d690d6f118fb$export$452f1062ecf44be7;
module.exports["LINK_PICKER_WIDTH_IN_PX"] = $7282d690d6f118fb$export$bf31a09f182d5584;
module.exports["LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK"] = $7282d690d6f118fb$export$542fb16962bf430c;

});

parcelRegister("knjgj", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $42omo = parcelRequire("42omo");


var $dQl1W = parcelRequire("dQl1W");


var $hzd6s = parcelRequire("hzd6s");

const $56c0565d5892d700$export$c07727f5eddb98f = 'SESSION_UNINITIALIZED';
const $56c0565d5892d700$export$3285420c698bc605 = /*#__PURE__*/ (0, $42omo.createContext)($56c0565d5892d700$export$c07727f5eddb98f);
const $56c0565d5892d700$export$2f19832fd2d620ca = ({ children: children })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const { current: sessionId } = (0, $42omo.useRef)((0, $dQl1W.v4)());
    (0, $42omo.useEffect)(()=>{
        (0, $hzd6s.startUfoExperience)((0, $hzd6s.ufoExperience).mounted, sessionId);
        return ()=>(0, $hzd6s.abortUfoExperience)((0, $hzd6s.ufoExperience).mounted, sessionId);
    }, [
        sessionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($56c0565d5892d700$export$3285420c698bc605.Provider, {
        value: sessionId
    }, children);
};
const $56c0565d5892d700$export$36ecc935abdc3636 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $42omo.useContext)($56c0565d5892d700$export$3285420c698bc605);
} : ()=>(0, $42omo.useContext)($56c0565d5892d700$export$3285420c698bc605);
module.exports["LinkPickerSessionProvider"] = $56c0565d5892d700$export$2f19832fd2d620ca;
module.exports["useLinkPickerSessionId"] = $56c0565d5892d700$export$36ecc935abdc3636;

});

parcelRegister("hzd6s", function(module, exports) {

var $9801n = parcelRequire("9801n");

var $iqaft = parcelRequire("iqaft");

const $f665373313765471$export$f9c7780c574346a2 = {
    mounted: 'component-mounted'
};
const $f665373313765471$var$ufoExperiences = {
    [$f665373313765471$export$f9c7780c574346a2.mounted]: new (0, $9801n.ConcurrentExperience)($f665373313765471$export$f9c7780c574346a2.mounted, {
        type: (0, $iqaft.ExperienceTypes).Load,
        performanceType: (0, $iqaft.ExperiencePerformanceTypes).PageSegmentLoad,
        platform: {
            component: 'link-picker'
        }
    })
};
const $f665373313765471$export$5e9287b6a10f8075 = (experienceName, id, metadata)=>{
    const experience = $f665373313765471$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (metadata) experience.addMetadata(metadata);
};
const $f665373313765471$export$c5a5cf072c836c0e = (experienceName, id, metadata)=>{
    const experience = $f665373313765471$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: metadata
    });
};
const $f665373313765471$export$8dda83bafca11b77 = (experienceName, id, metadata)=>{
    const experience = $f665373313765471$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: metadata
    });
};
const $f665373313765471$export$b1021040eb94cdca = (experienceName, id, metadata)=>{
    const experience = $f665373313765471$var$ufoExperiences[experienceName].getInstance(id);
    experience.abort({
        metadata: metadata
    });
};
module.exports["ufoExperience"] = $f665373313765471$export$f9c7780c574346a2;
module.exports["startUfoExperience"] = $f665373313765471$export$5e9287b6a10f8075;
module.exports["succeedUfoExperience"] = $f665373313765471$export$c5a5cf072c836c0e;
module.exports["failUfoExperience"] = $f665373313765471$export$8dda83bafca11b77;
module.exports["abortUfoExperience"] = $f665373313765471$export$b1021040eb94cdca;

});

parcelRegister("918lS", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $hzd6s = parcelRequire("hzd6s");


var $2lNr8 = parcelRequire("2lNr8");


var $abGcM = parcelRequire("abGcM");


var $knjgj = parcelRequire("knjgj");


var $khavy = parcelRequire("khavy");


var $3blls = parcelRequire("3blls");

const $4548d496336bec74$export$e926676385687eaf = (0, $4pOgL.isReactCompilerActivePlatform)() ? function ErrorBoundary(t0) {
    const $ = (0, $frIzR.c)(6);
    const { children: children } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const linkPickerSessionId = (0, $knjgj.useLinkPickerSessionId)();
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== linkPickerSessionId) {
        t1 = (error, info)=>{
            createAnalyticsEvent((0, $abGcM.default)("ui.linkPicker.unhandledErrorCaught", {
                browserInfo: window?.navigator?.userAgent || "unknown",
                error: error.toString(),
                componentStack: info?.componentStack ?? ""
            })).fire((0, $2lNr8.ANALYTICS_CHANNEL));
            (0, $hzd6s.failUfoExperience)((0, $hzd6s.ufoExperience).mounted, linkPickerSessionId);
        };
        $[0] = createAnalyticsEvent;
        $[1] = linkPickerSessionId;
        $[2] = t1;
    } else t1 = $[2];
    const handleError = t1;
    let t2;
    if ($[3] !== children || $[4] !== handleError) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $khavy.BaseErrorBoundary), {
            onError: handleError,
            ErrorComponent: (0, $3blls.ErrorBoundaryFallback)
        }, children);
        $[3] = children;
        $[4] = handleError;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : function ErrorBoundary({ children: children }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const linkPickerSessionId = (0, $knjgj.useLinkPickerSessionId)();
    const handleError = (0, $42omo.useCallback)((error, info)=>{
        // Fire Analytics event
        createAnalyticsEvent((0, $abGcM.default)('ui.linkPicker.unhandledErrorCaught', {
            browserInfo: window?.navigator?.userAgent || 'unknown',
            error: error.toString(),
            componentStack: info?.componentStack ?? ''
        })).fire((0, $2lNr8.ANALYTICS_CHANNEL));
        // Fire UFO failed experience
        (0, $hzd6s.failUfoExperience)((0, $hzd6s.ufoExperience).mounted, linkPickerSessionId);
    }, [
        createAnalyticsEvent,
        linkPickerSessionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $khavy.BaseErrorBoundary), {
        onError: handleError,
        ErrorComponent: (0, $3blls.ErrorBoundaryFallback)
    }, children);
};
module.exports["ErrorBoundary"] = $4548d496336bec74$export$e926676385687eaf;

});

parcelRegister("abGcM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::590b9da528f0d0b88cea1feaa1815283>>
 * @codegenCommand yarn workspace @atlaskit/link-picker run codegen-analytics
 */ function $1d2d80882026b768$var$createEventPayload(eventKey, attributes) {
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        action: action,
        attributes: attributes
    };
}
var $1d2d80882026b768$export$2e2bcd8739ae039 = $1d2d80882026b768$var$createEventPayload;
module.exports["default"] = $1d2d80882026b768$export$2e2bcd8739ae039;

});

parcelRegister("khavy", function(module, exports) {

var $42omo = parcelRequire("42omo");

class $096b317da4a8d9ff$export$688779ac61ee945f extends (0, $42omo.Component) {
    componentDidCatch(error, info) {
        const { onError: onError } = this.props;
        onError && onError(error, info);
        this.setState({
            hasError: true
        });
    }
    render() {
        const { children: children, ErrorComponent: ErrorComponent } = this.props;
        const { hasError: hasError } = this.state;
        if (hasError && ErrorComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ErrorComponent, null);
        return children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
module.exports["BaseErrorBoundary"] = $096b317da4a8d9ff$export$688779ac61ee945f;

});

parcelRegister("3blls", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $2lNr8 = parcelRequire("2lNr8");


var $c2ARh = parcelRequire("c2ARh");


var $atwsN = parcelRequire("atwsN");


var $lO9iE = parcelRequire("lO9iE");

const $6fbfcea2b9f5c943$var$errorBoundaryFallbackStyles = null;
const $6fbfcea2b9f5c943$var$messages = (0, $aXWIB.defineMessages)({
    heading: {
        defaultMessage: "Something went wrong!",
        id: "fabric.linkPicker.unhandledError.heading"
    },
    description: {
        defaultMessage: "Try reloading the page.",
        id: "fabric.linkPicker.unhandledError.description"
    }
});
const $6fbfcea2b9f5c943$export$8a28b7e38e4685dd = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(8);
    const intl = (0, $aXWIB.useIntl)();
    let t0;
    if ($[0] !== intl) {
        t0 = intl.formatMessage($6fbfcea2b9f5c943$var$messages.heading);
        $[0] = intl;
        $[1] = t0;
    } else t0 = $[1];
    const header = t0;
    let t1;
    if ($[2] !== intl) {
        t1 = intl.formatMessage($6fbfcea2b9f5c943$var$messages.description);
        $[2] = intl;
        $[3] = t1;
    } else t1 = $[3];
    const description = t1;
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $gMc0m.default)([
            "_11c8i4vh"
        ]);
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== description || $[6] !== header) {
        t3 = /*#__PURE__*/ $42omo.createElement((0, $lO9iE.MinHeightContainer), {
            minHeight: (0, $2lNr8.LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK),
            "data-testid": "link-picker-root-error-boundary-ui",
            className: t2
        }, /*#__PURE__*/ $42omo.createElement((0, $atwsN.EmptyState), {
            header: header,
            renderImage: $6fbfcea2b9f5c943$var$_temp,
            description: description
        }));
        $[5] = description;
        $[6] = header;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ()=>{
    const intl = (0, $aXWIB.useIntl)();
    const header = intl.formatMessage($6fbfcea2b9f5c943$var$messages.heading);
    const description = intl.formatMessage($6fbfcea2b9f5c943$var$messages.description);
    return /*#__PURE__*/ $42omo.createElement((0, $lO9iE.MinHeightContainer), {
        minHeight: (0, $2lNr8.LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK),
        "data-testid": "link-picker-root-error-boundary-ui",
        className: (0, $gMc0m.default)([
            "_11c8i4vh"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $atwsN.EmptyState), {
        header: header,
        renderImage: ()=>/*#__PURE__*/ $42omo.createElement((0, $c2ARh.GenericErrorSVG), null),
        description: description
    }));
};
function $6fbfcea2b9f5c943$var$_temp() {
    return /*#__PURE__*/ $42omo.createElement((0, $c2ARh.GenericErrorSVG), null);
}
module.exports["ErrorBoundaryFallback"] = $6fbfcea2b9f5c943$export$8a28b7e38e4685dd;

});

parcelRegister("c2ARh", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $2890d1e9307e8ae4$var$SIZE = 96;
const $2890d1e9307e8ae4$var$genericErrorStyles = null;
const $2890d1e9307e8ae4$export$e54420a1a27457a4 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(10);
    let t0;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $gMc0m.default)([
            "_1bsb16xz _4t3i16xz _1e0c1ule"
        ]);
        t1 = /*#__PURE__*/ $42omo.createElement("path", {
            fill: "#fff",
            d: "M64.861 32.06a27.753 27.753 0 0 0-2.667-4.133 28.187 28.187 0 0 0-3.376-3.669c-6.985-6.311-15.57-6.89-23.609-2.53a30.226 30.226 0 0 0-4.056 2.656 30.624 30.624 0 0 0-3.735 3.4c-6.225 6.717-7.82 15.154-3.505 23.462a28.108 28.108 0 0 0 2.698 4.193 27.67 27.67 0 0 0 3.33 3.62c6.94 6.266 15.518 6.85 23.596 2.507a30.492 30.492 0 0 0 4.23-2.758 30.07 30.07 0 0 0 3.593-3.257c6.252-6.692 7.847-15.161 3.494-23.49h.007Z"
        });
        t2 = /*#__PURE__*/ $42omo.createElement("path", {
            fill: "#DDDEE1",
            d: "M43.092 66.774c-5.306 0-10.382-1.997-14.75-5.938a30.405 30.405 0 0 1-3.62-3.93 30.243 30.243 0 0 1-2.928-4.553c-4.657-8.961-3.247-18.509 3.871-26.192a33.271 33.271 0 0 1 4.025-3.67 32.834 32.834 0 0 1 4.378-2.869c9.209-4.995 18.816-3.951 26.353 2.86a30.945 30.945 0 0 1 3.665 3.98 30.303 30.303 0 0 1 2.898 4.488c4.705 9.003 3.295 18.565-3.868 26.231a32.148 32.148 0 0 1-3.879 3.515 33.415 33.415 0 0 1-4.562 2.975c-3.858 2.073-7.782 3.1-11.583 3.1v.003Zm2.53-45.486c-3.019 0-6.147.84-9.275 2.54a28.433 28.433 0 0 0-3.735 2.448 28.059 28.059 0 0 0-3.442 3.135c-5.746 6.203-6.86 13.566-3.135 20.736a25.395 25.395 0 0 0 2.472 3.83 25.304 25.304 0 0 0 3.044 3.309c5.99 5.41 13.398 6.182 20.862 2.175a28.02 28.02 0 0 0 3.899-2.545 28.03 28.03 0 0 0 3.31-2.999c5.777-6.182 6.883-13.552 3.124-20.75a25.553 25.553 0 0 0-2.44-3.777 25.848 25.848 0 0 0-3.087-3.358c-3.49-3.153-7.442-4.744-11.59-4.744h-.006Z"
        });
        t3 = /*#__PURE__*/ $42omo.createElement("path", {
            fill: "#DDDEE1",
            d: "M62.822 59.694c-1.235-1.72-2.562-1.71-3.857-.708-1.215.939-1.54 2.21-.244 3.882l1.48 1.913 4.102-3.174-1.48-1.913Z"
        });
        t4 = /*#__PURE__*/ $42omo.createElement("path", {
            fill: "#DDDEE1",
            d: "m65.334 60.811-6.159 4.762L70.748 80.54l6.16-4.761L65.333 60.81Z"
        });
        t5 = /*#__PURE__*/ $42omo.createElement("path", {
            fill: "#B7B9BE",
            d: "m64.344 61.577-4.178 3.23 3.925 5.076 4.178-3.23-3.925-5.076Z"
        });
        t6 = /*#__PURE__*/ $42omo.createElement("path", {
            fill: "#DDDEE1",
            fillRule: "evenodd",
            d: "M55.057 33.452 36.213 52.296l-2.468-2.469 18.844-18.844 2.468 2.469Z",
            clipRule: "evenodd"
        });
        t7 = /*#__PURE__*/ $42omo.createElement("path", {
            fill: "#DDDEE1",
            fillRule: "evenodd",
            d: "M52.589 52.296 33.745 33.452l2.468-2.469 18.844 18.844-2.468 2.469Z",
            clipRule: "evenodd"
        });
        $[0] = t0;
        $[1] = t1;
        $[2] = t2;
        $[3] = t3;
        $[4] = t4;
        $[5] = t5;
        $[6] = t6;
        $[7] = t7;
    } else {
        t0 = $[0];
        t1 = $[1];
        t2 = $[2];
        t3 = $[3];
        t4 = $[4];
        t5 = $[5];
        t6 = $[6];
        t7 = $[7];
    }
    let t8;
    if ($[8] !== props) {
        t8 = /*#__PURE__*/ $42omo.createElement("svg", {
            viewBox: "0 0 96 96",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props,
            className: t0
        }, t1, t2, t3, t4, t5, t6, t7);
        $[8] = props;
        $[9] = t8;
    } else t8 = $[9];
    return t8;
} : (props)=>{
    return /*#__PURE__*/ $42omo.createElement("svg", {
        viewBox: "0 0 96 96",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        className: (0, $gMc0m.default)([
            "_1bsb16xz _4t3i16xz _1e0c1ule"
        ])
    }, /*#__PURE__*/ $42omo.createElement("path", {
        fill: "#fff",
        d: "M64.861 32.06a27.753 27.753 0 0 0-2.667-4.133 28.187 28.187 0 0 0-3.376-3.669c-6.985-6.311-15.57-6.89-23.609-2.53a30.226 30.226 0 0 0-4.056 2.656 30.624 30.624 0 0 0-3.735 3.4c-6.225 6.717-7.82 15.154-3.505 23.462a28.108 28.108 0 0 0 2.698 4.193 27.67 27.67 0 0 0 3.33 3.62c6.94 6.266 15.518 6.85 23.596 2.507a30.492 30.492 0 0 0 4.23-2.758 30.07 30.07 0 0 0 3.593-3.257c6.252-6.692 7.847-15.161 3.494-23.49h.007Z"
    }), /*#__PURE__*/ $42omo.createElement("path", {
        fill: "#DDDEE1",
        d: "M43.092 66.774c-5.306 0-10.382-1.997-14.75-5.938a30.405 30.405 0 0 1-3.62-3.93 30.243 30.243 0 0 1-2.928-4.553c-4.657-8.961-3.247-18.509 3.871-26.192a33.271 33.271 0 0 1 4.025-3.67 32.834 32.834 0 0 1 4.378-2.869c9.209-4.995 18.816-3.951 26.353 2.86a30.945 30.945 0 0 1 3.665 3.98 30.303 30.303 0 0 1 2.898 4.488c4.705 9.003 3.295 18.565-3.868 26.231a32.148 32.148 0 0 1-3.879 3.515 33.415 33.415 0 0 1-4.562 2.975c-3.858 2.073-7.782 3.1-11.583 3.1v.003Zm2.53-45.486c-3.019 0-6.147.84-9.275 2.54a28.433 28.433 0 0 0-3.735 2.448 28.059 28.059 0 0 0-3.442 3.135c-5.746 6.203-6.86 13.566-3.135 20.736a25.395 25.395 0 0 0 2.472 3.83 25.304 25.304 0 0 0 3.044 3.309c5.99 5.41 13.398 6.182 20.862 2.175a28.02 28.02 0 0 0 3.899-2.545 28.03 28.03 0 0 0 3.31-2.999c5.777-6.182 6.883-13.552 3.124-20.75a25.553 25.553 0 0 0-2.44-3.777 25.848 25.848 0 0 0-3.087-3.358c-3.49-3.153-7.442-4.744-11.59-4.744h-.006Z"
    }), /*#__PURE__*/ $42omo.createElement("path", {
        fill: "#DDDEE1",
        d: "M62.822 59.694c-1.235-1.72-2.562-1.71-3.857-.708-1.215.939-1.54 2.21-.244 3.882l1.48 1.913 4.102-3.174-1.48-1.913Z"
    }), /*#__PURE__*/ $42omo.createElement("path", {
        fill: "#DDDEE1",
        d: "m65.334 60.811-6.159 4.762L70.748 80.54l6.16-4.761L65.333 60.81Z"
    }), /*#__PURE__*/ $42omo.createElement("path", {
        fill: "#B7B9BE",
        d: "m64.344 61.577-4.178 3.23 3.925 5.076 4.178-3.23-3.925-5.076Z"
    }), /*#__PURE__*/ $42omo.createElement("path", {
        fill: "#DDDEE1",
        fillRule: "evenodd",
        d: "M55.057 33.452 36.213 52.296l-2.468-2.469 18.844-18.844 2.468 2.469Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ $42omo.createElement("path", {
        fill: "#DDDEE1",
        fillRule: "evenodd",
        d: "M52.589 52.296 33.745 33.452l2.468-2.469 18.844 18.844-2.468 2.469Z",
        clipRule: "evenodd"
    }));
};
module.exports["GenericErrorSVG"] = $2890d1e9307e8ae4$export$e54420a1a27457a4;

});

parcelRegister("atwsN", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $cO1el = parcelRequire("cO1el");


var $g9Jfe = parcelRequire("g9Jfe");


var $1s5hv = parcelRequire("1s5hv");

var $iXCQx = parcelRequire("iXCQx");

const $e8c7333955d8c82e$var$styles = {
    containerV2: "_ca0q1ejb _u5f3oahv _19bvoahv _n3td1jfw _y3gn1h6o",
    whiteSpaceNormal: "_o5724jg8"
};
const $e8c7333955d8c82e$export$fddf379e22a74b00 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { testId: testId, header: header, description: description, action: action, renderImage: renderImage } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $1Whri.cx)($e8c7333955d8c82e$var$styles.containerV2, (0, $g9Jfe.fg)("platform_link_picker_fix_error_state_text_overflow") && $e8c7333955d8c82e$var$styles.whiteSpaceNormal);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== renderImage) {
        t2 = renderImage?.();
        $[1] = renderImage;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== header) {
        t3 = /*#__PURE__*/ $42omo.createElement((0, $cO1el.default), {
            size: "small",
            as: "h2"
        }, header);
        $[3] = header;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== description) {
        t4 = description && /*#__PURE__*/ $42omo.createElement((0, $iXCQx.Text), {
            as: "p",
            color: "color.text"
        }, description);
        $[5] = description;
        $[6] = t4;
    } else t4 = $[6];
    const t5 = action && action;
    let t6;
    if ($[7] !== t2 || $[8] !== t3 || $[9] !== t4 || $[10] !== t5 || $[11] !== testId) {
        t6 = /*#__PURE__*/ $42omo.createElement((0, $1s5hv.Flex), {
            xcss: t1,
            testId: testId,
            direction: "column",
            alignItems: "center",
            gap: "space.200"
        }, t2, t3, t4, t5);
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
        $[11] = testId;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : ({ testId: testId, header: header, description: description, action: action, renderImage: renderImage })=>{
    return /*#__PURE__*/ $42omo.createElement((0, $1s5hv.Flex), {
        xcss: (0, $1Whri.cx)($e8c7333955d8c82e$var$styles.containerV2, (0, $g9Jfe.fg)('platform_link_picker_fix_error_state_text_overflow') && $e8c7333955d8c82e$var$styles.whiteSpaceNormal),
        testId: testId,
        direction: "column",
        alignItems: "center",
        gap: "space.200"
    }, renderImage?.(), /*#__PURE__*/ $42omo.createElement((0, $cO1el.default), {
        size: "small",
        as: "h2"
    }, header), description && /*#__PURE__*/ $42omo.createElement((0, $iXCQx.Text), {
        as: "p",
        color: "color.text"
    }, description), action && action);
};
module.exports["EmptyState"] = $e8c7333955d8c82e$export$fddf379e22a74b00;

});

parcelRegister("lO9iE", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");

const $562443300071d672$var$minHeightComponentStyles = null;
const $562443300071d672$export$42134e2a251518b3 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ className: className, minHeight: minHeight, ...props }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: ref,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1fhb _1bah1h6o _1tke16li",
            className
        ]),
        ...props,
        style: {
            ['--link-picker-min-height']: minHeight
        }
    });
});
module.exports["MinHeightContainer"] = $562443300071d672$export$42134e2a251518b3;

});

parcelRegister("jrfDA", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $9hlns = parcelRequire("9hlns");


var $lO9iE = parcelRequire("lO9iE");

const $c92e1a3420d5d33f$var$styles = null;
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITHOUT_DISPLAYTEXT = '495px';
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITH_DISPLAYTEXT = '590px';
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITH_DISPLAYTEXT = '545px';
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITHOUT_DISPLAYTEXT = '450px';
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_DISPLAYTEXT = '252px';
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITHOUT_DISPLAYTEXT = '155px';
const $c92e1a3420d5d33f$var$getEstimatedMinHeight = ({ hideDisplayText: hideDisplayText, isLoadingPlugins: isLoadingPlugins, plugins: plugins, url: url })=>{
    /**
   * "Insert mode" (search results shown initially)
   */ if (!url) {
        /**
     * With tabs
     */ if (plugins && plugins.length > 1 || isLoadingPlugins) return hideDisplayText ? $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITHOUT_DISPLAYTEXT : $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITH_DISPLAYTEXT;
         /**
       * Without tabs
       */ 
        if (plugins?.length === 1) return hideDisplayText ? $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITHOUT_DISPLAYTEXT : $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITH_DISPLAYTEXT;
    }
    return hideDisplayText ? $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITHOUT_DISPLAYTEXT : $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_DISPLAYTEXT;
};
const $c92e1a3420d5d33f$export$d96e921133238c41 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(8);
    let t0;
    if ($[0] !== props) {
        t0 = $c92e1a3420d5d33f$var$getEstimatedMinHeight(props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    const minHeight = t0;
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $gMc0m.default)([
            "_4cvr1h6o"
        ]);
        $[2] = t1;
    } else t1 = $[2];
    const t2 = props.name || "link-picker-loading";
    let t3;
    if ($[3] !== t2) {
        t3 = /*#__PURE__*/ $42omo.createElement((0, $9hlns.default), {
            testId: "link-picker.component-loading-indicator",
            interactionName: t2,
            size: "medium"
        });
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== minHeight || $[6] !== t3) {
        t4 = /*#__PURE__*/ $42omo.createElement((0, $lO9iE.MinHeightContainer), {
            minHeight: minHeight,
            "data-testid": "link-picker-root-loader-boundary-ui",
            className: t1
        }, t3);
        $[5] = minHeight;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : (props)=>{
    const minHeight = $c92e1a3420d5d33f$var$getEstimatedMinHeight(props);
    return /*#__PURE__*/ $42omo.createElement((0, $lO9iE.MinHeightContainer), {
        minHeight: minHeight,
        "data-testid": "link-picker-root-loader-boundary-ui",
        className: (0, $gMc0m.default)([
            "_4cvr1h6o"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $9hlns.default), {
        testId: "link-picker.component-loading-indicator",
        interactionName: props.name || 'link-picker-loading',
        size: "medium"
    }));
};
module.exports["LoaderFallback"] = $c92e1a3420d5d33f$export$d96e921133238c41;

});

parcelRegister("lQSkW", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $ab7LA = parcelRequire("ab7LA");

const $6958f3d9e68e6f8d$export$54320b51a950d54a = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ab7LA.LazyMessagesProvider), null, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ab7LA.LazyMessagesProvider), null, children);
};
module.exports["MessagesProvider"] = $6958f3d9e68e6f8d$export$54320b51a950d54a;

});

parcelRegister("ab7LA", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $keVvA = parcelRequire("keVvA");


var $iaMDd = parcelRequire("iaMDd");


var $3lHRF = parcelRequire("3lHRF");

const $42f9fe6b4d8a0292$export$d013d33430f9fb4b = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $keVvA.default), {
            defaultMessages: (0, $iaMDd.default),
            loaderFn: (0, $3lHRF.fetchMessagesForLocale)
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $keVvA.default), {
        defaultMessages: (0, $iaMDd.default),
        loaderFn: (0, $3lHRF.fetchMessagesForLocale)
    }, children);
};
module.exports["LazyMessagesProvider"] = $42f9fe6b4d8a0292$export$d013d33430f9fb4b;

});

parcelRegister("keVvA", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $e9OZ6 = parcelRequire("e9OZ6");


var $5cR9p = parcelRequire("5cR9p");

const $36f6a30267bec70f$var$IntlMessagesProvider = (0, $4pOgL.isReactCompilerActivePlatform)() ? function IntlMessagesProvider(t0) {
    const $ = (0, $frIzR.c)(9);
    const { loaderFn: loaderFn, children: children, defaultMessages: defaultMessages } = t0;
    const intl = (0, $5cR9p.useSafeIntl)();
    const messages = (0, $e9OZ6.useMessages)(intl.locale, loaderFn);
    let t1;
    if ($[0] !== defaultMessages || $[1] !== intl.messages || $[2] !== messages) {
        t1 = {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
        $[0] = defaultMessages;
        $[1] = intl.messages;
        $[2] = messages;
        $[3] = t1;
    } else t1 = $[3];
    const mergedMessages = t1;
    let t2;
    if ($[4] !== children || $[5] !== intl.locale || $[6] !== intl.onError || $[7] !== mergedMessages) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.IntlProvider), {
            defaultLocale: "en",
            locale: intl.locale,
            onError: intl.onError,
            messages: mergedMessages
        }, children);
        $[4] = children;
        $[5] = intl.locale;
        $[6] = intl.onError;
        $[7] = mergedMessages;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : function IntlMessagesProvider({ loaderFn: loaderFn, children: children, defaultMessages: defaultMessages }) {
    const intl = (0, $5cR9p.useSafeIntl)();
    const messages = (0, $e9OZ6.useMessages)(intl.locale, loaderFn);
    /**
   * IntlProvider does not inherit from upstream IntlProviders,
   * we lookup messages in the Intl context (via useSafeIntl) and pass them downstream
   * This prevents the missing messages error.
   */ const mergedMessages = (0, $42omo.useMemo)(()=>{
        return {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.IntlProvider), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages
    }, children);
};
var $36f6a30267bec70f$export$2e2bcd8739ae039 = $36f6a30267bec70f$var$IntlMessagesProvider;
module.exports["default"] = $36f6a30267bec70f$export$2e2bcd8739ae039;

});

parcelRegister("e9OZ6", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $hxPth = parcelRequire("hxPth");

const $e1a1ee666860bb23$export$4d17e2d9c5348842 = (0, $4pOgL.isReactCompilerActivePlatform)() ? function useMessages(locale, loaderFn) {
    const $ = (0, $frIzR.c)(4);
    const [localeState, setLocaleState] = (0, $42omo.useState)((0, $hxPth.DEFAULT_LOCALE_STATE));
    const loadedLocaleRef = (0, $42omo.useRef)(localeState.locale);
    let t0;
    let t1;
    if ($[0] !== loaderFn || $[1] !== locale) {
        t0 = ()=>{
            if (locale === loadedLocaleRef.current) return;
            let current = true;
            loaderFn(locale).then((messages)=>{
                if (current) {
                    loadedLocaleRef.current = locale;
                    setLocaleState({
                        locale: locale,
                        messages: messages ?? {}
                    });
                }
            }, $e1a1ee666860bb23$var$_temp);
            return ()=>{
                current = false;
            };
        };
        t1 = [
            loaderFn,
            locale
        ];
        $[0] = loaderFn;
        $[1] = locale;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $42omo.useEffect)(t0, t1);
    return localeState.messages;
} : function useMessages(locale, loaderFn) {
    const [localeState, setLocaleState] = (0, $42omo.useState)((0, $hxPth.DEFAULT_LOCALE_STATE));
    const loadedLocaleRef = (0, $42omo.useRef)(localeState.locale);
    (0, $42omo.useEffect)(()=>{
        // Skip if we already have messages for this locale
        if (locale === loadedLocaleRef.current) return;
        let current = true;
        loaderFn(locale).then((messages)=>{
            if (current) {
                loadedLocaleRef.current = locale;
                setLocaleState({
                    locale: locale,
                    messages: messages ?? {}
                });
            }
        }, (error)=>{
            // Handle or log error appropriately
            console.error('Failed to load i18n messages via intl-messages-provider', error);
        });
        return ()=>{
            current = false;
        };
    }, [
        loaderFn,
        locale
    ]);
    return localeState.messages;
};
function $e1a1ee666860bb23$var$_temp(error) {
    console.error("Failed to load i18n messages via intl-messages-provider", error);
}
module.exports["useMessages"] = $e1a1ee666860bb23$export$4d17e2d9c5348842;

});

parcelRegister("hxPth", function(module, exports) {
const $b9a0da62d538b640$export$79618bef82c02d4c = {
    locale: 'en-US',
    messages: undefined
};
module.exports["DEFAULT_LOCALE_STATE"] = $b9a0da62d538b640$export$79618bef82c02d4c;

});

parcelRegister("5cR9p", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $hxPth = parcelRequire("hxPth");

// Prevents memory leaks
const $1961b540cbe6be26$var$cache = (0, $aXWIB.createIntlCache)();
const $1961b540cbe6be26$export$f752ac21ea3960a5 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    const context = (0, $42omo.useContext)((0, $aXWIB.IntlContext));
    if (!context) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = (0, $aXWIB.createIntl)((0, $hxPth.DEFAULT_LOCALE_STATE), $1961b540cbe6be26$var$cache);
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    }
    return context;
} : ()=>{
    const context = (0, $42omo.useContext)((0, $aXWIB.IntlContext));
    if (!context) return (0, $aXWIB.createIntl)((0, $hxPth.DEFAULT_LOCALE_STATE), $1961b540cbe6be26$var$cache);
    return context;
};
module.exports["useSafeIntl"] = $1961b540cbe6be26$export$f752ac21ea3960a5;

});

parcelRegister("3lHRF", function(module, exports) {

var $aWYpi = parcelRequire("aWYpi");

const $b1e230aff09883c2$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        const localeKey = locale.replace('-', '_');
        if (localeKey in (0, $aWYpi.locales)) {
            const messages = await (0, $aWYpi.locales)[localeKey]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        if (parentLocale in (0, $aWYpi.locales)) {
            const messages = await (0, $aWYpi.locales)[parentLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
};
module.exports["fetchMessagesForLocale"] = $b1e230aff09883c2$export$2b153a2030b0feb2;

});

parcelRegister("aWYpi", function(module, exports) {

























const $c4ed7fdc8607c9f9$export$df1c34db1371eeed = {
    cs: ()=>(parcelRequire("7QabG")),
    da: ()=>(parcelRequire("fZ5cF")),
    de: ()=>(parcelRequire("et5rH")),
    en_GB: ()=>(parcelRequire("9iJaf")),
    en_ZZ: ()=>(parcelRequire("4Cnvr")),
    en: ()=>Promise.resolve((parcelRequire("iaMDd"))),
    es: ()=>(parcelRequire("98LT8")),
    fi: ()=>(parcelRequire("g7yUI")),
    fr: ()=>(parcelRequire("54msv")),
    hu: ()=>(parcelRequire("gwZUB")),
    it: ()=>(parcelRequire("xztHG")),
    ja: ()=>(parcelRequire("2KyfN")),
    ko: ()=>(parcelRequire("9Acpd")),
    nb: ()=>(parcelRequire("16lF4")),
    nl: ()=>(parcelRequire("2kH7F")),
    pl: ()=>(parcelRequire("aXcVD")),
    pt_BR: ()=>(parcelRequire("5zlIO")),
    ru: ()=>(parcelRequire("k2mlL")),
    sv: ()=>(parcelRequire("fHEUp")),
    th: ()=>(parcelRequire("khF3L")),
    tr: ()=>(parcelRequire("3Shvv")),
    uk: ()=>(parcelRequire("7MpfQ")),
    vi: ()=>(parcelRequire("bbM1s")),
    zh_TW: ()=>(parcelRequire("fbVgU")),
    zh: ()=>(parcelRequire("hDdXe"))
};
module.exports["locales"] = $c4ed7fdc8607c9f9$export$df1c34db1371eeed;

});

parcelRegister("7QabG", function(module, exports) {

let $5b554ac0a4775ef8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5b554ac0a4775ef8$var$load("4Mixi"),
    $5b554ac0a4775ef8$var$load("1jsQH"),
    $5b554ac0a4775ef8$var$load("bv8GZ"),
    $5b554ac0a4775ef8$var$load("i9sd0"),
    $5b554ac0a4775ef8$var$load("i5eMd"),
    $5b554ac0a4775ef8$var$load("4DYJ5"),
    $5b554ac0a4775ef8$var$load("gyXEE"),
    $5b554ac0a4775ef8$var$load("hoPZ9")
]).then(()=>parcelRequire('k82rV'));

});

parcelRegister("fZ5cF", function(module, exports) {

let $ba3096ce98de807c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ba3096ce98de807c$var$load("cjveN"),
    $ba3096ce98de807c$var$load("deyvi"),
    $ba3096ce98de807c$var$load("cdeuH"),
    $ba3096ce98de807c$var$load("aNg21"),
    $ba3096ce98de807c$var$load("4UPfH"),
    $ba3096ce98de807c$var$load("hfFxJ"),
    $ba3096ce98de807c$var$load("1Mp9N"),
    $ba3096ce98de807c$var$load("2Fu3d")
]).then(()=>parcelRequire('5CXR9'));

});

parcelRegister("et5rH", function(module, exports) {

let $a887ff903b710b1b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a887ff903b710b1b$var$load("8XGJb"),
    $a887ff903b710b1b$var$load("6dERU"),
    $a887ff903b710b1b$var$load("7gF8f"),
    $a887ff903b710b1b$var$load("YEGhv"),
    $a887ff903b710b1b$var$load("gd4qs"),
    $a887ff903b710b1b$var$load("gofGr"),
    $a887ff903b710b1b$var$load("dBb6q"),
    $a887ff903b710b1b$var$load("eJgH8")
]).then(()=>parcelRequire('28QMN'));

});

parcelRegister("9iJaf", function(module, exports) {

let $6c58d42f4a0edd59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6c58d42f4a0edd59$var$load("hdvZr"),
    $6c58d42f4a0edd59$var$load("kTurq"),
    $6c58d42f4a0edd59$var$load("djb49"),
    $6c58d42f4a0edd59$var$load("d8WL7"),
    $6c58d42f4a0edd59$var$load("fviv5"),
    $6c58d42f4a0edd59$var$load("2RQvP"),
    $6c58d42f4a0edd59$var$load("7Lkvk")
]).then(()=>parcelRequire('b4NXj'));

});

parcelRegister("4Cnvr", function(module, exports) {

let $35ccf1dd50685b5f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $35ccf1dd50685b5f$var$load("4ViGN"),
    $35ccf1dd50685b5f$var$load("j0PWv"),
    $35ccf1dd50685b5f$var$load("ksTQ6"),
    $35ccf1dd50685b5f$var$load("j5F5K"),
    $35ccf1dd50685b5f$var$load("eBoC7"),
    $35ccf1dd50685b5f$var$load("7NpX8"),
    $35ccf1dd50685b5f$var$load("cukQS"),
    $35ccf1dd50685b5f$var$load("5FaEJ")
]).then(()=>parcelRequire('5SuH4'));

});

parcelRegister("98LT8", function(module, exports) {

let $6a7a020a351d74e8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6a7a020a351d74e8$var$load("32vlK"),
    $6a7a020a351d74e8$var$load("dlmud"),
    $6a7a020a351d74e8$var$load("5CGnz"),
    $6a7a020a351d74e8$var$load("dXu4x"),
    $6a7a020a351d74e8$var$load("bNv64"),
    $6a7a020a351d74e8$var$load("bFU3Y"),
    $6a7a020a351d74e8$var$load("3CucM"),
    $6a7a020a351d74e8$var$load("9yemY")
]).then(()=>parcelRequire('7TuuZ'));

});

parcelRegister("g7yUI", function(module, exports) {

let $bbc861f37c3af690$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bbc861f37c3af690$var$load("bjoGV"),
    $bbc861f37c3af690$var$load("cbkj0"),
    $bbc861f37c3af690$var$load("9Oxgj"),
    $bbc861f37c3af690$var$load("18TX5"),
    $bbc861f37c3af690$var$load("4Afgd"),
    $bbc861f37c3af690$var$load("exaJ2"),
    $bbc861f37c3af690$var$load("lp8Wm"),
    $bbc861f37c3af690$var$load("l2LZP")
]).then(()=>parcelRequire('ezgWl'));

});

parcelRegister("54msv", function(module, exports) {

let $3b0ebf4c93ba50be$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3b0ebf4c93ba50be$var$load("8oiz7"),
    $3b0ebf4c93ba50be$var$load("17m16"),
    $3b0ebf4c93ba50be$var$load("kAg8V"),
    $3b0ebf4c93ba50be$var$load("9Cdzw"),
    $3b0ebf4c93ba50be$var$load("cMubu"),
    $3b0ebf4c93ba50be$var$load("hcCcg"),
    $3b0ebf4c93ba50be$var$load("cHWSM"),
    $3b0ebf4c93ba50be$var$load("35Ssm")
]).then(()=>parcelRequire('gYv97'));

});

parcelRegister("gwZUB", function(module, exports) {

let $c08fa8ef165abe34$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c08fa8ef165abe34$var$load("hFxmj"),
    $c08fa8ef165abe34$var$load("b4NO6"),
    $c08fa8ef165abe34$var$load("fM2oh"),
    $c08fa8ef165abe34$var$load("guNAg"),
    $c08fa8ef165abe34$var$load("3fLE9"),
    $c08fa8ef165abe34$var$load("j9KTb"),
    $c08fa8ef165abe34$var$load("b37xN"),
    $c08fa8ef165abe34$var$load("ik6u5")
]).then(()=>parcelRequire('bVNwo'));

});

parcelRegister("xztHG", function(module, exports) {

let $064e9a642f5294af$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $064e9a642f5294af$var$load("BXOZB"),
    $064e9a642f5294af$var$load("1K1Fj"),
    $064e9a642f5294af$var$load("xnqy2"),
    $064e9a642f5294af$var$load("cM3gY"),
    $064e9a642f5294af$var$load("8hOn0"),
    $064e9a642f5294af$var$load("3hjAq"),
    $064e9a642f5294af$var$load("7PjNK"),
    $064e9a642f5294af$var$load("Vt6S9")
]).then(()=>parcelRequire('lxZVf'));

});

parcelRegister("2KyfN", function(module, exports) {

let $200a72bdd603d235$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $200a72bdd603d235$var$load("9Xiuh"),
    $200a72bdd603d235$var$load("38sfA"),
    $200a72bdd603d235$var$load("awkVi"),
    $200a72bdd603d235$var$load("6yRq3"),
    $200a72bdd603d235$var$load("h4OCL"),
    $200a72bdd603d235$var$load("2bCHJ"),
    $200a72bdd603d235$var$load("ktSfi"),
    $200a72bdd603d235$var$load("9GZ76")
]).then(()=>parcelRequire('hflsJ'));

});

parcelRegister("9Acpd", function(module, exports) {

let $6fa1195a67639e91$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6fa1195a67639e91$var$load("7Odo3"),
    $6fa1195a67639e91$var$load("bjmre"),
    $6fa1195a67639e91$var$load("11DLa"),
    $6fa1195a67639e91$var$load("cft22"),
    $6fa1195a67639e91$var$load("bcQs2"),
    $6fa1195a67639e91$var$load("fdXnq"),
    $6fa1195a67639e91$var$load("iouLY"),
    $6fa1195a67639e91$var$load("4sOIV")
]).then(()=>parcelRequire('73LWR'));

});

parcelRegister("16lF4", function(module, exports) {

let $0cd7277e754619f9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0cd7277e754619f9$var$load("4VkvT"),
    $0cd7277e754619f9$var$load("asvK9"),
    $0cd7277e754619f9$var$load("barSq"),
    $0cd7277e754619f9$var$load("gctEz"),
    $0cd7277e754619f9$var$load("aBa7j"),
    $0cd7277e754619f9$var$load("cItJR"),
    $0cd7277e754619f9$var$load("hPZE5"),
    $0cd7277e754619f9$var$load("QTjdE")
]).then(()=>parcelRequire('h0YR4'));

});

parcelRegister("2kH7F", function(module, exports) {

let $1b2ee6483a0770cc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1b2ee6483a0770cc$var$load("g5qJV"),
    $1b2ee6483a0770cc$var$load("7v6wU"),
    $1b2ee6483a0770cc$var$load("a8heY"),
    $1b2ee6483a0770cc$var$load("9PPH7"),
    $1b2ee6483a0770cc$var$load("b544F"),
    $1b2ee6483a0770cc$var$load("SctKm"),
    $1b2ee6483a0770cc$var$load("dzIm8"),
    $1b2ee6483a0770cc$var$load("hrf1M")
]).then(()=>parcelRequire('573SD'));

});

parcelRegister("aXcVD", function(module, exports) {

let $7f997165c7ba8892$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7f997165c7ba8892$var$load("dPa6p"),
    $7f997165c7ba8892$var$load("aEpRh"),
    $7f997165c7ba8892$var$load("6hlNE"),
    $7f997165c7ba8892$var$load("1y1eN"),
    $7f997165c7ba8892$var$load("K6fhx"),
    $7f997165c7ba8892$var$load("1fJz1"),
    $7f997165c7ba8892$var$load("jqwnR"),
    $7f997165c7ba8892$var$load("lsloj")
]).then(()=>parcelRequire('8sMYh'));

});

parcelRegister("5zlIO", function(module, exports) {

let $40e1121b9ee6c93d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $40e1121b9ee6c93d$var$load("iG4uh"),
    $40e1121b9ee6c93d$var$load("3fuR9"),
    $40e1121b9ee6c93d$var$load("2bqSD"),
    $40e1121b9ee6c93d$var$load("e8jpx"),
    $40e1121b9ee6c93d$var$load("gZU54"),
    $40e1121b9ee6c93d$var$load("9yA8o"),
    $40e1121b9ee6c93d$var$load("bGhLc"),
    $40e1121b9ee6c93d$var$load("iRKhU")
]).then(()=>parcelRequire('lRfBG'));

});

parcelRegister("k2mlL", function(module, exports) {

let $e96554c98c9bc495$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e96554c98c9bc495$var$load("9tVE8"),
    $e96554c98c9bc495$var$load("fMrUo"),
    $e96554c98c9bc495$var$load("bJykp"),
    $e96554c98c9bc495$var$load("fjbzp"),
    $e96554c98c9bc495$var$load("4Wdqb"),
    $e96554c98c9bc495$var$load("448N7"),
    $e96554c98c9bc495$var$load("9v6ER"),
    $e96554c98c9bc495$var$load("aEAsN")
]).then(()=>parcelRequire('hZouV'));

});

parcelRegister("fHEUp", function(module, exports) {

let $b6ea9acd9e8be017$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b6ea9acd9e8be017$var$load("6UAlo"),
    $b6ea9acd9e8be017$var$load("9eNkX"),
    $b6ea9acd9e8be017$var$load("dh2Er"),
    $b6ea9acd9e8be017$var$load("1pFHs"),
    $b6ea9acd9e8be017$var$load("k10Cs"),
    $b6ea9acd9e8be017$var$load("gBDdh"),
    $b6ea9acd9e8be017$var$load("8Mz40"),
    $b6ea9acd9e8be017$var$load("l6YHr")
]).then(()=>parcelRequire('4LH4L'));

});

parcelRegister("khF3L", function(module, exports) {

let $ec453ec2806faba2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ec453ec2806faba2$var$load("jYGxH").then(()=>parcelRequire('hlxQj'));

});

parcelRegister("3Shvv", function(module, exports) {

let $2d23fecbe4644720$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2d23fecbe4644720$var$load("czAFw").then(()=>parcelRequire('gQkbc'));

});

parcelRegister("7MpfQ", function(module, exports) {

let $5aa09b1e53b19903$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5aa09b1e53b19903$var$load("c0Efy").then(()=>parcelRequire('lC9hp'));

});

parcelRegister("bbM1s", function(module, exports) {

let $8255f915989d7a01$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8255f915989d7a01$var$load("dKBuH").then(()=>parcelRequire('fzD7h'));

});

parcelRegister("fbVgU", function(module, exports) {

let $b0f44f1323f5f3cb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b0f44f1323f5f3cb$var$load("ia9y3"),
    $b0f44f1323f5f3cb$var$load("j9OUx"),
    $b0f44f1323f5f3cb$var$load("bV8sS"),
    $b0f44f1323f5f3cb$var$load("kKXTS"),
    $b0f44f1323f5f3cb$var$load("l079e"),
    $b0f44f1323f5f3cb$var$load("ebljE"),
    $b0f44f1323f5f3cb$var$load("hF4v3"),
    $b0f44f1323f5f3cb$var$load("afU9w")
]).then(()=>parcelRequire('6PXdj'));

});

parcelRegister("hDdXe", function(module, exports) {

let $cd60e73a24cb5f53$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cd60e73a24cb5f53$var$load("15ncj"),
    $cd60e73a24cb5f53$var$load("gDiIK"),
    $cd60e73a24cb5f53$var$load("eLlpV"),
    $cd60e73a24cb5f53$var$load("7sItg"),
    $cd60e73a24cb5f53$var$load("f1B4n"),
    $cd60e73a24cb5f53$var$load("j4dSZ"),
    $cd60e73a24cb5f53$var$load("1Tuyb"),
    $cd60e73a24cb5f53$var$load("7iCpI")
]).then(()=>parcelRequire('5WXmf'));

});

parcelRegister("5kVpB", function(module, exports) {

let $3e2b5ad91357e86b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3e2b5ad91357e86b$var$load("inyRM"),
    $3e2b5ad91357e86b$var$load("knUiM"),
    $3e2b5ad91357e86b$var$load("hfDyd"),
    $3e2b5ad91357e86b$var$load("hOwUU"),
    $3e2b5ad91357e86b$var$load("8JTTv"),
    $3e2b5ad91357e86b$var$load("6wr18"),
    $3e2b5ad91357e86b$var$load("7EorR"),
    $3e2b5ad91357e86b$var$load("ffEVr"),
    $3e2b5ad91357e86b$var$load("Wowvf"),
    $3e2b5ad91357e86b$var$load("hhss7"),
    $3e2b5ad91357e86b$var$load("c0JsV")
]).then(()=>parcelRequire('cDSVd'));

});

parcelRegister("8fW0f", function(module, exports) {

var $4CPyF = parcelRequire("4CPyF");

var $aQaGv = parcelRequire("aQaGv");


var $g9Jfe = parcelRequire("g9Jfe");


var $6hu6G = parcelRequire("6hu6G");


var $7dyLS = parcelRequire("7dyLS");


var $44rik = parcelRequire("44rik");


var $k1Kn6 = parcelRequire("k1Kn6");


var $4LCen = parcelRequire("4LCen");


var $7OCSv = parcelRequire("7OCSv");


var $1MqUK = parcelRequire("1MqUK");

const $072a50f740811d00$export$452f1062ecf44be7 = 5;
const $072a50f740811d00$var$DEBOUNCE_MS = 400;
/**
 * Plugin responsible for handling fetching + caching of Atlassian Link Picker results
 */ class $072a50f740811d00$var$AtlassianLinkPickerPlugin {
    /**
   * Create search provider if config params are provided
   */ createSearchProvider(scope, aggregatorUrl, analyticsIdentifier, useConfluenceTypeInAri) {
        if (!this.cloudId || !scope) return undefined;
        return Promise.resolve(new (0, $4LCen.default)(this.cloudId, scope, aggregatorUrl, analyticsIdentifier, useConfluenceTypeInAri, this.cloudIds));
    }
    /**
   * Filter out fields from recent or search items.
   * @param items The recent items to remove fields from.
   * @returns Items with fields removed.
   */ filterListItemFields(items) {
        // Assume this.products won't change during function call
        const products = this.products;
        // We can't filter out items if we don't have a product or we have more than one product,
        // as we can't tell which product a given item is from.
        if (products?.length !== 1) return items;
        // Config of map of products to fields to filter out from each item
        const productFieldsMap = {
            townsquare: [
                'lastViewedDate',
                'lastUpdatedDate',
                'container'
            ]
        };
        return items.map((item)=>{
            const newItem = {
                ...item
            };
            // Set fields to be undefined when they have been specified to be based on a given product in productFieldsMap
            for (const [productToCheck, fieldsToCheck] of Object.entries(productFieldsMap)){
                if (products[0] === productToCheck) for (const field of fieldsToCheck)newItem[field] = undefined;
            }
            return newItem;
        });
    }
    /**
   * Set lastUpdatedDate for Loom search results and unset lastViewedDate.
   * @param items The recent Loom items .
   * @returns Items with lastUpdatedDate set.
   */ setLoomRecentItemsDateField(items) {
        return items.map((item)=>{
            const newItem = {
                ...item
            };
            newItem.lastViewedDate = item.lastUpdatedDate;
            newItem.lastUpdatedDate = undefined;
            return newItem;
        });
    }
    /**
   * Retrieve recent items from the activity provider
   */ async getRecentItems() {
        if (!this.activityClient) return [];
        if (!this.recentItems) {
            const { viewed: items } = await this.activityClient.fetchActivities([
                50,
                125,
                250
            ], // retries
            {
                limit: 100,
                products: this.products,
                rootContainerIds: this.allowMultiSiteRecents ? this.cloudIds?.reduce((acc, cloudId)=>acc.concat(...(0, $1MqUK.getArisForProducts)(this.products, cloudId)), []) : // If cloudIds array is provided, do not scope activities query
                this.cloudId !== undefined && !this.isMultisiteSearch ? (0, $1MqUK.getArisForProducts)(this.products, this.cloudId) : undefined
            }, [
                'viewed'
            ], true);
            this.recentItems = items.map((0, $1MqUK.mapActivityClientResultToLinkSearchItemData));
            this.recentItems = this.filterListItemFields(this.recentItems);
        }
        return this.recentItems;
    }
    /**
   * Given a query, search the activity provider for recent activity
   */ async searchRecentItems({ query: query }) {
        if (!this.recentItems) await this.getRecentItems();
        return (0, $44rik.filterItems)(this.recentItems, query);
    }
    async quickSearch(state) {
        const isLoomRecentSearch = this._scope === (0, $7dyLS.Scope).Loom && state.query.length === 0;
        // similar to getRecentItems() we return the initial recent result when query string is reset
        if (isLoomRecentSearch && this._loomRecentItems) return this._loomRecentItems;
        const items = await this.debouncedSearch(state.query);
        let searchListItems = items.map((0, $k1Kn6.mapSearchProviderResultToLinkSearchItemData));
        // For Loom both recent and search results are fetched from search client. When search query is empty
        // the search returns recent items, when the query is not empty it returns searched items.
        // The setLoomRecentItemsDateField method sets the correct date field for the UI to consume.
        if (isLoomRecentSearch) {
            searchListItems = this.setLoomRecentItemsDateField(searchListItems);
            this._loomRecentItems = searchListItems;
        }
        return this.filterListItemFields(searchListItems);
    }
    /**
   * Merge list of recent items and search items, and dedupes
   */ mergeResults(itemsA, itemsB) {
        // Dedupe the items based on the URL
        return (0, $4CPyF.filterUniqueItems)([
            ...itemsA,
            ...itemsB
        ], (itemA, itemB)=>itemA.url === itemB.url);
    }
    applyPluginFilter(items) {
        return items.filter(({ objectId: objectId })=>this._pluginItemFilter?.(objectId) ?? true).filter(({ objectId: objectId, url: url })=>this._pluginDataFilter?.({
                id: objectId,
                url: url
            }) ?? true);
    }
    /**
   * Given link picker state yields updates to the list of link picker results
   * The plugin is considered to be in a loading state until the generator returns a final value
   * The plugin can yield intermediate lists of results to present the user with initial results
   * while loading additional results to update the list with.
   */ async *resolve(state) {
        if (this.activityClient && state.query.length === 0) return {
            data: this.applyPluginFilter(await this.getRecentItems())
        };
        // Filter recents based on current state
        const filteredRecentItems = this.applyPluginFilter(await this.searchRecentItems(state));
        // If we have enough results, or there's no search provider to fetch more, return what we have
        if (filteredRecentItems.length >= $072a50f740811d00$export$452f1062ecf44be7 || !this.searchProvider) return {
            data: filteredRecentItems
        };
        if (filteredRecentItems.length) // Update with what we have while we search for more
        yield {
            data: filteredRecentItems
        };
        // Get more results and return them merged with recents
        const searchResults = this.applyPluginFilter(await this.quickSearch(state));
        return {
            data: this.mergeResults(filteredRecentItems, searchResults)
        };
    }
    emptyStateNoResults() {
        if ((0, $g9Jfe.fg)('link-picker-atl-plugin-empty-state')) {
            if (!this.activityClient) return null; // recent activity isn't supported, so leave this as blank
            if (!this.products || this.products.length !== 1) // don't support multi-product, as message gets too confusing
            return null;
            return (0, $7OCSv.renderEmptyStateNoResults)(this.products[0], this.action, this.cloudId, this.isMultisiteSearch);
        }
        return null;
    }
    get tabKey() {
        return this._tabKey;
    }
    get tabTitle() {
        return this._tabTitle;
    }
    get action() {
        return this._action;
    }
    constructor(config){
        this._tabKey = void 0;
        this._tabTitle = void 0;
        this.products = void 0;
        this.debouncedSearch = void 0;
        this.searchProvider = void 0;
        this.activityClient = void 0;
        this.recentItems = void 0;
        this.analyticsIdentifier = 'link-picker-quick-search';
        this.useConfluenceTypeInAri = true;
        this.cloudId = void 0;
        this.cloudIds = void 0;
        this.isMultisiteSearch = void 0;
        this.allowMultiSiteRecents = void 0;
        this._action = void 0;
        this._scope = void 0;
        this._loomRecentItems = void 0;
        this._pluginItemFilter = void 0;
        this._pluginDataFilter = void 0;
        const { tabConfig: tabConfig, activityClientEndpoint: activityClientEndpoint, disableActivityClient: disableActivityClient = false, searchProvider: searchProvider, cloudId: cloudId, cloudIds: cloudIds, scope: scope, products: products, aggregatorUrl: aggregatorUrl, action: action, itemFilter: itemFilter, dataFilter: dataFilter, allowMultiSiteRecents: allowMultiSiteRecents } = config ?? {};
        const { tabKey: tabKey, tabTitle: tabTitle } = tabConfig ?? {};
        this._tabKey = tabKey || 'Atlassian';
        this._tabTitle = tabTitle || 'Atlassian';
        this.products = products;
        this.cloudId = cloudId;
        this.cloudIds = cloudIds;
        this.isMultisiteSearch = (this.cloudIds?.length ?? 0) > 0;
        this.allowMultiSiteRecents = this.isMultisiteSearch && allowMultiSiteRecents;
        this._action = action;
        this._scope = scope;
        this._pluginItemFilter = itemFilter;
        this._pluginDataFilter = dataFilter;
        this.searchProvider = searchProvider || this.createSearchProvider(scope, aggregatorUrl, this.analyticsIdentifier, this.useConfluenceTypeInAri);
        if (!disableActivityClient) this.activityClient = (0, $6hu6G.createActivityClient)('v3', 'link_picker_atlassian_plugin', undefined, activityClientEndpoint);
        this.debouncedSearch = (0, $aQaGv.promiseDebounce)(async (query)=>{
            if (!this.searchProvider) return [];
            const searchProvider = await this.searchProvider;
            return searchProvider.quickSearch(query, $072a50f740811d00$export$452f1062ecf44be7);
        }, $072a50f740811d00$var$DEBOUNCE_MS);
    }
}
var $072a50f740811d00$export$2e2bcd8739ae039 = $072a50f740811d00$var$AtlassianLinkPickerPlugin;
module.exports["default"] = $072a50f740811d00$export$2e2bcd8739ae039;

});

parcelRegister("4CPyF", function(module, exports) {
/**
 * Filters array to a set of unique items given a predicate/comparator function
 * @param arr Initial array of items
 * @param comparator Predicate function
 * @returns Array of filtered / unique items
 */ function $b8ef4b094e13b3c4$export$8437fc55448c6e05(arr, comparator) {
    return arr.filter((firstItem, index, self)=>{
        return self.findIndex((secondItem)=>comparator ? comparator(firstItem, secondItem) : firstItem === secondItem) === index;
    });
}
module.exports["filterUniqueItems"] = $b8ef4b094e13b3c4$export$8437fc55448c6e05;

});

parcelRegister("aQaGv", function(module, exports) {
/**
 * Given a callback function returns a promise that resolves to the result of calling the callback function but is
 * debounced (execution is cancelled and promise will remain pending if `promiseDebounce` is re-called within the `time` interval)
 * @param cb Callback which returns result to be resolved
 * @param time Debounce interval
 * @returns Function that returns debounced promise
 */ function $b114f862ee74d165$export$390f1673aa3d5232(cb, time) {
    let timeoutId;
    // Returns a promise that fires the debounce fn and pushes a resolver
    // to have the debounced result resolved
    return (...args)=>{
        timeoutId && clearTimeout(timeoutId);
        return new Promise((resolve, reject)=>{
            timeoutId = setTimeout(()=>{
                cb(...args).then(resolve).catch(reject);
            }, time);
        });
    };
}
module.exports["promiseDebounce"] = $b114f862ee74d165$export$390f1673aa3d5232;

});

parcelRegister("7dyLS", function(module, exports) {
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $lEY55 = parcelRequire("lEY55");


var $iUYhn = parcelRequire("iUYhn");


var $eFiFf = parcelRequire("eFiFf");


var $3YFt4 = parcelRequire("3YFt4");

var $ff4c1fab1412a389$export$92e44ea1079b9ec6 = /*#__PURE__*/ function(Products) {
    Products["jira"] = "JIRA";
    Products["confluence"] = "CONFLUENCE";
    Products["townsquare"] = "TOWNSQUARE";
    Products["trello"] = "TRELLO";
    Products["bitbucket"] = "BITBUCKET";
    Products["other"] = "OTHER";
    return Products;
}({});
const $ff4c1fab1412a389$export$775b6bb06e53a214 = {
    ...(0, $lEY55.Scope),
    ...(0, $iUYhn.Scope),
    ...(0, $3YFt4.TownsquareScope),
    ...(0, $eFiFf.Scope)
};
module.exports["Scope"] = $ff4c1fab1412a389$export$775b6bb06e53a214;

});

parcelRegister("lEY55", function(module, exports) {
/**
 * Instead of enum types for ResultType, AnalyticsType and ContentType we use a list of typed strings.
 * Typescript has issues when using types that require specific enum values (https://github.com/microsoft/TypeScript/issues/28102).
 *
 * There doesn't appear to be a working solution soon and as such we will manually type each value separately using strings.
 */ var $31e4730094d25be0$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["ConfluencePageBlogAttachment"] = "confluence.page,blogpost,attachment";
    Scope["ConfluencePageBlog"] = "confluence.page,blogpost";
    Scope["ConfluenceExperimentsPageBlogAttachment"] = "confluence_experiments.page,blogpost,attachment";
    Scope["ConfluenceSpace"] = "confluence.space";
    Scope["UserConfluence"] = "urs.user-confluence";
    Scope["ConfluencePageBlogWhiteboard"] = "confluence.page,blogpost,whiteboard";
    Scope["ConfluenceContentType"] = "confluence.page,blogpost,whiteboard,database,embed";
    return Scope;
}({});
const $31e4730094d25be0$export$b6316c73fe562220 = 'confluence.page,blogpost,attachment';
const $31e4730094d25be0$export$da1906f69c8621ca = 'confluence.page,blogpost';
const $31e4730094d25be0$export$a300dffead5808fd = 'confluence_experiments.page,blogpost,attachment';
const $31e4730094d25be0$export$7694915d49dbf79 = 'confluence_experiments.page,blogpost,whiteboard';
const $31e4730094d25be0$export$2d908678acc2f256 = 'confluence_experiments.page,blogpost,whiteboard,database,embed';
const $31e4730094d25be0$export$80a5be864676016b = 'confluence.space';
const $31e4730094d25be0$export$70542451ad6057d2 = 'urs.user-confluence';
const $31e4730094d25be0$export$6ec00f56b27cdc1d = 'generic-container-result';
const $31e4730094d25be0$export$ca1a50bc869949e = 'person-result';
const $31e4730094d25be0$export$a99961038e9d5471 = 'confluence-object-result';
const $31e4730094d25be0$export$18c69de2b4aa679c = 'recent-confluence';
const $31e4730094d25be0$export$dc31f0db54ab1a30 = 'result-confluence';
const $31e4730094d25be0$export$cb8b6c470492bee8 = 'recent-person';
const $31e4730094d25be0$export$ebb42dafe7a39a20 = 'result-person';
const $31e4730094d25be0$export$602b44a55c824e30 = 'advanced-search-confluence';
const $31e4730094d25be0$export$3eb1eaefdca3e463 = 'advanced-search-people';
const $31e4730094d25be0$export$bbd1709e62826142 = 'confluence-page';
const $31e4730094d25be0$export$4a1ec8cc030bc82a = 'confluence-blogpost';
const $31e4730094d25be0$export$b441f0c13fd510b9 = 'confluence-attachment';
const $31e4730094d25be0$export$8ee8726ca4e2f8bd = 'confluence-space';
const $31e4730094d25be0$export$d0e824889e01c751 = 'person';
const $31e4730094d25be0$export$b0c74445b9c9b57 = 'confluence-app';
module.exports["Scope"] = $31e4730094d25be0$export$775b6bb06e53a214;

});

parcelRegister("iUYhn", function(module, exports) {
/**
 * Instead of enum types for ResultType and ContentType we use a list of typed strings.
 * Typescript has issues when using types that require specific enum values (https://github.com/microsoft/TypeScript/issues/28102).
 *
 * There doesn't appear to be a working solution soon and as such we will manually type each value separately using strings.
 */ var $4cce666965dd4176$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["JiraIssue"] = "jira.issue";
    Scope["JiraPlan"] = "jira.plan";
    Scope["JiraDashboard"] = "jira.dashboard";
    Scope["JiraIssueDashboardBoardProjectFilter"] = "jira.issue,dashboard,board,project,filter";
    Scope["JiraBoardProjectFilter"] = "jira.board,project,filter";
    Scope["JiraBoardProjectFilterPlan"] = "jira.board,project,filter,plan";
    Scope["JiraProject"] = "jira.project";
    Scope["People"] = "urs.user-jira";
    return Scope;
}({});
var $4cce666965dd4176$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["JiraIssue"] = "jira-issue";
    ContentType["JiraDashboard"] = "jira-dashboard";
    ContentType["JiraBoard"] = "jira-board";
    ContentType["JiraProject"] = "jira-project";
    ContentType["JiraFilter"] = "jira-filter";
    ContentType["JiraPlan"] = "jira-plan";
    ContentType["JiraPeople"] = "jira-people";
    return ContentType;
}({});
function $4cce666965dd4176$export$b3b8cefe01df28d2(avatar) {
    return Object.prototype.hasOwnProperty.call(avatar, 'url');
}
function $4cce666965dd4176$export$496f9fe01bbac92b(avatar) {
    return Object.prototype.hasOwnProperty.call(avatar, 'urls');
}
var $4cce666965dd4176$export$d31c6c64cddbeeac = /*#__PURE__*/ function(AttributeType) {
    AttributeType["issue"] = "issue";
    AttributeType["dashboard"] = "dashboard";
    AttributeType["board"] = "board";
    AttributeType["project"] = "project";
    AttributeType["filter"] = "filter";
    AttributeType["plan"] = "plan";
    AttributeType["people"] = "people";
    return AttributeType;
}({});
module.exports["Scope"] = $4cce666965dd4176$export$775b6bb06e53a214;

});

parcelRegister("eFiFf", function(module, exports) {
var $e9e0239fba21ef53$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["Loom"] = "loom.loom";
    return Scope;
}({});
module.exports["Scope"] = $e9e0239fba21ef53$export$775b6bb06e53a214;

});

parcelRegister("3YFt4", function(module, exports) {
var $e1c90e4cbab1fa73$export$fca43c5c12a4e3fa = /*#__PURE__*/ function(TownsquareScope) {
    TownsquareScope["TownsquareProject"] = "townsquare.project";
    TownsquareScope["TownsquareGoal"] = "townsquare.goal";
    TownsquareScope["TownsquareHelpLink"] = "townsquare.help-pointer";
    TownsquareScope["TownsquareQuestion"] = "townsquare.question";
    TownsquareScope["TownsquareTag"] = "townsquare.tag";
    TownsquareScope["TownsquareLearning"] = "townsquare.learning";
    TownsquareScope["People"] = "townsquare.people";
    TownsquareScope["Teams"] = "townsquare.teams";
    return TownsquareScope;
}({});
 // End of copied code.
module.exports["TownsquareScope"] = $e1c90e4cbab1fa73$export$fca43c5c12a4e3fa;

});

parcelRegister("44rik", function(module, exports) {
const $6873537e3409ebab$export$16c4c0987c894b8c = (items, searchTerm)=>{
    if (!searchTerm || !items) return [];
    return items.filter((item)=>{
        return item.name.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
    });
};
module.exports["filterItems"] = $6873537e3409ebab$export$16c4c0987c894b8c;

});

parcelRegister("k1Kn6", function(module, exports) {

var $7OCSv = parcelRequire("7OCSv");

const $fcdb22c28e10bf47$export$b76efb0c656bea6e = ({ objectId: objectId, container: container, title: title, contentType: contentType, url: url, updatedTimestamp: updatedTimestamp, iconUrl: iconUrl, subtype: subtype })=>({
        objectId: objectId,
        name: title,
        container: container,
        url: url,
        ...// Use the icon url from the quick search result if it exists but still resolve the altText,
        // which return defaultAlt if no icon is found. Otherwise find an icon by looking up the content type
        iconUrl ? {
            icon: iconUrl,
            iconAlt: (0, $7OCSv.getIconFromContentType)(contentType, subtype).iconAlt
        } : (0, $7OCSv.getIconFromContentType)(contentType, subtype),
        lastUpdatedDate: updatedTimestamp ? new Date(updatedTimestamp) : undefined,
        prefetch: false,
        meta: {
            source: 'xp-search'
        }
    });
module.exports["mapSearchProviderResultToLinkSearchItemData"] = $fcdb22c28e10bf47$export$b76efb0c656bea6e;

});

parcelRegister("7OCSv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $duwSm = parcelRequire("duwSm");


var $lAFHW = parcelRequire("lAFHW");





var $6iY4P = parcelRequire("6iY4P");


var $l5jcq = parcelRequire("l5jcq");


var $57Wda = parcelRequire("57Wda");


var $kWiYc = parcelRequire("kWiYc");


var $8hhCV = parcelRequire("8hhCV");


var $66dpz = parcelRequire("66dpz");


var $9J3bP = parcelRequire("9J3bP");


var $7G33r = parcelRequire("7G33r");


var $eQfRp = parcelRequire("eQfRp");


var $8d3zB = parcelRequire("8d3zB");


var $g9Jfe = parcelRequire("g9Jfe");


var $hjLb5 = parcelRequire("hjLb5");


var $d5Nnx = parcelRequire("d5Nnx");

var $0d10d22313e2a678$var$LinkContentType = /*#__PURE__*/ function(LinkContentType) {
    LinkContentType[LinkContentType["jira.issue"] = 0] = "jira.issue";
    LinkContentType[LinkContentType["jira.issue.bug"] = 1] = "jira.issue.bug";
    LinkContentType[LinkContentType["jira.issue.story"] = 2] = "jira.issue.story";
    LinkContentType[LinkContentType["jira.issue.task"] = 3] = "jira.issue.task";
    LinkContentType[LinkContentType["jira.issue.epic"] = 4] = "jira.issue.epic";
    LinkContentType[LinkContentType["jira.dashboard"] = 5] = "jira.dashboard";
    LinkContentType[LinkContentType["jira.board"] = 6] = "jira.board";
    LinkContentType[LinkContentType["jira.project"] = 7] = "jira.project";
    LinkContentType[LinkContentType["jira.filter"] = 8] = "jira.filter";
    LinkContentType[LinkContentType["confluence.page"] = 9] = "confluence.page";
    LinkContentType[LinkContentType["confluence.blogpost"] = 10] = "confluence.blogpost";
    LinkContentType[LinkContentType["confluence.whiteboard"] = 11] = "confluence.whiteboard";
    LinkContentType[LinkContentType["loom.video"] = 12] = "loom.video";
    LinkContentType[LinkContentType["confluence.database"] = 13] = "confluence.database";
    LinkContentType[LinkContentType["confluence.embed"] = 14] = "confluence.embed";
    return LinkContentType;
}($0d10d22313e2a678$var$LinkContentType || {});
const $0d10d22313e2a678$export$74b0c6644317c84d = (product, action, cloudId, isMultisiteSearch)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hjLb5.EmptyStateNoResults), {
        product: product,
        action: action,
        cloudId: cloudId,
        isMultisiteSearch: isMultisiteSearch
    });
};
const $0d10d22313e2a678$export$f642707b43bbbafc = (contentType)=>{
    return Boolean(contentType && Object.keys($0d10d22313e2a678$var$LinkContentType).includes(contentType));
};
const $0d10d22313e2a678$export$80e948449ec854a9 = {
    'jira.issue': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8d3zB.default), {
                label: alt
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconIssueLabel
    },
    'jira.issue.bug': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l5jcq.default), {
                label: alt
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconBugLabel
    },
    'jira.issue.story': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9J3bP.default), {
                label: alt
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconStoryLabel
    },
    'jira.issue.task': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7G33r.default), {
                label: alt
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconTaskLabel
    },
    'jira.issue.epic': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kWiYc.default), {
                label: alt
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconEpicLabel
    },
    'jira.dashboard': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.JiraIcon), {
                label: alt,
                size: "xxsmall",
                appearance: "brand"
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconDashboardLabel
    },
    'jira.board': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.JiraIcon), {
                label: alt,
                size: "xxsmall",
                appearance: "brand"
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconBoardLabel
    },
    'jira.project': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.JiraIcon), {
                label: alt,
                size: "xxsmall",
                appearance: "brand"
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconProjectLabel
    },
    'jira.filter': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.JiraIcon), {
                label: alt,
                size: "xxsmall",
                appearance: "brand"
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconFilterLabel
    },
    'confluence.page': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8hhCV.default), {
                label: alt
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconPageLabel
    },
    'confluence.blogpost': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6iY4P.default), {
                label: alt
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconBlogLabel
    },
    'confluence.whiteboard': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eQfRp.default), {
                label: alt
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconWhiteboardLabel
    },
    'loom.video': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.LoomIcon), {
                label: alt,
                shouldUseNewLogoDesign: true,
                size: "xxsmall"
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconLoomLabel
    },
    'confluence.database': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $57Wda.default), {
                label: alt
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconDatabaseLabel
    },
    'confluence.embed': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($duwSm))), {
                color: "var(--ds-icon-accent-blue, #357DE8)",
                label: alt
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconEmbedLabel
    }
};
const $0d10d22313e2a678$export$d71678bb4eba5b81 = (contentType, subtype)=>{
    if (!$0d10d22313e2a678$export$f642707b43bbbafc(contentType)) return {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8hhCV.default), {
                label: alt
            }),
        iconAlt: (0, $d5Nnx.messages).defaultAltText
    };
    if (contentType === 'jira.issue' && (0, $g9Jfe.fg)('confluence-issue-terminology-refresh')) return {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8d3zB.default), {
                label: alt
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconIssueLabelIssueTermRefresh
    };
    if (contentType === 'confluence.page' && subtype === 'live') return {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $66dpz.default), {
                label: alt
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconLiveDocLabel
    };
    return $0d10d22313e2a678$export$80e948449ec854a9[contentType];
};
const $0d10d22313e2a678$export$ac1fda7301622804 = (iconUrl)=>{
    let alt = (0, $d5Nnx.messages).defaultAltText; // TODO add in extra cases for V3 api
    if (iconUrl.includes('story.svg')) alt = (0, $d5Nnx.messages).story;
    if (iconUrl.includes('epic.svg')) alt = (0, $d5Nnx.messages).epic;
    if (iconUrl.includes('avatarId=10318')) alt = (0, $d5Nnx.messages).task;
    if (iconUrl.includes('avatarId=10303')) alt = (0, $d5Nnx.messages).bug;
    if (iconUrl.includes('avatarId=10518')) alt = (0, $d5Nnx.messages).subTask;
    if (iconUrl.includes('avatarId=10310')) alt = (0, $d5Nnx.messages).improvement;
    return alt;
};
const $0d10d22313e2a678$export$fd251dec3e575ea1 = (iconUrl)=>{
    return {
        icon: iconUrl,
        iconAlt: $0d10d22313e2a678$export$ac1fda7301622804(iconUrl)
    };
};
module.exports["renderEmptyStateNoResults"] = $0d10d22313e2a678$export$74b0c6644317c84d;
module.exports["getIconFromContentType"] = $0d10d22313e2a678$export$d71678bb4eba5b81;
module.exports["getIconFromIconUrl"] = $0d10d22313e2a678$export$fd251dec3e575ea1;

});

parcelRegister("l5jcq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $2ISy2 = parcelRequire("2ISy2");


var $kXb3C = parcelRequire("kXb3C");

const $6c7fb5a91851c05d$var$BugObject = (0, $4pOgL.isReactCompilerActivePlatform)() ? function BugObject(t0) {
    const $ = (0, $frIzR.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Bug" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($2ISy2))),
            color: "var(--ds-icon-accent-red, #C9372C)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function BugObject({ label: label = 'Bug', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2ISy2))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
};
var $6c7fb5a91851c05d$export$2e2bcd8739ae039 = $6c7fb5a91851c05d$var$BugObject;
module.exports["default"] = $6c7fb5a91851c05d$export$2e2bcd8739ae039;

});

parcelRegister("57Wda", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6B0jU = parcelRequire("6B0jU");


var $kXb3C = parcelRequire("kXb3C");

const $0a57bdd6dcbbb0a3$var$DatabaseObject = (0, $4pOgL.isReactCompilerActivePlatform)() ? function DatabaseObject(t0) {
    const $ = (0, $frIzR.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Database" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))),
            color: "var(--ds-icon-accent-purple, #AF59E1)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function DatabaseObject({ label: label = 'Database', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
};
var $0a57bdd6dcbbb0a3$export$2e2bcd8739ae039 = $0a57bdd6dcbbb0a3$var$DatabaseObject;
module.exports["default"] = $0a57bdd6dcbbb0a3$export$2e2bcd8739ae039;

});

parcelRegister("kWiYc", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $4SWbm = parcelRequire("4SWbm");


var $kXb3C = parcelRequire("kXb3C");

const $4ce94c9023f0019e$var$EpicObject = (0, $4pOgL.isReactCompilerActivePlatform)() ? function EpicObject(t0) {
    const $ = (0, $frIzR.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Epic" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($4SWbm))),
            color: "var(--ds-icon-accent-purple, #AF59E1)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function EpicObject({ label: label = 'Epic', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4SWbm))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
};
var $4ce94c9023f0019e$export$2e2bcd8739ae039 = $4ce94c9023f0019e$var$EpicObject;
module.exports["default"] = $4ce94c9023f0019e$export$2e2bcd8739ae039;

});

parcelRegister("8hhCV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $8jHAi = parcelRequire("8jHAi");


var $kXb3C = parcelRequire("kXb3C");

const $02745cd2b6b0665c$var$PageObject = (0, $4pOgL.isReactCompilerActivePlatform)() ? function PageObject(t0) {
    const $ = (0, $frIzR.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Page" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function PageObject({ label: label = 'Page', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $02745cd2b6b0665c$export$2e2bcd8739ae039 = $02745cd2b6b0665c$var$PageObject;
module.exports["default"] = $02745cd2b6b0665c$export$2e2bcd8739ae039;

});

parcelRegister("66dpz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $e0ycV = parcelRequire("e0ycV");


var $kXb3C = parcelRequire("kXb3C");

const $893c7e3925139b9a$var$PageLiveDocObject = (0, $4pOgL.isReactCompilerActivePlatform)() ? function PageLiveDocObject(t0) {
    const $ = (0, $frIzR.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Page Live Doc" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
            color: "var(--ds-icon-accent-magenta, #CD519D)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function PageLiveDocObject({ label: label = 'Page Live Doc', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
        color: "var(--ds-icon-accent-magenta, #CD519D)"
    });
};
var $893c7e3925139b9a$export$2e2bcd8739ae039 = $893c7e3925139b9a$var$PageLiveDocObject;
module.exports["default"] = $893c7e3925139b9a$export$2e2bcd8739ae039;

});

parcelRegister("e0ycV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53807950cf9f28638ee48a6f68a59d1b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a32b99a806197ff2$var$_react = $a32b99a806197ff2$var$_interopRequireDefault((parcelRequire("42omo")));

var $a32b99a806197ff2$var$_baseNew = $a32b99a806197ff2$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a32b99a806197ff2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/page-live-doc
 * Usage guidance:
 * Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a32b99a806197ff2$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $a32b99a806197ff2$var$_react.default.createElement($a32b99a806197ff2$var$_baseNew.default, Object.assign({
        name: "PageLiveDocIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$a32b99a806197ff2$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $a32b99a806197ff2$var$_default = module.exports.default = $a32b99a806197ff2$var$PageLiveDocIcon;

});

parcelRegister("9J3bP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $kR5QY = parcelRequire("kR5QY");


var $kXb3C = parcelRequire("kXb3C");

const $458cec0faf8f188b$var$StoryObject = (0, $4pOgL.isReactCompilerActivePlatform)() ? function StoryObject(t0) {
    const $ = (0, $frIzR.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Story" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kR5QY))),
            color: "var(--ds-icon-accent-green, #22A06B)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function StoryObject({ label: label = 'Story', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kR5QY))),
        color: "var(--ds-icon-accent-green, #22A06B)"
    });
};
var $458cec0faf8f188b$export$2e2bcd8739ae039 = $458cec0faf8f188b$var$StoryObject;
module.exports["default"] = $458cec0faf8f188b$export$2e2bcd8739ae039;

});

parcelRegister("7G33r", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dmbve = parcelRequire("dmbve");


var $kXb3C = parcelRequire("kXb3C");

const $b1b906ca2447e962$var$TaskObject = (0, $4pOgL.isReactCompilerActivePlatform)() ? function TaskObject(t0) {
    const $ = (0, $frIzR.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Task" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($dmbve))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function TaskObject({ label: label = 'Task', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dmbve))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $b1b906ca2447e962$export$2e2bcd8739ae039 = $b1b906ca2447e962$var$TaskObject;
module.exports["default"] = $b1b906ca2447e962$export$2e2bcd8739ae039;

});

parcelRegister("eQfRp", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $ZDq1z = parcelRequire("ZDq1z");


var $kXb3C = parcelRequire("kXb3C");

const $26650821103220c8$var$WhiteboardObject = (0, $4pOgL.isReactCompilerActivePlatform)() ? function WhiteboardObject(t0) {
    const $ = (0, $frIzR.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Whiteboard" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
            color: "var(--ds-icon-accent-teal, #2898BD)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function WhiteboardObject({ label: label = 'Whiteboard', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
        color: "var(--ds-icon-accent-teal, #2898BD)"
    });
};
var $26650821103220c8$export$2e2bcd8739ae039 = $26650821103220c8$var$WhiteboardObject;
module.exports["default"] = $26650821103220c8$export$2e2bcd8739ae039;

});

parcelRegister("8d3zB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $2qVkt = parcelRequire("2qVkt");


var $kXb3C = parcelRequire("kXb3C");

const $487ca0b42e22d1f4$var$WorkItemObject = (0, $4pOgL.isReactCompilerActivePlatform)() ? function WorkItemObject(t0) {
    const $ = (0, $frIzR.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Work Item" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($2qVkt))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function WorkItemObject({ label: label = 'Work Item', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2qVkt))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $487ca0b42e22d1f4$export$2e2bcd8739ae039 = $487ca0b42e22d1f4$var$WorkItemObject;
module.exports["default"] = $487ca0b42e22d1f4$export$2e2bcd8739ae039;

});

parcelRegister("hjLb5", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $abC4X = parcelRequire("abC4X");


var $2Nwuj = parcelRequire("2Nwuj");


var $kiOFr = parcelRequire("kiOFr");


var $kSC7A = parcelRequire("kSC7A");


var $g9Jfe = parcelRequire("g9Jfe");


var $4CdHI = parcelRequire("4CdHI");

const $6b6b665bcf70315b$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    noResults: {
        id: "fabric.linkPickerAtlassianPlugin.emptyStateNoResults.heading",
        defaultMessage: "Get started with {productName}."
    },
    noResultsConfluenceDescription: {
        id: "fabric.linkPickerAtlassianPlugin.emptyStateNoResults.confluenceDescription",
        defaultMessage: "Recently viewed pages will appear once you <link>start using Confluence</link>."
    },
    noResultsJiraDescription: {
        id: "fabric.linkPickerAtlassianPlugin.emptyStateNoResults.jiraDescription",
        defaultMessage: "Recently viewed issues will appear once you <link>start using Jira</link>."
    },
    noResultsJiraDescriptionIssueTerminologyRefreshM4: {
        id: "fabric.linkPickerAtlassianPlugin.emptyStateNoResults.jiraDescription-issue-terminology-refresh-m4",
        defaultMessage: "Recently viewed work items will appear once you <link>start using Jira</link>."
    },
    noResultsDefaultDescription: {
        id: "fabric.linkPickerAtlassianPlugin.emptyStateNoResults.defaultDescription",
        defaultMessage: "Recently viewed items will appear once you <link>start using {productName}</link>."
    },
    noResultsConfluenceCreateOption: {
        id: "fabric.linkPickerAtlassianPlugin.emptyStateNoResults.description",
        defaultMessage: "You can also create a new page."
    }
});
const $6b6b665bcf70315b$export$800daf5fbbe96aff = {
    emptyStateNoResults: 'link-picker-empty-state-no-results'
};
const $6b6b665bcf70315b$var$emptyStateWrapperStyles = null;
const $6b6b665bcf70315b$export$e661eeb828fb7b2 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(17);
    const { product: product, cloudId: cloudId, isMultisiteSearch: isMultisiteSearch } = t0;
    const intl = (0, $aXWIB.useIntl)();
    const { data: data } = (0, $kiOFr.useAvailableSites)();
    const isConfluence = product === "confluence";
    let t1;
    if ($[0] !== cloudId || $[1] !== data || $[2] !== intl || $[3] !== isConfluence || $[4] !== isMultisiteSearch || $[5] !== product) {
        t1 = Symbol.for("react.early_return_sentinel");
        bb0: {
            const productDetails = $6b6b665bcf70315b$export$dc8a6c8f6bc81cdd(product);
            if (!productDetails) {
                t1 = null;
                break bb0;
            }
            const firstMatchingSite = data.find($6b6b665bcf70315b$export$5e557b52f4095909(productDetails.availableSitesProduct, cloudId, isMultisiteSearch));
            if (firstMatchingSite) {
                let baseUrl = firstMatchingSite.url;
                if (isConfluence) {
                    baseUrl = baseUrl + "/wiki";
                    baseUrl;
                }
                const intlDescription = intl.formatMessage(productDetails.description, {
                    productName: productDetails.productName,
                    link: (str)=>/*#__PURE__*/ $42omo.createElement((0, $2Nwuj.default), {
                            href: baseUrl
                        }, str)
                });
                let t2;
                if ($[7] !== intl || $[8] !== isConfluence) {
                    t2 = isConfluence ? intl.formatMessage($6b6b665bcf70315b$export$defe85febe8b728c.noResultsConfluenceCreateOption) : "";
                    $[7] = intl;
                    $[8] = isConfluence;
                    $[9] = t2;
                } else t2 = $[9];
                const intlConfCreate = t2;
                let t3;
                if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
                    t3 = (0, $gMc0m.default)([
                        "_otyrmgjw _clfdidpf _11pqidpf _q0a5idpf _c3k8idpf"
                    ]);
                    $[10] = t3;
                } else t3 = $[10];
                let t4;
                if ($[11] !== intlConfCreate || $[12] !== intlDescription) {
                    t4 = /*#__PURE__*/ $42omo.createElement("span", null, intlDescription, " ", intlConfCreate);
                    $[11] = intlConfCreate;
                    $[12] = intlDescription;
                    $[13] = t4;
                } else t4 = $[13];
                const t5 = /*#__PURE__*/ $42omo.createElement((0, $abC4X.default), {
                    testId: $6b6b665bcf70315b$export$800daf5fbbe96aff.emptyStateNoResults,
                    header: intl.formatMessage($6b6b665bcf70315b$export$defe85febe8b728c.noResults, {
                        productName: productDetails.productName
                    }),
                    description: t4,
                    renderImage: $6b6b665bcf70315b$var$_temp
                });
                let t6;
                if ($[14] !== t3 || $[15] !== t5) {
                    t6 = /*#__PURE__*/ $42omo.createElement("div", {
                        className: t3
                    }, t5);
                    $[14] = t3;
                    $[15] = t5;
                    $[16] = t6;
                } else t6 = $[16];
                t1 = t6;
                break bb0;
            }
        }
        $[0] = cloudId;
        $[1] = data;
        $[2] = intl;
        $[3] = isConfluence;
        $[4] = isMultisiteSearch;
        $[5] = product;
        $[6] = t1;
    } else t1 = $[6];
    if (t1 !== Symbol.for("react.early_return_sentinel")) return t1;
    return null;
} : ({ product: product, action: action, cloudId: cloudId, isMultisiteSearch: isMultisiteSearch })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { data: data } = (0, $kiOFr.useAvailableSites)();
    const isConfluence = product === 'confluence'; // confluence has some special cases
    const productDetails = $6b6b665bcf70315b$export$dc8a6c8f6bc81cdd(product);
    if (!productDetails) return null; // unsupported product
     // find the first matching site for this product
    const firstMatchingSite = data.find($6b6b665bcf70315b$export$5e557b52f4095909(productDetails.availableSitesProduct, cloudId, isMultisiteSearch));
    if (firstMatchingSite) {
        let baseUrl = firstMatchingSite.url; // Confluence is a special case where the baseUrl is the same as Jira's, so we need to add the path
        if (isConfluence) baseUrl += '/wiki';
        const intlDescription = intl.formatMessage(productDetails.description, {
            productName: productDetails.productName,
            link: (str)=>/*#__PURE__*/ $42omo.createElement((0, $2Nwuj.default), {
                    href: baseUrl
                }, str)
        }); // Confluence is a special case because it has an optional "create", which we'll list as a call to action
        const intlConfCreate = isConfluence ? intl.formatMessage($6b6b665bcf70315b$export$defe85febe8b728c.noResultsConfluenceCreateOption) : '';
        return /*#__PURE__*/ $42omo.createElement("div", {
            className: (0, $gMc0m.default)([
                "_otyrmgjw _clfdidpf _11pqidpf _q0a5idpf _c3k8idpf"
            ])
        }, /*#__PURE__*/ $42omo.createElement((0, $abC4X.default), {
            testId: $6b6b665bcf70315b$export$800daf5fbbe96aff.emptyStateNoResults,
            header: intl.formatMessage($6b6b665bcf70315b$export$defe85febe8b728c.noResults, {
                productName: productDetails.productName
            }),
            description: /*#__PURE__*/ $42omo.createElement("span", null, intlDescription, " ", intlConfCreate),
            renderImage: ()=>/*#__PURE__*/ $42omo.createElement((0, $4CdHI.EmptyStateNoResultsSVG), null)
        }));
    }
    return null;
};
const $6b6b665bcf70315b$export$dc8a6c8f6bc81cdd = (product)=>{
    switch(product){
        case 'confluence':
            return {
                availableSitesProduct: (0, $kSC7A.AvailableSitesProductType).CONFLUENCE,
                productName: 'Confluence',
                description: $6b6b665bcf70315b$export$defe85febe8b728c.noResultsConfluenceDescription
            };
        case 'jira':
            return {
                availableSitesProduct: (0, $kSC7A.AvailableSitesProductType).JIRA_SOFTWARE,
                productName: 'Jira',
                description: (0, $g9Jfe.fg)('jira-issue-terminology-update-m4') ? $6b6b665bcf70315b$export$defe85febe8b728c.noResultsJiraDescriptionIssueTerminologyRefreshM4 : $6b6b665bcf70315b$export$defe85febe8b728c.noResultsJiraDescription
            };
        case 'atlas':
            return {
                availableSitesProduct: (0, $kSC7A.AvailableSitesProductType).ATLAS,
                productName: 'Atlas',
                description: $6b6b665bcf70315b$export$defe85febe8b728c.noResultsDefaultDescription
            };
        default:
            return undefined;
    }
};
const $6b6b665bcf70315b$export$5e557b52f4095909 = (availableSitesProduct, cloudId, isMultisiteSearch)=>{
    return (site)=>{
        // if the product doesn't match, this site doesn't match
        if (!site.products.includes(availableSitesProduct)) return false;
         // if the cloudId is undefined, this site matches (match everything)
        if (!cloudId) return true;
         // if we're mutlisite, match everything - this is probably a mistake,
        // but I'm not going to fix that here, and sticking to consistency with AtlassianLinkPickerPlugin.getRecentItems
        if (isMultisiteSearch) return true;
         // otherwise the site has to match the cloudId
        return site.cloudId === cloudId;
    };
};
function $6b6b665bcf70315b$var$_temp() {
    return /*#__PURE__*/ $42omo.createElement((0, $4CdHI.EmptyStateNoResultsSVG), null);
}
module.exports["EmptyStateNoResults"] = $6b6b665bcf70315b$export$e661eeb828fb7b2;

});

parcelRegister("kiOFr", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kSC7A = parcelRequire("kSC7A");


var $f8S0G = parcelRequire("f8S0G");


var $hBNGD = parcelRequire("hBNGD");


var $inPa6 = parcelRequire("inPa6");


var $g9Jfe = parcelRequire("g9Jfe");


var $bZKB2 = parcelRequire("bZKB2");


var $6fCTI = parcelRequire("6fCTI");

const $78f887db99bd3113$var$AVAILABLE_SITES_PATH = '/gateway/api/available-sites';
const $78f887db99bd3113$var$AVAILABLE_SITES_UNIT_COMPLIANT_PATH = '/gateway/api/experimental/available-sites';
const $78f887db99bd3113$var$ACCESSIBLE_PRODUCTS_PATH = '/gateway/api/v2/accessible-products';
const $78f887db99bd3113$var$ACCESSIBLE_PRODUCTS_UNIT_COMPLIANT_PATH = '/gateway/api/experimental/v2/accessible-products';
const $78f887db99bd3113$var$defaultProducts = [
    (0, $kSC7A.AvailableSitesProductType).WHITEBOARD,
    (0, $kSC7A.AvailableSitesProductType).BEACON,
    (0, $kSC7A.AvailableSitesProductType).COMPASS,
    (0, $kSC7A.AvailableSitesProductType).CONFLUENCE,
    (0, $kSC7A.AvailableSitesProductType).JIRA_BUSINESS,
    (0, $kSC7A.AvailableSitesProductType).JIRA_INCIDENT_MANAGER,
    (0, $kSC7A.AvailableSitesProductType).JIRA_PRODUCT_DISCOVERY,
    (0, $kSC7A.AvailableSitesProductType).JIRA_SERVICE_DESK,
    (0, $kSC7A.AvailableSitesProductType).JIRA_SOFTWARE,
    (0, $kSC7A.AvailableSitesProductType).MERCURY,
    (0, $kSC7A.AvailableSitesProductType).OPSGENIE,
    (0, $kSC7A.AvailableSitesProductType).STATUS_PAGE,
    (0, $kSC7A.AvailableSitesProductType).ATLAS,
    (0, $kSC7A.AvailableSitesProductType).LOOM
];
const $78f887db99bd3113$export$3738ff0cbe469211 = ({ gatewayBaseUrl: gatewayBaseUrl } = {})=>{
    const [state, setState] = (0, $42omo.useState)({
        data: [],
        loading: true
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        const fetchSites = async ()=>{
            try {
                const { sites: sites } = await $78f887db99bd3113$var$getAvailableSites({
                    products: $78f887db99bd3113$var$defaultProducts,
                    gatewayBaseUrl: gatewayBaseUrl
                });
                setState({
                    // TODO As part of NAVX-5287 (FG cleanup) remove the map and go back to `data: sites`
                    // As isVertigo be removed in same PR it doesn't matter if data will be back again.
                    data: (0, $g9Jfe.fg)('platform_lp_kill_isvertigo_and_vortexmode') ? sites.map((site)=>({
                            ...site,
                            isVertigo: undefined
                        })) : sites,
                    loading: false,
                    error: undefined
                });
            } catch (err) {
                createAnalyticsEvent((0, $f8S0G.default)('operational.getAvailableSitesResolve.failed', (0, $6fCTI.getOperationFailedAttributes)(err))).fire((0, $hBNGD.ANALYTICS_CHANNEL));
                const error = err instanceof Error ? err : new Error('unknown error');
                setState({
                    data: [],
                    loading: false,
                    error: error
                });
            }
        };
        fetchSites();
    }, [
        createAnalyticsEvent,
        gatewayBaseUrl
    ]);
    return state;
};
const $78f887db99bd3113$export$bd4055e8b60f8535 = (data)=>{
    const sites = [];
    data.products.forEach((product)=>{
        product.workspaces.forEach((workspace)=>{
            const currentSite = sites.find((site)=>site.cloudId === workspace.cloudId);
            if (currentSite) {
                currentSite.products.push(product.productId);
                return currentSite;
            }
            sites.push({
                avatarUrl: workspace.workspaceAvatarUrl,
                cloudId: workspace.cloudId,
                displayName: workspace.workspaceDisplayName,
                isVertigo: (0, $g9Jfe.fg)('platform_lp_kill_isvertigo_and_vortexmode') ? undefined : workspace.vortexMode === 'ENABLED',
                products: [
                    product.productId
                ],
                url: workspace.cloudUrl
            });
        });
    });
    return sites;
};
const $78f887db99bd3113$export$3f59b707a86875c4 = ({ gatewayBaseUrl: gatewayBaseUrl })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isMounted = (0, $bZKB2.useIsMounted)();
    const [state, setState] = (0, $42omo.useState)({
        data: [],
        loading: true
    });
    (0, $42omo.useEffect)(()=>{
        const fetchSites = async ()=>{
            try {
                const response = await $78f887db99bd3113$var$getAccessibleProducts({
                    products: $78f887db99bd3113$var$defaultProducts,
                    gatewayBaseUrl: gatewayBaseUrl
                });
                if (isMounted()) setState({
                    data: $78f887db99bd3113$export$bd4055e8b60f8535(response.data),
                    loading: false,
                    error: undefined
                });
            } catch (error) {
                if (isMounted()) setState({
                    data: [],
                    loading: false,
                    error: error
                });
            }
        };
        fetchSites();
    }, [
        createAnalyticsEvent,
        gatewayBaseUrl,
        isMounted
    ]);
    return state;
};
async function $78f887db99bd3113$var$getAvailableSites({ products: products, gatewayBaseUrl: gatewayBaseUrl }) {
    const availableSitesPath = (0, $g9Jfe.fg)('linking_platform_site_picker_api_unit_compliant') ? $78f887db99bd3113$var$AVAILABLE_SITES_UNIT_COMPLIANT_PATH : $78f887db99bd3113$var$AVAILABLE_SITES_PATH;
    const requestConfig = {
        method: 'POST',
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            products: products
        })
    };
    const response = await window.fetch(gatewayBaseUrl ? `${gatewayBaseUrl}${availableSitesPath}` : availableSitesPath, requestConfig);
    if (response.ok) return response.json();
    throw response;
}
async function $78f887db99bd3113$var$getAccessibleProducts({ products: products, gatewayBaseUrl: gatewayBaseUrl }) {
    const accessibleProductsPath = (0, $g9Jfe.fg)('linking_platform_site_picker_api_unit_compliant') ? $78f887db99bd3113$var$ACCESSIBLE_PRODUCTS_UNIT_COMPLIANT_PATH : $78f887db99bd3113$var$ACCESSIBLE_PRODUCTS_PATH;
    const requestConfig = {
        method: 'POST',
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            productIds: products,
            permissionIds: []
        })
    };
    const response = await window.fetch(gatewayBaseUrl ? `${gatewayBaseUrl}${accessibleProductsPath}` : accessibleProductsPath, requestConfig);
    if (response.ok) return response.json();
    throw response;
}
module.exports["useAvailableSites"] = $78f887db99bd3113$export$3738ff0cbe469211;
module.exports["mapAccessibleProductsToAvailableSites"] = $78f887db99bd3113$export$bd4055e8b60f8535;
module.exports["useAvailableSitesV2"] = $78f887db99bd3113$export$3f59b707a86875c4;

});

parcelRegister("kSC7A", function(module, exports) {
var $2f440bf1e6112d68$export$16bdf84263b17cf0 = /*#__PURE__*/ function(AvailableSitesProductType) {
    AvailableSitesProductType["WHITEBOARD"] = "atlassian-whiteboard";
    AvailableSitesProductType["BEACON"] = "beacon";
    AvailableSitesProductType["COMPASS"] = "compass";
    AvailableSitesProductType["CONFLUENCE"] = "confluence.ondemand";
    AvailableSitesProductType["JIRA_BUSINESS"] = "jira-core.ondemand";
    AvailableSitesProductType["JIRA_INCIDENT_MANAGER"] = "jira-incident-manager.ondemand";
    AvailableSitesProductType["JIRA_PRODUCT_DISCOVERY"] = "jira-product-discovery";
    AvailableSitesProductType["JIRA_SERVICE_DESK"] = "jira-servicedesk.ondemand";
    AvailableSitesProductType["JIRA_SOFTWARE"] = "jira-software.ondemand";
    AvailableSitesProductType["MERCURY"] = "mercury";
    AvailableSitesProductType["OPSGENIE"] = "opsgenie";
    AvailableSitesProductType["STATUS_PAGE"] = "statuspage";
    AvailableSitesProductType["ATLAS"] = "townsquare";
    AvailableSitesProductType["LOOM"] = "loom";
    return AvailableSitesProductType;
}({});
module.exports["AvailableSitesProductType"] = $2f440bf1e6112d68$export$16bdf84263b17cf0;

});

parcelRegister("f8S0G", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::bf8c5828b0e062cbddf6092143efece2>>
 * @codegenCommand yarn workspace @atlaskit/linking-common run codegen-analytics
 */ function $4a22b51dcbeecd57$var$createEventPayload(eventKey, attributes) {
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        action: action,
        attributes: attributes
    };
}
var $4a22b51dcbeecd57$export$2e2bcd8739ae039 = $4a22b51dcbeecd57$var$createEventPayload;
module.exports["default"] = $4a22b51dcbeecd57$export$2e2bcd8739ae039;

});

parcelRegister("hBNGD", function(module, exports) {
const $eb5d052cb0327301$export$85183a312807388d = 'media';
const $eb5d052cb0327301$export$60efea3f80310017 = 'wide';
module.exports["ANALYTICS_CHANNEL"] = $eb5d052cb0327301$export$85183a312807388d;
module.exports["DATASOURCE_DEFAULT_LAYOUT"] = $eb5d052cb0327301$export$60efea3f80310017;

});

parcelRegister("bZKB2", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $d79b64f48ff0234f$export$80c2a3957bcb42ea() {
    const isMounted = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return (0, $42omo.useCallback)(()=>isMounted.current, []);
}
module.exports["useIsMounted"] = $d79b64f48ff0234f$export$80c2a3957bcb42ea;

});

parcelRegister("6fCTI", function(module, exports) {

var $6mn0G = parcelRequire("6mn0G");

const $9cbe6bde573cd7a4$var$getUrlPath = (url)=>{
    try {
        return new URL(url).pathname;
    } catch  {
        return 'Failed to parse pathname from url';
    }
};
const $9cbe6bde573cd7a4$export$294520aca64d4e59 = (error)=>{
    if (error instanceof Response) return {
        traceId: (0, $6mn0G.getTraceId)(error),
        status: error.status,
        path: $9cbe6bde573cd7a4$var$getUrlPath(error.url)
    };
    return {
        traceId: null,
        status: null,
        path: null
    };
};
const $9cbe6bde573cd7a4$export$e19f9f08a6d79fd2 = (error)=>{
    if (error instanceof Response) return 'NetworkError';
    if (error instanceof Error) return error.name;
    return typeof error;
};
const $9cbe6bde573cd7a4$export$b2d107ab31565d0b = (err)=>{
    if (err instanceof Response) return {
        error: 'NetworkError',
        errorType: 'NetworkError',
        ...$9cbe6bde573cd7a4$export$294520aca64d4e59(err)
    };
    const error = err instanceof Error ? err : new Error('unknown error');
    return {
        error: error.name,
        errorType: error.name,
        traceId: null,
        status: null,
        path: null
    };
};
module.exports["getOperationFailedAttributes"] = $9cbe6bde573cd7a4$export$b2d107ab31565d0b;

});

parcelRegister("6mn0G", function(module, exports) {
function $ef5055edddfff711$export$e88cb5bfb57ce9c4(response) {
    try {
        return response.headers.get('x-trace-id') ?? response.headers.get('atl-traceid') ?? null;
    } catch  {
        return null;
    }
}
module.exports["getTraceId"] = $ef5055edddfff711$export$e88cb5bfb57ce9c4;

});

parcelRegister("4CdHI", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $c4f341a96ee4101f$var$noResultsSVGStyles = null;
const $c4f341a96ee4101f$export$88f98178b806da03 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $42omo.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 96 96",
            className: (0, $gMc0m.default)([
                "_1bsb16xz _4t3i16xz _19pkidpf _2hwx1wug _otyrpxbi _18u01wug _1e0c1ule"
            ])
        }, /*#__PURE__*/ $42omo.createElement("path", {
            fill: "#FCA700",
            d: "M74.189 55.386c.318-1.787.485-3.69.485-5.697a32.59 32.59 0 0 0-.496-5.774c-1.933-10.773-9.418-17.412-19.912-19.12-1.79-.29-3.669-.44-5.62-.44s-3.994.161-5.854.472c-10.5 1.752-17.971 8.375-19.909 19.088a32.362 32.362 0 0 0-.5 5.774c0 2.039.169 3.91.49 5.697 1.923 10.7 9.4 17.333 19.919 19.089 1.86.31 3.815.471 5.854.471s3.83-.15 5.62-.44c10.512-1.71 18.003-8.36 19.923-19.12Z"
        }), /*#__PURE__*/ $42omo.createElement("path", {
            fill: "#1868DB",
            d: "M40.02 77.477c-.248 6.944 3.225 9.59 8.598 9.59 5.044 0 8.434-2.646 8.434-9.59V69.54H40.02v7.938Z"
        }), /*#__PURE__*/ $42omo.createElement("path", {
            fill: "#101214",
            d: "M50.807 58.42c-.07.901-.133 1.802-.175 2.702 0 0-.035.29-.077.758a42.187 42.187 0 0 0-.146 1.808c-.088 1.404-.119 3.044-.021 3.98a81.585 81.585 0 0 0 .14 7.037s.062.734.174 1.571c.108.838.255 1.784.377 2.214.147.537.283.876.377.939.206.125.181-.862-.14-3.655.007-.035.007-.15.021-.164-.38-2.954-.248-5.83-.21-8.85-.052.039-.09-.063-.059-.157l.063.035c-.073-2.021.206-3.264.144-5.121 0 0 .066.216.066.22.122-1.571.314-3.292.576-5.052.136-.851.377-1.703.914-2.251.27-.276.615-.485.964-.562.349-.077.691-.014.97.188.283.2.507.53.618.901.056.185.087.377.087.566 0 .195-.024.397-.07.596-.184.8-.708 1.564-1.284 2.228a9.32 9.32 0 0 1-2.01 1.665c-.748.43-1.533.76-2.322.995h.035l-.01.014c.15-.032.44-.102.792-.192.335-.13.754-.245 1.113-.437.182-.09.367-.167.527-.258l.426-.255c.252-.143.395-.258.395-.258-.796.796-1.92 1.354-3.11 1.64-1.194.29-2.444.322-3.624.213l.024-.08c1.016.098 1.924-.042 2.273-.129-.9.105-2.05.112-3.257-.164-.597-.147-1.218-.328-1.805-.621-.147-.07-.293-.144-.443-.213l-.42-.262a4.987 4.987 0 0 1-.785-.573c-.474-.433-.88-.953-1.138-1.5a3.304 3.304 0 0 1-.258-.832 2.151 2.151 0 0 1 .038-.782c.143-.488.458-.88.866-1.078.402-.213.859-.266 1.257-.245-.038-.038-.31-.038-.594-.003-.279.038-.565.112-.715.084.74-.356 1.69-.283 2.426.059-.028.06-.143.035-.262-.007-.122-.031-.251-.077-.297-.08.144.073.754.223 1.362.83.286.3.586.751.803 1.285.22.541.373 1.184.454 1.896.083.712.097 1.487.09 2.307 0 .82-.017 1.672-.056 2.542a91.086 91.086 0 0 1-.373 5.257c-.339 3.453-.785 6.622-.992 8.486-.209 1.864-.195 2.416.213.618l.042.196c.308-1.875.559-3.428.946-5.373.025-.279.042-.31-.024-.317 0-.074-.004-.2-.038-.171-.168.007-.028-.597 0-.866.237.195.443-1.33.551-3.016.115-1.683.108-3.523.136-3.952.262-.157.077-1.69.185-2.206.007.038.063.268.07.3.042-.115.06-.684.042-1.435-.01-.747-.056-1.69-.196-2.541-.254-1.718-1.096-2.912-.436-1.97a4.525 4.525 0 0 0-.967-1.608 3.86 3.86 0 0 0-1.83-1.006 3.41 3.41 0 0 0-1.12-.094 2.874 2.874 0 0 0-1.155.321c-.37.196-.698.496-.936.859a2.7 2.7 0 0 0-.405 1.225c-.07.883.27 1.704.723 2.395.227.349.503.663.8.956.296.287.635.566.99.772l.531.325c.182.097.374.181.563.272.37.195.778.3 1.169.447.806.213 1.637.384 2.478.39l.315.015.314-.01.628-.029.622-.08.31-.042.308-.066.61-.136.597-.189.297-.094.29-.119.572-.24c1.487-.727 2.814-1.778 3.718-3.104.45-.657.828-1.407.911-2.245.087-.841-.188-1.71-.796-2.314-.303-.3-.712-.52-1.141-.59a2.392 2.392 0 0 0-1.232.129c-.744.283-1.32.845-1.673 1.46l.067-.06c-.056.073-.16.324-.217.37a7.214 7.214 0 0 0-.258 1.016c-.07.39-.119.81-.157 1.19l-.133 1.39-.003-.008Zm-4.675 3.376s-.014.01-.007.014c0-.014-.314-.063-.635-.108a8.793 8.793 0 0 1-.66-.154l.028-.077c.629.12 1.655.315 2.196.416.272.06.422.08.325.105-.098.028-.447.003-1.145-.105-.098.007-.091-.063-.105-.094l.003.003Zm-4.726-7.128c.213-.07.453-.126.719-.14a2.898 2.898 0 0 0-1.061.401c-.329.213-.597.52-.772.887-.373.733-.265 1.655.108 2.426.374.779.957 1.47 1.655 1.976.175.126.363.23.541.346l.272.167c.095.05.189.091.283.137.189.087.377.174.566.254.195.063.387.123.576.185-.573.018-1.47-.324-2.28-.872-.824-.566-1.435-1.418-1.735-2.053-.366-.6-.572-1.445-.342-2.217.119-.377.332-.712.593-.97.259-.266.587-.42.88-.52l-.003-.007ZM45.944 70.1l.042.01-.01.102s-.025-.014-.029-.035a.14.14 0 0 1-.003-.077Zm5.26-13.182c-.041-.223.147-1.022.179-.464-.05.133-.046.538-.178.464Zm-6.678-1.63c.039-.06.283.073.475.272.2.196.315.444.241.496a4.06 4.06 0 0 0-.715-.768Zm6.078 9.51c.133.286-.028.198-.122.29.025-.07.042-.326.108-.27l.014-.02Zm0 4.953c.074.07.122.349.13.482-.046.342-.19-.325-.13-.482Zm.527 8.14c.08 0 .13.193.056.256-.063-.014-.133-.245-.045-.287 0 0-.01.014-.01.032Zm-5.058-18.204c-.13-.133-.164-.433-.199-.761-.031-.328-.073-.685-.164-.915.126.024.202.265.244.552.042.286.046.61.084.799.014.136.025.24.032.321l.003.004Zm9.635-4.217c-.105.007-.119-.22-.182-.482-.056-.265-.185-.559-.296-.663l.07-.046c.279.374.44.674.408 1.173v.021-.003Zm-15.158.576c.014.097-.031.195-.066.303-.028.109-.08.217-.077.307-.028 0-.052-.052-.06-.125 0-.07.008-.164.025-.255.06-.171.14-.314.182-.234l-.004.004Zm5.254 5.264c.025.133-.394.017-.513-.01.09 0 .258-.05.36-.039.07.01.083.028.153.049Zm9.97-5.474a3.445 3.445 0 0 1-.363 1.18l-.07-.049c.182-.373.308-.76.35-1.152l.08.018.003.003Zm-2.203 3.327-.055-.063c.363-.464.558-.366.066.053l-.01.01Zm-.984-4.776c.042-.038.108-.1.147-.14.29-.264.276-.146.178-.02-.098.125-.248.3-.328.16h.003Zm-1.065 4.2c0 .087.014.206 0 .297-.08.607-.202-.091 0-.297ZM38.864 13.967l-.233-.314s-.112-.65-.392-.828l-.254-.946s-.189-.366-.353-.44a.488.488 0 0 0-.29-.041c-.17.038-.265.216-.073.565-.007.007-.014.028-.028.035.262.35.185.8.353 1.19.045-.02.09-.02.07 0l-.063.018c.216.223.08.457.373.628h-.09c.335.82.656 1.98 1.075 2.845l.007-.007h.01c.032-.104-.024-.537-.024-.537.401.195.216.646.342.96l-.08.024a.659.659 0 0 0-.179-.286c.07.534.405 1.536.699 1.969.055-.035-.13-.136.052-.241.045.122.119.234.154.35-.126.044-.105-.04-.133-.043-.066.248 1.229 4.336 1.42 3.184h.074c-.06-.258-.112-.471-.077-.775-.024-.032-.01-.042-.077-.018-.014-.006-.038-.017-.062 0-.157.06-.123-.041-.14-.076.506-.13-.237-.824-.258-.943.227-.105-.07-.223.003-.328.01 0 .073.014.084.014.13-.115-.646-.97-.255-.785.07-1.358-1.288-3.296-1.316-4.727l-.024.02s-.021-.038.01-.059c-.14-.094-.328-.401-.328-.401l.003-.007Zm.768 3.034s.014 0 .014-.004c-.024.01.05.168.046.178l-.077.028c-.21-.112.185-.684.084-.237.024.007-.042.028-.067.041v-.006Zm.514 1.462c0 .032.007.063.014.101-.381-.293-.259-.91-.52-1.288.397.018.334.423.376.608.144.153.123.398.13.576v.003Zm.81 2.465.041-.014v.014s-.02.007-.024.007c-.01 0-.018 0-.014-.007h-.004Zm-2.203-6.696c.073.007.073.123-.074.098.014-.024-.063-.056.074-.098Zm1.448 4.692c.13-.045.203.084.028.147-.02-.046-.024-.098-.028-.147Zm-1.951-5.68c-.15.01.007-.031.087-.073-.014.018-.01.052-.077.066l-.01.007Zm-.314-.621c-.07.014-.126-.007-.136-.024.035-.063.188-.018.136.024Zm-.391-1.068c-.077.024-.112.007-.039-.025.056-.017.112 0 .025.035 0 0 .01-.003.014-.01Zm2.611 8.11c-.237.041-.101-.151-.185-.196.23-.063.108.115.164.153a.229.229 0 0 0 .021.042Zm-1.445-4.235c-.2.073-.091-.126-.15-.157l.077-.028c.045.063.111.087.073.181v.004Zm.918 2.96c-.087 0-.032-.07-.042-.098.112-.038.171.07.038.098h.004Zm-.391-1.194c.119-.049.08.031.098.042-.028 0-.112 0-.115-.01 0-.011.01-.018.017-.032Zm-.433-1.742a1.4 1.4 0 0 1 .056.171l-.08.025a4.814 4.814 0 0 1-.056-.171l.08-.025Zm.077.6-.077.029c-.101-.056.094-.133.077-.028Zm-.423-1.284v.031c.05.112-.293.053 0-.031Zm-.29-.573s-.045-.014-.045-.028c-.02-.083.203-.062.046.028ZM51.327 14.843l-.007-.303s.28-.416.164-.67c.115-.22.237-.433.356-.65 0 0 .073-.304-.003-.44a.52.52 0 0 0-.196-.202c-.153-.087-.328-.053-.394.251-.01 0-.025.007-.042 0-.01.346-.335.541-.433.855.049.014.084.042.052.039l-.059-.028c.038.248-.206.3-.07.565l-.07-.052c-.206.65-.586 1.498-.694 2.238h.017c.08-.05.265-.332.265-.332.227.325-.164.492-.22.75l-.08-.024a.409.409 0 0 0 0-.262c-.223.356-.45 1.142-.412 1.55.063.004-.042-.143.164-.125-.02.097-.014.199-.038.29-.13-.032-.073-.074-.094-.088-.088.06-.356.89-.468 1.63-.112.74-.087 1.376.244 1.027l.067.028c.059-.196.104-.357.272-.538-.007-.031.007-.031-.06-.042a.093.093 0 0 0-.055-.028c-.164-.024-.091-.077-.091-.108.506.122.16-.628.199-.716.248.032.042-.174.157-.206.007.007.06.039.066.046.16-.014-.1-.894.15-.604.353-.405.482-1.047.632-1.704.147-.653.321-1.32.702-1.72h-.032s.008-.036.042-.029c-.059-.125-.041-.401-.041-.401l.01.003Zm-1.002 2.137.014.003c-.024-.007-.045.126-.052.13l-.08-.025c-.116-.175.506-.314.191-.101.018.014-.049-.004-.076-.01l.003.003Zm-.304 1.134c-.014.021-.024.042-.038.07-.185-.36.23-.68.203-1.033.32.206.07.415.01.551.045.161-.09.3-.178.412h.003Zm-.453 1.906.041.007v.01s-.028-.006-.03-.01c-.008 0-.015-.007-.011-.01v.003Zm1.522-5.093c.055.046-.01.112-.112.014.024-.007-.017-.066.112-.014Zm-1.243 3.498c.133.031.136.147-.049.105.007-.039.028-.07.049-.105ZM51.25 14.1c-.122-.08.025-.014.112.01-.021 0-.038.021-.098-.007h-.014V14.1Zm.115-.52c-.062-.035-.09-.08-.09-.095.063-.014.153.102.09.095Zm.332-.796c-.073-.035-.087-.063-.014-.035.052.028.084.07 0 .035h.014Zm-2.248 6.084c-.227-.08-.014-.14-.066-.21.23.064.034.123.07.172 0 .014-.004.024 0 .035l-.004.003Zm.946-3.288c-.2-.066-.004-.122-.035-.175l.077.028c0 .063.042.112-.042.143v.004Zm-.779 2.245c-.076-.042.01-.06.014-.08.116.027.112.125-.014.08Zm.276-.925c.126.03.053.059.06.076-.025-.017-.095-.056-.091-.066.003-.007.017-.003.031-.01Zm.566-1.254a.961.961 0 0 1-.046.13l-.076-.028c.014-.046.031-.088.045-.13l.077.028Zm-.262.388-.08-.025c-.056-.087.15-.028.08.025Zm.36-.97s-.018.013-.018.017c-.02.09-.265-.133.018-.018Zm.087-.486s-.028-.031-.021-.042c.031-.06.195.08.02.042ZM62.638 15.643l.17-.367s.528-.43.552-.768l.726-.708s.238-.353.227-.535a.489.489 0 0 0-.101-.279c-.115-.132-.321-.122-.541.224-.01 0-.028 0-.042-.007-.189.408-.628.572-.897.918.042.031.063.066.035.06l-.046-.046c-.097.303-.373.303-.384.649l-.042-.08c-.572.712-1.459 1.588-2.035 2.401h.01l.008.011c.108-.028.467-.293.467-.293.014.453-.474.52-.698.792l-.06-.056c.102-.111.165-.237.172-.303-.443.335-1.18 1.141-1.428 1.62.056.03.06-.182.237-.077-.087.1-.153.223-.237.314-.101-.087-.017-.112-.028-.14-.251.066-3.295 3.299-2.171 2.877l.035.066c.202-.185.37-.339.66-.464.017-.039.031-.032-.021-.077 0-.014-.004-.042-.028-.056-.126-.108-.021-.13 0-.164.36.38.621-.628.719-.709.202.147.167-.178.297-.164l.027.08c.165.056.559-1.064.584-.624 1.25-.632 2.335-2.821 3.606-3.575l-.028-.01s.028-.039.059-.021c.017-.172.203-.493.203-.493l-.008.004Zm-2.35 2.223s.007.011.01.011c-.02-.017-.125.13-.136.13l-.062-.057c0-.24.701-.185.254-.049.007.025-.045-.02-.07-.038l.004.003Zm-1.068 1.201a.653.653 0 0 0-.084.063c.08-.485.691-.694.904-1.117.175.36-.22.51-.363.646-.066.202-.3.314-.454.408h-.003Zm-1.815 1.973.031.028-.01.01s-.018-.017-.021-.024c-.004-.007-.007-.018 0-.018v.004Zm4.94-5.362c.03.07-.078.129-.123-.014.032 0 .021-.084.122.014Zm-3.51 3.676c.102.09.022.223-.118.097.032-.041.077-.07.119-.097Zm4.155-4.622c-.084-.126.032-.01.108.038-.02-.007-.052.018-.097-.035l-.01-.007v.004Zm.408-.594c-.045-.056-.052-.115-.041-.129.073 0 .104.157.041.13Zm.768-.89c-.059-.052-.059-.094.004-.045.042.042.056.097-.017.038 0 0 .01.007.013.007Zm-6.014 6.44c-.15-.188.087-.163.087-.265.168.172-.052.154-.06.224-.013.014-.02.028-.027.038v.004Zm3.1-3.434c-.161-.14.07-.143.07-.213l.062.056c-.035.073-.024.143-.129.157h-.003Zm-2.214 2.321c-.041-.077.05-.063.067-.084.087.08.017.189-.07.084h.003Zm.887-.953c.101.08.01.087.01.108-.01-.028-.055-.097-.045-.108.007-.007.021 0 .035 0Zm1.351-1.27c-.038.045-.084.094-.126.14l-.059-.057c.042-.045.084-.094.126-.136l.059.056v-.004Zm-.5.37-.062-.056c0-.12.164.014.063.052v.003Zm.947-1.027s-.025.01-.028.018c-.077.1-.185-.23.028-.018Zm.373-.548s-.007-.045 0-.056c.067-.06.15.147 0 .056Z"
        }), /*#__PURE__*/ $42omo.createElement("path", {
            fill: "#09326C",
            d: "M40.02 69.542v4.336a31.13 31.13 0 0 0 2.771.597c1.861.31 3.816.471 5.855.471 2.038 0 3.83-.15 5.62-.44a30.493 30.493 0 0 0 2.786-.586v-4.378H40.02Z"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ $42omo.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 96 96",
        className: (0, $gMc0m.default)([
            "_1bsb16xz _4t3i16xz _19pkidpf _2hwx1wug _otyrpxbi _18u01wug _1e0c1ule"
        ])
    }, /*#__PURE__*/ $42omo.createElement("path", {
        fill: "#FCA700",
        d: "M74.189 55.386c.318-1.787.485-3.69.485-5.697a32.59 32.59 0 0 0-.496-5.774c-1.933-10.773-9.418-17.412-19.912-19.12-1.79-.29-3.669-.44-5.62-.44s-3.994.161-5.854.472c-10.5 1.752-17.971 8.375-19.909 19.088a32.362 32.362 0 0 0-.5 5.774c0 2.039.169 3.91.49 5.697 1.923 10.7 9.4 17.333 19.919 19.089 1.86.31 3.815.471 5.854.471s3.83-.15 5.62-.44c10.512-1.71 18.003-8.36 19.923-19.12Z"
    }), /*#__PURE__*/ $42omo.createElement("path", {
        fill: "#1868DB",
        d: "M40.02 77.477c-.248 6.944 3.225 9.59 8.598 9.59 5.044 0 8.434-2.646 8.434-9.59V69.54H40.02v7.938Z"
    }), /*#__PURE__*/ $42omo.createElement("path", {
        fill: "#101214",
        d: "M50.807 58.42c-.07.901-.133 1.802-.175 2.702 0 0-.035.29-.077.758a42.187 42.187 0 0 0-.146 1.808c-.088 1.404-.119 3.044-.021 3.98a81.585 81.585 0 0 0 .14 7.037s.062.734.174 1.571c.108.838.255 1.784.377 2.214.147.537.283.876.377.939.206.125.181-.862-.14-3.655.007-.035.007-.15.021-.164-.38-2.954-.248-5.83-.21-8.85-.052.039-.09-.063-.059-.157l.063.035c-.073-2.021.206-3.264.144-5.121 0 0 .066.216.066.22.122-1.571.314-3.292.576-5.052.136-.851.377-1.703.914-2.251.27-.276.615-.485.964-.562.349-.077.691-.014.97.188.283.2.507.53.618.901.056.185.087.377.087.566 0 .195-.024.397-.07.596-.184.8-.708 1.564-1.284 2.228a9.32 9.32 0 0 1-2.01 1.665c-.748.43-1.533.76-2.322.995h.035l-.01.014c.15-.032.44-.102.792-.192.335-.13.754-.245 1.113-.437.182-.09.367-.167.527-.258l.426-.255c.252-.143.395-.258.395-.258-.796.796-1.92 1.354-3.11 1.64-1.194.29-2.444.322-3.624.213l.024-.08c1.016.098 1.924-.042 2.273-.129-.9.105-2.05.112-3.257-.164-.597-.147-1.218-.328-1.805-.621-.147-.07-.293-.144-.443-.213l-.42-.262a4.987 4.987 0 0 1-.785-.573c-.474-.433-.88-.953-1.138-1.5a3.304 3.304 0 0 1-.258-.832 2.151 2.151 0 0 1 .038-.782c.143-.488.458-.88.866-1.078.402-.213.859-.266 1.257-.245-.038-.038-.31-.038-.594-.003-.279.038-.565.112-.715.084.74-.356 1.69-.283 2.426.059-.028.06-.143.035-.262-.007-.122-.031-.251-.077-.297-.08.144.073.754.223 1.362.83.286.3.586.751.803 1.285.22.541.373 1.184.454 1.896.083.712.097 1.487.09 2.307 0 .82-.017 1.672-.056 2.542a91.086 91.086 0 0 1-.373 5.257c-.339 3.453-.785 6.622-.992 8.486-.209 1.864-.195 2.416.213.618l.042.196c.308-1.875.559-3.428.946-5.373.025-.279.042-.31-.024-.317 0-.074-.004-.2-.038-.171-.168.007-.028-.597 0-.866.237.195.443-1.33.551-3.016.115-1.683.108-3.523.136-3.952.262-.157.077-1.69.185-2.206.007.038.063.268.07.3.042-.115.06-.684.042-1.435-.01-.747-.056-1.69-.196-2.541-.254-1.718-1.096-2.912-.436-1.97a4.525 4.525 0 0 0-.967-1.608 3.86 3.86 0 0 0-1.83-1.006 3.41 3.41 0 0 0-1.12-.094 2.874 2.874 0 0 0-1.155.321c-.37.196-.698.496-.936.859a2.7 2.7 0 0 0-.405 1.225c-.07.883.27 1.704.723 2.395.227.349.503.663.8.956.296.287.635.566.99.772l.531.325c.182.097.374.181.563.272.37.195.778.3 1.169.447.806.213 1.637.384 2.478.39l.315.015.314-.01.628-.029.622-.08.31-.042.308-.066.61-.136.597-.189.297-.094.29-.119.572-.24c1.487-.727 2.814-1.778 3.718-3.104.45-.657.828-1.407.911-2.245.087-.841-.188-1.71-.796-2.314-.303-.3-.712-.52-1.141-.59a2.392 2.392 0 0 0-1.232.129c-.744.283-1.32.845-1.673 1.46l.067-.06c-.056.073-.16.324-.217.37a7.214 7.214 0 0 0-.258 1.016c-.07.39-.119.81-.157 1.19l-.133 1.39-.003-.008Zm-4.675 3.376s-.014.01-.007.014c0-.014-.314-.063-.635-.108a8.793 8.793 0 0 1-.66-.154l.028-.077c.629.12 1.655.315 2.196.416.272.06.422.08.325.105-.098.028-.447.003-1.145-.105-.098.007-.091-.063-.105-.094l.003.003Zm-4.726-7.128c.213-.07.453-.126.719-.14a2.898 2.898 0 0 0-1.061.401c-.329.213-.597.52-.772.887-.373.733-.265 1.655.108 2.426.374.779.957 1.47 1.655 1.976.175.126.363.23.541.346l.272.167c.095.05.189.091.283.137.189.087.377.174.566.254.195.063.387.123.576.185-.573.018-1.47-.324-2.28-.872-.824-.566-1.435-1.418-1.735-2.053-.366-.6-.572-1.445-.342-2.217.119-.377.332-.712.593-.97.259-.266.587-.42.88-.52l-.003-.007ZM45.944 70.1l.042.01-.01.102s-.025-.014-.029-.035a.14.14 0 0 1-.003-.077Zm5.26-13.182c-.041-.223.147-1.022.179-.464-.05.133-.046.538-.178.464Zm-6.678-1.63c.039-.06.283.073.475.272.2.196.315.444.241.496a4.06 4.06 0 0 0-.715-.768Zm6.078 9.51c.133.286-.028.198-.122.29.025-.07.042-.326.108-.27l.014-.02Zm0 4.953c.074.07.122.349.13.482-.046.342-.19-.325-.13-.482Zm.527 8.14c.08 0 .13.193.056.256-.063-.014-.133-.245-.045-.287 0 0-.01.014-.01.032Zm-5.058-18.204c-.13-.133-.164-.433-.199-.761-.031-.328-.073-.685-.164-.915.126.024.202.265.244.552.042.286.046.61.084.799.014.136.025.24.032.321l.003.004Zm9.635-4.217c-.105.007-.119-.22-.182-.482-.056-.265-.185-.559-.296-.663l.07-.046c.279.374.44.674.408 1.173v.021-.003Zm-15.158.576c.014.097-.031.195-.066.303-.028.109-.08.217-.077.307-.028 0-.052-.052-.06-.125 0-.07.008-.164.025-.255.06-.171.14-.314.182-.234l-.004.004Zm5.254 5.264c.025.133-.394.017-.513-.01.09 0 .258-.05.36-.039.07.01.083.028.153.049Zm9.97-5.474a3.445 3.445 0 0 1-.363 1.18l-.07-.049c.182-.373.308-.76.35-1.152l.08.018.003.003Zm-2.203 3.327-.055-.063c.363-.464.558-.366.066.053l-.01.01Zm-.984-4.776c.042-.038.108-.1.147-.14.29-.264.276-.146.178-.02-.098.125-.248.3-.328.16h.003Zm-1.065 4.2c0 .087.014.206 0 .297-.08.607-.202-.091 0-.297ZM38.864 13.967l-.233-.314s-.112-.65-.392-.828l-.254-.946s-.189-.366-.353-.44a.488.488 0 0 0-.29-.041c-.17.038-.265.216-.073.565-.007.007-.014.028-.028.035.262.35.185.8.353 1.19.045-.02.09-.02.07 0l-.063.018c.216.223.08.457.373.628h-.09c.335.82.656 1.98 1.075 2.845l.007-.007h.01c.032-.104-.024-.537-.024-.537.401.195.216.646.342.96l-.08.024a.659.659 0 0 0-.179-.286c.07.534.405 1.536.699 1.969.055-.035-.13-.136.052-.241.045.122.119.234.154.35-.126.044-.105-.04-.133-.043-.066.248 1.229 4.336 1.42 3.184h.074c-.06-.258-.112-.471-.077-.775-.024-.032-.01-.042-.077-.018-.014-.006-.038-.017-.062 0-.157.06-.123-.041-.14-.076.506-.13-.237-.824-.258-.943.227-.105-.07-.223.003-.328.01 0 .073.014.084.014.13-.115-.646-.97-.255-.785.07-1.358-1.288-3.296-1.316-4.727l-.024.02s-.021-.038.01-.059c-.14-.094-.328-.401-.328-.401l.003-.007Zm.768 3.034s.014 0 .014-.004c-.024.01.05.168.046.178l-.077.028c-.21-.112.185-.684.084-.237.024.007-.042.028-.067.041v-.006Zm.514 1.462c0 .032.007.063.014.101-.381-.293-.259-.91-.52-1.288.397.018.334.423.376.608.144.153.123.398.13.576v.003Zm.81 2.465.041-.014v.014s-.02.007-.024.007c-.01 0-.018 0-.014-.007h-.004Zm-2.203-6.696c.073.007.073.123-.074.098.014-.024-.063-.056.074-.098Zm1.448 4.692c.13-.045.203.084.028.147-.02-.046-.024-.098-.028-.147Zm-1.951-5.68c-.15.01.007-.031.087-.073-.014.018-.01.052-.077.066l-.01.007Zm-.314-.621c-.07.014-.126-.007-.136-.024.035-.063.188-.018.136.024Zm-.391-1.068c-.077.024-.112.007-.039-.025.056-.017.112 0 .025.035 0 0 .01-.003.014-.01Zm2.611 8.11c-.237.041-.101-.151-.185-.196.23-.063.108.115.164.153a.229.229 0 0 0 .021.042Zm-1.445-4.235c-.2.073-.091-.126-.15-.157l.077-.028c.045.063.111.087.073.181v.004Zm.918 2.96c-.087 0-.032-.07-.042-.098.112-.038.171.07.038.098h.004Zm-.391-1.194c.119-.049.08.031.098.042-.028 0-.112 0-.115-.01 0-.011.01-.018.017-.032Zm-.433-1.742a1.4 1.4 0 0 1 .056.171l-.08.025a4.814 4.814 0 0 1-.056-.171l.08-.025Zm.077.6-.077.029c-.101-.056.094-.133.077-.028Zm-.423-1.284v.031c.05.112-.293.053 0-.031Zm-.29-.573s-.045-.014-.045-.028c-.02-.083.203-.062.046.028ZM51.327 14.843l-.007-.303s.28-.416.164-.67c.115-.22.237-.433.356-.65 0 0 .073-.304-.003-.44a.52.52 0 0 0-.196-.202c-.153-.087-.328-.053-.394.251-.01 0-.025.007-.042 0-.01.346-.335.541-.433.855.049.014.084.042.052.039l-.059-.028c.038.248-.206.3-.07.565l-.07-.052c-.206.65-.586 1.498-.694 2.238h.017c.08-.05.265-.332.265-.332.227.325-.164.492-.22.75l-.08-.024a.409.409 0 0 0 0-.262c-.223.356-.45 1.142-.412 1.55.063.004-.042-.143.164-.125-.02.097-.014.199-.038.29-.13-.032-.073-.074-.094-.088-.088.06-.356.89-.468 1.63-.112.74-.087 1.376.244 1.027l.067.028c.059-.196.104-.357.272-.538-.007-.031.007-.031-.06-.042a.093.093 0 0 0-.055-.028c-.164-.024-.091-.077-.091-.108.506.122.16-.628.199-.716.248.032.042-.174.157-.206.007.007.06.039.066.046.16-.014-.1-.894.15-.604.353-.405.482-1.047.632-1.704.147-.653.321-1.32.702-1.72h-.032s.008-.036.042-.029c-.059-.125-.041-.401-.041-.401l.01.003Zm-1.002 2.137.014.003c-.024-.007-.045.126-.052.13l-.08-.025c-.116-.175.506-.314.191-.101.018.014-.049-.004-.076-.01l.003.003Zm-.304 1.134c-.014.021-.024.042-.038.07-.185-.36.23-.68.203-1.033.32.206.07.415.01.551.045.161-.09.3-.178.412h.003Zm-.453 1.906.041.007v.01s-.028-.006-.03-.01c-.008 0-.015-.007-.011-.01v.003Zm1.522-5.093c.055.046-.01.112-.112.014.024-.007-.017-.066.112-.014Zm-1.243 3.498c.133.031.136.147-.049.105.007-.039.028-.07.049-.105ZM51.25 14.1c-.122-.08.025-.014.112.01-.021 0-.038.021-.098-.007h-.014V14.1Zm.115-.52c-.062-.035-.09-.08-.09-.095.063-.014.153.102.09.095Zm.332-.796c-.073-.035-.087-.063-.014-.035.052.028.084.07 0 .035h.014Zm-2.248 6.084c-.227-.08-.014-.14-.066-.21.23.064.034.123.07.172 0 .014-.004.024 0 .035l-.004.003Zm.946-3.288c-.2-.066-.004-.122-.035-.175l.077.028c0 .063.042.112-.042.143v.004Zm-.779 2.245c-.076-.042.01-.06.014-.08.116.027.112.125-.014.08Zm.276-.925c.126.03.053.059.06.076-.025-.017-.095-.056-.091-.066.003-.007.017-.003.031-.01Zm.566-1.254a.961.961 0 0 1-.046.13l-.076-.028c.014-.046.031-.088.045-.13l.077.028Zm-.262.388-.08-.025c-.056-.087.15-.028.08.025Zm.36-.97s-.018.013-.018.017c-.02.09-.265-.133.018-.018Zm.087-.486s-.028-.031-.021-.042c.031-.06.195.08.02.042ZM62.638 15.643l.17-.367s.528-.43.552-.768l.726-.708s.238-.353.227-.535a.489.489 0 0 0-.101-.279c-.115-.132-.321-.122-.541.224-.01 0-.028 0-.042-.007-.189.408-.628.572-.897.918.042.031.063.066.035.06l-.046-.046c-.097.303-.373.303-.384.649l-.042-.08c-.572.712-1.459 1.588-2.035 2.401h.01l.008.011c.108-.028.467-.293.467-.293.014.453-.474.52-.698.792l-.06-.056c.102-.111.165-.237.172-.303-.443.335-1.18 1.141-1.428 1.62.056.03.06-.182.237-.077-.087.1-.153.223-.237.314-.101-.087-.017-.112-.028-.14-.251.066-3.295 3.299-2.171 2.877l.035.066c.202-.185.37-.339.66-.464.017-.039.031-.032-.021-.077 0-.014-.004-.042-.028-.056-.126-.108-.021-.13 0-.164.36.38.621-.628.719-.709.202.147.167-.178.297-.164l.027.08c.165.056.559-1.064.584-.624 1.25-.632 2.335-2.821 3.606-3.575l-.028-.01s.028-.039.059-.021c.017-.172.203-.493.203-.493l-.008.004Zm-2.35 2.223s.007.011.01.011c-.02-.017-.125.13-.136.13l-.062-.057c0-.24.701-.185.254-.049.007.025-.045-.02-.07-.038l.004.003Zm-1.068 1.201a.653.653 0 0 0-.084.063c.08-.485.691-.694.904-1.117.175.36-.22.51-.363.646-.066.202-.3.314-.454.408h-.003Zm-1.815 1.973.031.028-.01.01s-.018-.017-.021-.024c-.004-.007-.007-.018 0-.018v.004Zm4.94-5.362c.03.07-.078.129-.123-.014.032 0 .021-.084.122.014Zm-3.51 3.676c.102.09.022.223-.118.097.032-.041.077-.07.119-.097Zm4.155-4.622c-.084-.126.032-.01.108.038-.02-.007-.052.018-.097-.035l-.01-.007v.004Zm.408-.594c-.045-.056-.052-.115-.041-.129.073 0 .104.157.041.13Zm.768-.89c-.059-.052-.059-.094.004-.045.042.042.056.097-.017.038 0 0 .01.007.013.007Zm-6.014 6.44c-.15-.188.087-.163.087-.265.168.172-.052.154-.06.224-.013.014-.02.028-.027.038v.004Zm3.1-3.434c-.161-.14.07-.143.07-.213l.062.056c-.035.073-.024.143-.129.157h-.003Zm-2.214 2.321c-.041-.077.05-.063.067-.084.087.08.017.189-.07.084h.003Zm.887-.953c.101.08.01.087.01.108-.01-.028-.055-.097-.045-.108.007-.007.021 0 .035 0Zm1.351-1.27c-.038.045-.084.094-.126.14l-.059-.057c.042-.045.084-.094.126-.136l.059.056v-.004Zm-.5.37-.062-.056c0-.12.164.014.063.052v.003Zm.947-1.027s-.025.01-.028.018c-.077.1-.185-.23.028-.018Zm.373-.548s-.007-.045 0-.056c.067-.06.15.147 0 .056Z"
    }), /*#__PURE__*/ $42omo.createElement("path", {
        fill: "#09326C",
        d: "M40.02 69.542v4.336a31.13 31.13 0 0 0 2.771.597c1.861.31 3.816.471 5.855.471 2.038 0 3.83-.15 5.62-.44a30.493 30.493 0 0 0 2.786-.586v-4.378H40.02Z"
    }));
};
module.exports["EmptyStateNoResultsSVG"] = $c4f341a96ee4101f$export$88f98178b806da03;

});

parcelRegister("d5Nnx", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $930927a24c397c44$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    hyperlinkIconIssueLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconIssueLabel",
        defaultMessage: "Issue"
    },
    hyperlinkIconBugLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconBugLabel",
        defaultMessage: "Bug"
    },
    hyperlinkIconStoryLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconStoryLabel",
        defaultMessage: "Story"
    },
    hyperlinkIconTaskLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconTaskLabel",
        defaultMessage: "Task"
    },
    hyperlinkIconEpicLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconEpicLabel",
        defaultMessage: "Epic"
    },
    hyperlinkIconDashboardLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconDashboardLabel",
        defaultMessage: "Dashboard"
    },
    hyperlinkIconBoardLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconBoardLabel",
        defaultMessage: "Board"
    },
    hyperlinkIconProjectLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconProjectLabel",
        defaultMessage: "Task"
    },
    hyperlinkIconPlanLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconPlanLabel",
        defaultMessage: "Plan"
    },
    hyperlinkIconFilterLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconFilterLabel",
        defaultMessage: "Filter"
    },
    hyperlinkIconPageLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconPageLabel",
        defaultMessage: "Page"
    },
    hyperlinkIconBlogLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconBlogLabel",
        defaultMessage: "Blog"
    },
    hyperlinkIconWhiteboardLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconWhiteboardLabel",
        defaultMessage: "Whiteboard"
    },
    hyperlinkIconDatabaseLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconDatabaseLabel",
        defaultMessage: "Database"
    },
    hyperlinkIconEmbedLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconEmbedLabel",
        defaultMessage: "Smart Link"
    },
    hyperlinkIconLoomLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconLoomLabel",
        defaultMessage: "Loom"
    },
    hyperlinkIconLiveDocLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconLiveDocLabel",
        defaultMessage: "Live Doc"
    },
    story: {
        id: "fabric.linkPicker.story",
        defaultMessage: "Story"
    },
    epic: {
        id: "fabric.linkPicker.epic",
        defaultMessage: "Epic"
    },
    task: {
        id: "fabric.linkPicker.task",
        defaultMessage: "Task"
    },
    bug: {
        id: "fabric.linkPicker.bug",
        defaultMessage: "Bug"
    },
    subTask: {
        id: "fabric.linkPicker.subTask",
        defaultMessage: "Sub-task"
    },
    improvement: {
        id: "fabric.linkPicker.improvement",
        defaultMessage: "Improvement"
    },
    defaultAltText: {
        id: "fabric.linkPicker.defaultAltText",
        defaultMessage: "List item"
    },
    hyperlinkIconIssueLabelIssueTermRefresh: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconIssueLabel-issue-term-refresh",
        defaultMessage: "Work item"
    }
});
module.exports["messages"] = $930927a24c397c44$export$defe85febe8b728c;

});

parcelRegister("4LCen", function(module, exports) {

var $g9Jfe = parcelRequire("g9Jfe");


var $7MEO5 = parcelRequire("7MEO5");


var $3paC4 = parcelRequire("3paC4");


var $7dyLS = parcelRequire("7dyLS");

const $2fe1ecad5a015726$var$ANALYTICS_IDENTIFIER = 'link-picker';
const $2fe1ecad5a015726$var$JIRA_DASHBOARD_URL_PATTERN = new RegExp(/(.*)\/issues\/\?dashboard=(\d+)$/);
class $2fe1ecad5a015726$export$2e2bcd8739ae039 {
    getAriString(opt) {
        try {
            return new (0, $7MEO5.ResourceIdentifier)(opt).toString();
        } catch (e) {
            return '';
        }
    }
    confluencePageBlogResponseTransformer(response) {
        if (!response) return [];
        return response.results.map((item)=>{
            const result = {
                title: item.title,
                // The `item.url` is only the relative path so we need to prefix the `item.baseUrl`
                url: item.baseUrl + item.url,
                container: item.container.title,
                contentType: this.mapToContentType(item.content && item.content.type),
                updatedTimestamp: item.lastModified,
                objectId: this.cloudIds.length === 0 ? this.getAriString({
                    resourceOwner: 'confluence',
                    cloudId: this.cloudId,
                    resourceType: this.useConfluenceTypeInAri && item.content?.type || 'content',
                    resourceId: item.content && item.content.id
                }) : item.baseUrl + item.url
            };
            if (item.subtype) result.subtype = item.subtype;
            return result;
        });
    }
    getIconUrlFromAvatar(avatar) {
        if ('urls' in avatar) return avatar.urls['16x16'];
        else return avatar.url;
    }
    jiraResponseTransformer(response) {
        if (!response) return [];
        return response.results.map((item)=>{
            // The `item.url` here for Jira content is _usually_ absolute url, except for dashboard where the url is wrong
            // It respond with https://site/issues/?dashboard={dashboardId}, but the url needs to be
            // https://site/jira/dashboards/{dashboardId}
            const dashboardMatch = $2fe1ecad5a015726$var$JIRA_DASHBOARD_URL_PATTERN.exec(item.url);
            const url = dashboardMatch ? `${dashboardMatch[1]}/jira/dashboards/${dashboardMatch[2]}` : item.url;
            return {
                title: item.name,
                url: url,
                container: 'container' in item.attributes && item.attributes.container && item.attributes.container.title || '',
                contentType: this.mapToContentType(item.attributes['@type'], 'issueTypeName' in item.attributes ? item.attributes.issueTypeName : undefined),
                updatedTimestamp: 'updated' in item.attributes ? item.attributes.updated : undefined,
                iconUrl: 'avatar' in item.attributes && item.attributes.avatar ? this.getIconUrlFromAvatar(item.attributes.avatar) : undefined,
                objectId: this.cloudIds.length === 0 ? this.getAriString({
                    resourceOwner: 'jira',
                    cloudId: this.cloudId,
                    resourceType: item.attributes['@type'],
                    resourceId: item.id
                }) : url
            };
        });
    }
    townsquareProjectResponseTransformer(response) {
        if (!response) return [];
        const townsquareResponseToQuickSearch = (item)=>{
            const { id: id, title: title, url: url, iconUrl: iconUrl } = item;
            return {
                title: title,
                url: // The `item.url` in Townsquare/Atlas response is absolute url
                url,
                iconUrl: iconUrl,
                // There isn't any container like attribute in the response
                container: '',
                contentType: this.mapToContentType('townsquareProject'),
                objectId: (0, $g9Jfe.fg)('platform_link_picker_atlas_project_object_id_ari') ? id : url
            };
        };
        return response.results.map(townsquareResponseToQuickSearch);
    }
    townsquareGoalResponseTransformer(response) {
        if (!response) return [];
        const townsquareResponseToQuickSearch = (item)=>{
            const { id: id, title: title, url: url, iconUrl: iconUrl } = item;
            return {
                title: title,
                url: // The `item.url` in Townsquare/Atlas response is absolute url
                url,
                iconUrl: iconUrl,
                // There isn't any container like attribute in the response
                container: '',
                contentType: this.mapToContentType('townsquareGoal'),
                objectId: id
            };
        };
        return response.results.map(townsquareResponseToQuickSearch);
    }
    LoomResponseTransformer(response) {
        if (!response) return [];
        return response.results.map((item)=>({
                title: item.name,
                url: item.url,
                container: item.workspaceName,
                contentType: this.mapToContentType('loom'),
                objectId: item.url,
                updatedTimestamp: item.activityDate || item.createdAt
            }));
    }
    mapToContentType(type, subType) {
        switch(type){
            case 'issue':
                switch(subType){
                    case 'Bug':
                        return 'jira.issue.bug';
                    case 'Story':
                        return 'jira.issue.story';
                    case 'Task':
                        return 'jira.issue.task';
                    case 'Epic':
                        return 'jira.issue.epic';
                    default:
                        return 'jira.issue';
                }
            case 'project':
                return 'jira.project';
            case 'board':
                return 'jira.board';
            case 'filter':
                return 'jira.filter';
            case 'dashboard':
                return 'jira.dashboard';
            case 'townsquareProject':
                return 'townsquare.project';
            case 'townsquareGoal':
                return 'townsquare.goal';
            case 'page':
                return 'confluence.page';
            case 'blogpost':
                return 'confluence.blogpost';
            case 'whiteboard':
                return 'confluence.whiteboard';
            case 'database':
                return 'confluence.database';
            case 'embed':
                return 'confluence.embed';
            case 'loom':
                return 'loom.video';
            default:
                return 'default';
        }
    }
    async quickSearch(query, limit) {
        const result = await this.client.search({
            query: query,
            scopes: [
                this.scope
            ],
            analytics: {
                identifier: this.analyticsIdentifier
            },
            resultLimit: limit,
            sites: this.cloudIds
        });
        if (this.scope === (0, $7dyLS.Scope).ConfluencePageBlog || this.scope === (0, $7dyLS.Scope).ConfluencePageBlogWhiteboard || this.scope === (0, $7dyLS.Scope).ConfluenceContentType) {
            const scopeResult = result.response.retrieveScope(this.scope);
            return this.confluencePageBlogResponseTransformer(scopeResult);
        } else if (this.scope === (0, $7dyLS.Scope).JiraIssue || this.scope === (0, $7dyLS.Scope).JiraIssueDashboardBoardProjectFilter) {
            const scopeResult = result.response.retrieveScope(this.scope);
            return this.jiraResponseTransformer(scopeResult);
        } else if (this.scope === (0, $7dyLS.Scope).TownsquareProject) {
            const scopeResult = result.response.retrieveScope(this.scope);
            return this.townsquareProjectResponseTransformer(scopeResult);
        } else if (this.scope === (0, $7dyLS.Scope).TownsquareGoal) {
            const scopeResult = result.response.retrieveScope(this.scope);
            return this.townsquareGoalResponseTransformer(scopeResult);
        } else if (this.scope === (0, $7dyLS.Scope).Loom) {
            const scopeResult = result.response.retrieveScope(this.scope);
            return this.LoomResponseTransformer(scopeResult);
        } else throw new Error(`Unsupported scope - ${this.scope}`);
    }
    constructor(cloudId, scope, aggregatorUrl, analyticsIdentifier = $2fe1ecad5a015726$var$ANALYTICS_IDENTIFIER, useConfluenceTypeInAri = false, cloudIds = []){
        this.client = void 0;
        this.scope = void 0;
        this.cloudId = void 0;
        this.cloudIds = void 0;
        this.analyticsIdentifier = void 0;
        this.useConfluenceTypeInAri = void 0;
        switch(scope){
            case (0, $7dyLS.Scope).ConfluencePageBlog:
            case (0, $7dyLS.Scope).ConfluencePageBlogWhiteboard:
            case (0, $7dyLS.Scope).ConfluenceContentType:
            case (0, $7dyLS.Scope).JiraIssue:
            case (0, $7dyLS.Scope).JiraDashboard:
            case (0, $7dyLS.Scope).JiraIssueDashboardBoardProjectFilter:
            case (0, $7dyLS.Scope).TownsquareProject:
            case (0, $7dyLS.Scope).TownsquareGoal:
            case (0, $7dyLS.Scope).Loom:
                break;
            default:
                throw new Error(`Unsupported scope - ${scope}`);
        }
        this.scope = scope;
        this.cloudId = cloudId;
        this.cloudIds = cloudIds;
        this.analyticsIdentifier = analyticsIdentifier;
        this.useConfluenceTypeInAri = useConfluenceTypeInAri;
        const config = {
            cloudId: cloudId,
            aggregatorUrl: aggregatorUrl
        };
        this.client = (0, $3paC4.createClient)(config);
    }
}
module.exports["default"] = $2fe1ecad5a015726$export$2e2bcd8739ae039;

});

parcelRegister("3paC4", function(module, exports) {

var $dwp40 = parcelRequire("dwp40");


var $jppmC = parcelRequire("jppmC");

const $6b372c322d10f06f$var$MAX_SITES_INITIAL_QUERY = 3;
const $6b372c322d10f06f$var$limitToMaxSiteUsage = (sites = [])=>{
    return sites.slice(0, $6b372c322d10f06f$var$MAX_SITES_INITIAL_QUERY);
};
class $6b372c322d10f06f$var$AggregatorClient {
    async getAutoCorrection({ query: query }) {
        const cloudId = this.cloudId;
        // The language is hardcoded to 'en' as the backend does not support other languages
        // Also the frontend only auto corrects in English locale
        const body = {
            query: query,
            language: 'en',
            cloudId: cloudId
        };
        const response = await this.makePostRequest($6b372c322d10f06f$var$AggregatorClient.AUTO_CORRECT_API_URL, body);
        return response.fullCorrection;
    }
    async search({ query: query, context: context, scopes: scopes, modelParams: modelParams, resultLimit: resultLimit, filters: filters = [], experience: experience, sites: sites = [] }) {
        const cloudId = this.cloudId;
        const cloudIdsToFilterOn = sites.length > 0 ? sites : $6b372c322d10f06f$var$limitToMaxSiteUsage(this.siteMasterList).map((site)=>site.cloudId);
        const body = {
            query: query,
            cloudId: cloudId,
            limit: resultLimit,
            scopes: scopes,
            filters: filters,
            searchSession: context,
            ...modelParams.length > 0 ? {
                modelParams: modelParams
            } : {},
            experience: experience,
            cloudIds: cloudIdsToFilterOn
        };
        const { result: response, durationMs: requestDurationMs } = await (0, $jppmC.timed)(this.makePostRequest($6b372c322d10f06f$var$AggregatorClient.QUICKSEARCH_API_URL, body));
        return {
            response: {
                rawData: response,
                retrieveScope: (scope)=>// @ts-expect-error TS2367: This comparison appears to be unintentional because the types 'Scope' and 'SingleScope' have no overlap
                    response.scopes.find((s)=>s.id === scope) || null
            },
            requestDurationMs: requestDurationMs
        };
    }
    constructor({ url: url, cloudId: cloudId, siteMasterList: siteMasterList }){
        this.serviceConfig = void 0;
        this.cloudId = void 0;
        this.siteMasterList = void 0;
        this.makePostRequest = (path, body)=>{
            const options = {
                path: path,
                requestInit: {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(body)
                }
            };
            return (0, $dwp40.utils).requestService(this.serviceConfig, options);
        };
        this.serviceConfig = {
            url: url
        };
        this.cloudId = cloudId;
        this.siteMasterList = siteMasterList;
    }
}
$6b372c322d10f06f$var$AggregatorClient.QUICKSEARCH_API_URL = 'quicksearch/v1';
$6b372c322d10f06f$var$AggregatorClient.AUTO_CORRECT_API_URL = 'autocorrect';
const $6b372c322d10f06f$export$5d730b7aed1a3eb0 = ({ cloudId: cloudId, aggregatorUrl: aggregatorUrl, aggregatorHostName: aggregatorHostName })=>{
    const aggregatorClient = new $6b372c322d10f06f$var$AggregatorClient({
        cloudId: cloudId,
        url: aggregatorUrl || `${aggregatorHostName || ''}/gateway/api/xpsearch-aggregator`,
        siteMasterList: []
    });
    async function getAutoCorrection({ query: query }) {
        return aggregatorClient.getAutoCorrection({
            query: query
        });
    }
    async function search({ query: query, scopes: scopes, resultLimit: resultLimit, analytics: analytics, sites: sites = [] }) {
        return aggregatorClient.search({
            query: query,
            context: {
                sessionId: analytics.sessionId ? analytics.sessionId : 'not-applicable',
                referrerId: null
            },
            scopes: scopes,
            modelParams: [],
            resultLimit: resultLimit,
            filters: [],
            experience: `external-${analytics.identifier}`,
            sites: sites
        });
    }
    return {
        search: search,
        getAutoCorrection: getAutoCorrection
    };
};
module.exports["createClient"] = $6b372c322d10f06f$export$5d730b7aed1a3eb0;

});

parcelRegister("jppmC", function(module, exports) {
const $e3bb250125deb745$export$d35186a762cd39c8 = async (promise)=>{
    const startTime = Date.now();
    const result = await promise;
    const duration = Date.now() - startTime;
    return {
        result: result,
        durationMs: duration
    };
};
module.exports["timed"] = $e3bb250125deb745$export$d35186a762cd39c8;

});

parcelRegister("1MqUK", function(module, exports) {

var $7OCSv = parcelRequire("7OCSv");

const $13b92bff3b95cf64$export$d82137ca931458ca = ({ object: object, containers: containers, timestamp: timestamp })=>{
    let iconUrl = object.icon?.value || '';
    if (object.icon?.type === 'EMOJI') iconUrl = object.icon.fallback || '';
    const iconData = object.product === 'confluence' ? (0, $7OCSv.getIconFromContentType)(object.product + '.' + object.type.toLowerCase(), object.subtype?.toLowerCase()) : (0, $7OCSv.getIconFromIconUrl)(iconUrl);
    return {
        objectId: object.id,
        name: object.name || '',
        container: $13b92bff3b95cf64$var$getContainerName(containers),
        url: object.url,
        ...iconData,
        lastViewedDate: timestamp ? new Date(timestamp) : undefined,
        prefetch: true,
        meta: {
            source: 'recent-work'
        }
    };
};
const $13b92bff3b95cf64$var$getContainerName = (containers)=>{
    for(let i = containers.length - 1; i >= 0; --i){
        const containerName = containers[i].name;
        if (containerName) return containerName;
    }
    return '';
};
/** No results returned for townsquare (Atlas) if `platform` is used in filter
 * https://atlassian.slack.com/archives/CGZMUTRUL/p1684729057252109?thread_ts=1684727786.451419&cid=CGZMUTRUL
 */ /**
 * Generate the ARI for particular product to send to the recent items API.
 */ function $13b92bff3b95cf64$var$generateProductSpecificAri(product, cloudId) {
    if (product === 'townsquare') /** No results returned for townsquare (Atlas) if `platform` is used in filter
     * https://atlassian.slack.com/archives/CGZMUTRUL/p1684729057252109?thread_ts=1684727786.451419&cid=CGZMUTRUL
     */ return `ari:cloud:townsquare::site/${cloudId}`;
    return `ari:cloud:platform::site/${cloudId}`;
}
function $13b92bff3b95cf64$export$4b7ffcf66d37c47b(products, cloudId) {
    const defaultAri = `ari:cloud:platform::site/${cloudId}`;
    if (products === undefined) return [
        defaultAri
    ];
    const allAris = products.map((product)=>$13b92bff3b95cf64$var$generateProductSpecificAri(product, cloudId));
    // Deduplicate
    return allAris.filter((value, index)=>allAris.indexOf(value) === index);
}
module.exports["mapActivityClientResultToLinkSearchItemData"] = $13b92bff3b95cf64$export$d82137ca931458ca;
module.exports["getArisForProducts"] = $13b92bff3b95cf64$export$4b7ffcf66d37c47b;

});

parcelRegister("3W9OD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7dyLS = parcelRequire("7dyLS");


var $1GRxr = parcelRequire("1GRxr");


var $bQm3c = parcelRequire("bQm3c");

function $267ba6a0568e3ab0$export$ffe8c124580b6e44() {
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    return (0, $42omo.useMemo)(()=>Promise.resolve((0, $1GRxr.createSearchProvider)(cloudId, (0, $7dyLS.Scope).ConfluencePageBlog, undefined, undefined, true)), [
        cloudId
    ]);
}
module.exports["useSearchProvider"] = $267ba6a0568e3ab0$export$ffe8c124580b6e44;

});

parcelRegister("1GRxr", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $dIeDA = parcelRequire("dIeDA");

const $8069e3f6ac931870$export$31a7d81156fc4fa1 = (cloudId, scope, aggregatorUrl, analyticsIdentifier, useConfluenceTypeInAri)=>{
    return new (0, $dIeDA.default)(cloudId, scope, aggregatorUrl, analyticsIdentifier, useConfluenceTypeInAri);
};
module.exports["createSearchProvider"] = $8069e3f6ac931870$export$31a7d81156fc4fa1;

});

parcelRegister("dIeDA", function(module, exports) {

var $3paC4 = parcelRequire("3paC4");


var $7dyLS = parcelRequire("7dyLS");


var $7MEO5 = parcelRequire("7MEO5");

const $2b54566fbe30c20f$var$ANALYTICS_IDENTIFIER = 'editor-quick-search';
class $2b54566fbe30c20f$export$2e2bcd8739ae039 {
    getAriString(opt) {
        try {
            return new (0, $7MEO5.ResourceIdentifier)(opt).toString();
        } catch (e) {
            return '';
        }
    }
    confluencePageBlogResponseTransformer(response) {
        if (!response) return [];
        return response.results.map((item)=>({
                title: item.title,
                // The `item.url` is only the relative path so we need to prefix the `item.baseUrl`
                url: item.baseUrl + item.url,
                container: item.container.title,
                contentType: this.mapToContentType(item.content && item.content.type),
                updatedTimestamp: item.lastModified,
                objectId: this.getAriString({
                    resourceOwner: 'confluence',
                    cloudId: this.cloudId,
                    resourceType: this.useConfluenceTypeInAri && item.content?.type || 'content',
                    resourceId: item.content && item.content.id
                })
            }));
    }
    jiraIssueResponseTransformer(response) {
        if (!response) return [];
        return response.results.map((item)=>({
                title: item.name,
                // The `item.url` here for Jira Issue is the absolute url
                url: item.url,
                container: item.attributes.container && item.attributes.container.title || '',
                contentType: this.mapToContentType(item.attributes['@type'], item.attributes.issueTypeName),
                updatedTimestamp: item.attributes.updated,
                objectId: this.getAriString({
                    resourceOwner: 'jira',
                    cloudId: this.cloudId,
                    resourceType: 'issue',
                    resourceId: item.id
                })
            }));
    }
    mapToContentType(type, subType) {
        switch(type){
            case 'issue':
                switch(subType){
                    case 'Bug':
                        return 'jira.issue.bug';
                    case 'Story':
                        return 'jira.issue.story';
                    case 'Task':
                        return 'jira.issue.task';
                    default:
                        return 'jira.issue';
                }
            case 'page':
                return 'confluence.page';
            case 'blogpost':
                return 'confluence.blogpost';
            default:
                return 'default';
        }
    }
    async quickSearch(query, limit) {
        const result = await this.client.search({
            query: query,
            scopes: [
                this.scope
            ],
            analytics: {
                identifier: this.analyticsIdentifier
            },
            resultLimit: limit
        });
        switch(this.scope){
            case (0, $7dyLS.Scope).ConfluencePageBlog:
                {
                    const scopeResult = result.response.retrieveScope(this.scope);
                    return this.confluencePageBlogResponseTransformer(scopeResult);
                }
            case (0, $7dyLS.Scope).JiraIssue:
                {
                    const scopeResult = result.response.retrieveScope(this.scope);
                    return this.jiraIssueResponseTransformer(scopeResult);
                }
            default:
                throw new Error(`Unsupported scope - ${this.scope}`);
        }
    }
    constructor(cloudId, scope, aggregatorUrl, analyticsIdentifier = $2b54566fbe30c20f$var$ANALYTICS_IDENTIFIER, useConfluenceTypeInAri = false){
        this.client = void 0;
        this.scope = void 0;
        this.cloudId = void 0;
        this.analyticsIdentifier = void 0;
        this.useConfluenceTypeInAri = void 0;
        switch(scope){
            case (0, $7dyLS.Scope).ConfluencePageBlog:
            case (0, $7dyLS.Scope).JiraIssue:
                break;
            default:
                throw new Error(`Unsupported scope - ${scope}`);
        }
        this.scope = scope;
        this.cloudId = cloudId;
        this.analyticsIdentifier = analyticsIdentifier;
        this.useConfluenceTypeInAri = useConfluenceTypeInAri;
        const config = {
            cloudId: cloudId,
            aggregatorUrl: aggregatorUrl
        };
        this.client = (0, $3paC4.createClient)(config);
    }
}
module.exports["default"] = $2b54566fbe30c20f$export$2e2bcd8739ae039;

});

parcelRegister("e2ZTm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3106b9c6f62709920818f57612d09ba2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a3a1430ff6078f73$var$_react = $a3a1430ff6078f73$var$_interopRequireDefault((parcelRequire("42omo")));

var $a3a1430ff6078f73$var$_baseNew = $a3a1430ff6078f73$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a3a1430ff6078f73$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SuggestedEdit".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/suggested-edit
 * Usage guidance:
 * Reserved for suggestions powered by Atlassian Intelligence
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a3a1430ff6078f73$var$SuggestedEditIcon = (props)=>/*#__PURE__*/ $a3a1430ff6078f73$var$_react.default.createElement($a3a1430ff6078f73$var$_baseNew.default, Object.assign({
        name: "SuggestedEditIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.84 5.85a2 2 0 0 1 2.83 0l.73.73a2 2 0 0 1 0 2.83l-5.14 5.14a2 2 0 0 1-.86.51l-3.19.91a.75.75 0 0 1-.93-.93l.91-3.19a2 2 0 0 1 .51-.86zm1.77 1.06a.5.5 0 0 0-.71 0l-.59.59 1.44 1.44.59-.59a.5.5 0 0 0 0-.71zM12.69 10l-1.44-1.44-3.49 3.49a.5.5 0 0 0-.13.22l-.54 1.89 1.89-.54a.5.5 0 0 0 .22-.13zM4.75 0c.31 0 .59.19.7.48l1 2.57 2.57 1a.75.75 0 0 1 0 1.4l-2.57 1-1 2.57a.75.75 0 0 1-1.4 0l-1-2.57-2.57-1a.75.75 0 0 1 0-1.4l2.57-1 1-2.57a.75.75 0 0 1 .7-.48m0 2.82L4.33 3.9a.75.75 0 0 1-.43.43l-1.08.42 1.08.42a.75.75 0 0 1 .43.43l.42 1.08.42-1.08a.75.75 0 0 1 .43-.43l1.08-.42-1.08-.42a.75.75 0 0 1-.43-.43z" clip-rule="evenodd"/>`
    }, props));
$a3a1430ff6078f73$var$SuggestedEditIcon.displayName = 'SuggestedEditIcon';
var $a3a1430ff6078f73$var$_default = module.exports.default = $a3a1430ff6078f73$var$SuggestedEditIcon;

});

parcelRegister("7hGsm", function(module, exports) {
$parcel$export(module.exports, "Integrations", () => $54db0de22feedc16$export$99d02219d259eb94);
$parcel$export(module.exports, "Transports", () => (parcelRequire("2UWw0")));

var $hXuPC = parcelRequire("hXuPC");


var $iIf3l = parcelRequire("iIf3l");


var $a5jIU = parcelRequire("a5jIU");


var $fkDf0 = parcelRequire("fkDf0");


var $6yHbi = parcelRequire("6yHbi");


var $2UWw0 = parcelRequire("2UWw0");

var $54db0de22feedc16$var$windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
var $54db0de22feedc16$var$_window = (0, $fkDf0.getGlobalObject)();
if ($54db0de22feedc16$var$_window.Sentry && $54db0de22feedc16$var$_window.Sentry.Integrations) $54db0de22feedc16$var$windowIntegrations = $54db0de22feedc16$var$_window.Sentry.Integrations;
var $54db0de22feedc16$export$99d02219d259eb94 = (0, $hXuPC.__assign)((0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, $54db0de22feedc16$var$windowIntegrations), (0, $a5jIU)), $6yHbi);
 //# sourceMappingURL=index.js.map
$parcel$exportWildcard(module.exports, $iIf3l);

});

parcelRegister("iIf3l", function(module, exports) {
$parcel$export(module.exports, "Severity", () => (parcelRequire("cs0rL")).Severity);
$parcel$export(module.exports, "addGlobalEventProcessor", () => (parcelRequire("euURg")).addGlobalEventProcessor);
$parcel$export(module.exports, "addBreadcrumb", () => (parcelRequire("805AA")).addBreadcrumb);
$parcel$export(module.exports, "captureException", () => (parcelRequire("805AA")).captureException);
$parcel$export(module.exports, "captureEvent", () => (parcelRequire("805AA")).captureEvent);
$parcel$export(module.exports, "captureMessage", () => (parcelRequire("805AA")).captureMessage);
$parcel$export(module.exports, "configureScope", () => (parcelRequire("805AA")).configureScope);
$parcel$export(module.exports, "getHubFromCarrier", () => (parcelRequire("k3i2h")).getHubFromCarrier);
$parcel$export(module.exports, "getCurrentHub", () => (parcelRequire("k3i2h")).getCurrentHub);
$parcel$export(module.exports, "Hub", () => (parcelRequire("k3i2h")).Hub);
$parcel$export(module.exports, "makeMain", () => (parcelRequire("k3i2h")).makeMain);
$parcel$export(module.exports, "Scope", () => (parcelRequire("euURg")).Scope);
$parcel$export(module.exports, "Session", () => (parcelRequire("cSJat")).Session);
$parcel$export(module.exports, "startTransaction", () => (parcelRequire("805AA")).startTransaction);
$parcel$export(module.exports, "SDK_VERSION", () => (parcelRequire("cTFwF")).SDK_VERSION);
$parcel$export(module.exports, "setContext", () => (parcelRequire("805AA")).setContext);
$parcel$export(module.exports, "setExtra", () => (parcelRequire("805AA")).setExtra);
$parcel$export(module.exports, "setExtras", () => (parcelRequire("805AA")).setExtras);
$parcel$export(module.exports, "setTag", () => (parcelRequire("805AA")).setTag);
$parcel$export(module.exports, "setTags", () => (parcelRequire("805AA")).setTags);
$parcel$export(module.exports, "setUser", () => (parcelRequire("805AA")).setUser);
$parcel$export(module.exports, "withScope", () => (parcelRequire("805AA")).withScope);
$parcel$export(module.exports, "BrowserClient", () => (parcelRequire("cW7ac")).BrowserClient);
$parcel$export(module.exports, "injectReportDialog", () => (parcelRequire("1cvC0")).injectReportDialog);
$parcel$export(module.exports, "eventFromException", () => (parcelRequire("a7P2i")).eventFromException);
$parcel$export(module.exports, "eventFromMessage", () => (parcelRequire("a7P2i")).eventFromMessage);
$parcel$export(module.exports, "defaultIntegrations", () => (parcelRequire("ffG6S")).defaultIntegrations);
$parcel$export(module.exports, "forceLoad", () => (parcelRequire("ffG6S")).forceLoad);
$parcel$export(module.exports, "init", () => (parcelRequire("ffG6S")).init);
$parcel$export(module.exports, "lastEventId", () => (parcelRequire("ffG6S")).lastEventId);
$parcel$export(module.exports, "onLoad", () => (parcelRequire("ffG6S")).onLoad);
$parcel$export(module.exports, "showReportDialog", () => (parcelRequire("ffG6S")).showReportDialog);
$parcel$export(module.exports, "flush", () => (parcelRequire("ffG6S")).flush);
$parcel$export(module.exports, "close", () => (parcelRequire("ffG6S")).close);
$parcel$export(module.exports, "wrap", () => (parcelRequire("ffG6S")).wrap);
$parcel$export(module.exports, "SDK_NAME", () => (parcelRequire("brq4Q")).SDK_NAME);

var $cs0rL = parcelRequire("cs0rL");


var $805AA = parcelRequire("805AA");

var $euURg = parcelRequire("euURg");

var $k3i2h = parcelRequire("k3i2h");

var $cTFwF = parcelRequire("cTFwF");

var $cSJat = parcelRequire("cSJat");


var $cW7ac = parcelRequire("cW7ac");


var $1cvC0 = parcelRequire("1cvC0");


var $a7P2i = parcelRequire("a7P2i");


var $ffG6S = parcelRequire("ffG6S");


var $brq4Q = parcelRequire("brq4Q");

 //# sourceMappingURL=exports.js.map

});

parcelRegister("brq4Q", function(module, exports) {
// TODO: Remove in the next major release and rely only on @sentry/core SDK_VERSION and SdkInfo metadata
var $854671b7fcc6622a$export$ca61d37259221480 = 'sentry.javascript.browser'; //# sourceMappingURL=version.js.map
module.exports["SDK_NAME"] = $854671b7fcc6622a$export$ca61d37259221480;

});

parcelRegister("6yHbi", function(module, exports) {
$parcel$export(module.exports, "GlobalHandlers", () => (parcelRequire("3BsQh")).GlobalHandlers);
$parcel$export(module.exports, "TryCatch", () => (parcelRequire("lIIKi")).TryCatch);
$parcel$export(module.exports, "Breadcrumbs", () => (parcelRequire("bISXm")).Breadcrumbs);
$parcel$export(module.exports, "LinkedErrors", () => (parcelRequire("63fUW")).LinkedErrors);
$parcel$export(module.exports, "UserAgent", () => (parcelRequire("eLUbA")).UserAgent);
$parcel$export(module.exports, "Dedupe", () => (parcelRequire("fCIwr")).Dedupe);

var $3BsQh = parcelRequire("3BsQh");


var $lIIKi = parcelRequire("lIIKi");


var $bISXm = parcelRequire("bISXm");


var $63fUW = parcelRequire("63fUW");


var $eLUbA = parcelRequire("eLUbA");


var $fCIwr = parcelRequire("fCIwr");

 //# sourceMappingURL=index.js.map

});

parcelRegister("2UWw0", function(module, exports) {
$parcel$export(module.exports, "BaseTransport", () => (parcelRequire("1l2dO")).BaseTransport);
$parcel$export(module.exports, "FetchTransport", () => (parcelRequire("8LVWj")).FetchTransport);
$parcel$export(module.exports, "XHRTransport", () => (parcelRequire("2yXKF")).XHRTransport);
$parcel$export(module.exports, "makeNewFetchTransport", () => (parcelRequire("hB2rb")).makeNewFetchTransport);
$parcel$export(module.exports, "makeNewXHRTransport", () => (parcelRequire("lgAM0")).makeNewXHRTransport);

var $1l2dO = parcelRequire("1l2dO");


var $8LVWj = parcelRequire("8LVWj");


var $2yXKF = parcelRequire("2yXKF");


var $hB2rb = parcelRequire("hB2rb");


var $lgAM0 = parcelRequire("lgAM0");

 //# sourceMappingURL=index.js.map

});

parcelRegister("a1WXB", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8IyAG = parcelRequire("8IyAG");


var $4sZvs = parcelRequire("4sZvs");


var $lAFHW = parcelRequire("lAFHW");


var $g9Jfe = parcelRequire("g9Jfe");


var $4TUdx = parcelRequire("4TUdx");


var $kbte2 = parcelRequire("kbte2");

function $ea05eb724aaf2d4b$export$ab527c45f467d3f7(options) {
    const { defaultExtractorFunction: defaultExtractorFunction, extractorPrioritiesByType: extractorPrioritiesByType, extractorFunctionsByType: extractorFunctionsByType, json: json } = options;
    if (json) {
        const type = json['@type'];
        if (type && Array.isArray(type)) {
            let highestPriority = 0;
            let highestPriorityExtractorFunction = defaultExtractorFunction;
            for (let t of type)if (extractorPrioritiesByType[t] > highestPriority) {
                highestPriority = extractorPrioritiesByType[t];
                highestPriorityExtractorFunction = extractorFunctionsByType[t];
            }
            return highestPriorityExtractorFunction(json);
        }
        if (type && extractorFunctionsByType[type]) return extractorFunctionsByType[type](json);
    }
    return defaultExtractorFunction(json);
}
const $ea05eb724aaf2d4b$export$396ba4ef2e37dc65 = (link)=>{
    if (typeof link === 'string') return link;
    else if (Array.isArray(link)) {
        if (link.length > 0) return $ea05eb724aaf2d4b$export$396ba4ef2e37dc65(link[0]);
    } else return link.href;
    return undefined;
};
const $ea05eb724aaf2d4b$export$67f3d92c824fd850 = (icon)=>{
    if (typeof icon === 'string') return icon;
    else if (icon['@type'] === 'Link') return $ea05eb724aaf2d4b$export$396ba4ef2e37dc65(icon);
    else {
        if (icon.url) return $ea05eb724aaf2d4b$export$396ba4ef2e37dc65(icon.url);
    }
    return undefined;
};
const $ea05eb724aaf2d4b$export$2e9ae379995d99e3 = (jsonLd)=>{
    const type = jsonLd['@type'];
    if (type) {
        if (Array.isArray(jsonLd['@type'])) return type;
        else return [
            type
        ];
    }
    return undefined;
};
const $ea05eb724aaf2d4b$export$be18a6294fd426ec = (jsonLd)=>{
    if (jsonLd['atlassian:ari']) return jsonLd['atlassian:ari'];
    return undefined;
};
const $ea05eb724aaf2d4b$export$63f54cf4c5883620 = (jsonLd)=>{
    const url = jsonLd?.url;
    if (url) {
        if (typeof url === 'string') return url;
        else return $ea05eb724aaf2d4b$export$396ba4ef2e37dc65(url);
    }
    return undefined;
};
const $ea05eb724aaf2d4b$export$db5a8500f6b6286e = (jsonLd)=>{
    if (typeof jsonLd?.summary === 'string') {
        const summary = jsonLd.summary.trim();
        return Boolean(summary) ? summary : undefined;
    }
    return undefined;
};
const $ea05eb724aaf2d4b$export$b05803156e5015b6 = (jsonLd, removeTextHighlightingFromTitle)=>{
    if (!jsonLd) return undefined;
    const name = jsonLd.name?.replace(/[\r\n]+/g, '');
    const id = jsonLd['@id'] || '';
    // Check if this is a reference to something _inside_ a Repository.
    // We format these titles to represent more metadata.
    const context = $ea05eb724aaf2d4b$export$efdbd45f3e77a161(jsonLd);
    const type = $ea05eb724aaf2d4b$export$2e9ae379995d99e3(jsonLd);
    const hasContextType = context && context.type;
    const hasContextRepo = hasContextType && context.type.includes('atlassian:SourceCodeRepository');
    if (hasContextRepo && type) {
        const contextName = context.name && `${context.name}: ` || '';
        // COMMIT: `repo-name: abf137c title of commit message`
        if (type.includes('atlassian:SourceCodeCommit')) {
            const [, hashContent] = id.split(':');
            const hash = hashContent && `${hashContent.substring(0, 8)} `;
            return contextName + (hash || '') + name;
        }
        // PR: `repo-name: #42 title of pull request`
        if (type.includes('atlassian:SourceCodePullRequest')) {
            const pullRequest = jsonLd;
            const internalId = pullRequest['atlassian:internalId'];
            const internalIdRef = internalId && `#${internalId} `;
            return contextName + (internalIdRef || '') + name;
        }
        // BRANCH: `repo-name/branch-name`
        if (type.includes('atlassian:SourceCodeReference')) return contextName + name;
        // FILE: `repo-name: filepath`
        if (type.includes('schema:DigitalDocument')) return contextName + name;
    }
    if (removeTextHighlightingFromTitle) {
        const textFragmentRegex = new RegExp(' \\| :~:text=.*', 'g');
        const truncated = name?.replace(textFragmentRegex, '');
        return truncated;
    }
    return name;
};
const $ea05eb724aaf2d4b$export$3185b99040f72cfd = (details)=>details?.data && 'name' in details.data && details.data.name || undefined;
const $ea05eb724aaf2d4b$export$efdbd45f3e77a161 = (jsonLd)=>{
    const context = jsonLd.context;
    if (context) {
        if (typeof context === 'string') return {
            name: context
        };
        else if (context['@type'] === 'Link') {
            if (context.name) return {
                name: context.name
            };
        } else {
            if (context.name) return {
                name: context.name,
                icon: context.icon && $ea05eb724aaf2d4b$export$67f3d92c824fd850(context.icon),
                type: $ea05eb724aaf2d4b$export$2e9ae379995d99e3(context)
            };
        }
    }
    return undefined;
};
const $ea05eb724aaf2d4b$export$a832871718466647 = (jsonLd)=>{
    const generator = jsonLd.generator;
    if (generator) {
        if (typeof generator === 'string') throw Error('Link.generator requires a name and icon.');
        else if (generator['@type'] === 'Link') {
            if (generator.name) return (0, $g9Jfe.fg)('platform_sl_google_rebrand') ? (0, $4TUdx.rebrandProvider)({
                text: generator.name
            }) : {
                text: generator.name
            };
        } else if (generator.name) {
            const id = generator['@id'];
            return (0, $g9Jfe.fg)('platform_sl_google_rebrand') ? (0, $4TUdx.rebrandProvider)({
                text: generator.name,
                icon: $ea05eb724aaf2d4b$export$6fb636a2ac885215(generator.icon, id),
                ...(0, $g9Jfe.fg)('platform_lp_use_entity_icon_url_for_icon') ? {
                    iconLabel: generator.name
                } : undefined,
                id: id,
                image: $ea05eb724aaf2d4b$var$extractProviderImage(generator.image)
            }) : {
                text: generator.name,
                icon: $ea05eb724aaf2d4b$export$6fb636a2ac885215(generator.icon, id),
                ...(0, $g9Jfe.fg)('platform_lp_use_entity_icon_url_for_icon') ? {
                    iconLabel: generator.name
                } : undefined,
                id: id,
                image: $ea05eb724aaf2d4b$var$extractProviderImage(generator.image)
            };
        }
    }
    return undefined;
};
const $ea05eb724aaf2d4b$export$6fb636a2ac885215 = (icon, id)=>{
    if (id) {
        if (id === (0, $kbte2.CONFLUENCE_GENERATOR_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4sZvs.ConfluenceIcon), {
            appearance: "brand",
            size: "xxsmall"
        });
        else if (id === (0, $kbte2.JIRA_GENERATOR_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.JiraIcon), {
            appearance: "brand",
            size: "xxsmall"
        });
    }
    if (icon) return $ea05eb724aaf2d4b$export$67f3d92c824fd850(icon);
    return undefined;
};
const $ea05eb724aaf2d4b$var$extractProviderImage = (image)=>{
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return $ea05eb724aaf2d4b$export$396ba4ef2e37dc65(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return $ea05eb724aaf2d4b$export$396ba4ef2e37dc65(image.url);
        }
    }
    return undefined;
};
const $ea05eb724aaf2d4b$export$38df542ff03a4183 = (id)=>{
    return id === (0, $kbte2.CONFLUENCE_GENERATOR_ID);
};
const $ea05eb724aaf2d4b$export$e1226a5e0bbbf862 = (jsonLd)=>{
    if (jsonLd['schema:dateCreated']) return jsonLd['schema:dateCreated'];
    return undefined;
};
const $ea05eb724aaf2d4b$export$7fc2f5e6f9d22ae7 = (jsonLd)=>{
    if (jsonLd.updated) return jsonLd.updated;
    return undefined;
};
const $ea05eb724aaf2d4b$export$601b23e9cf369aed = (jsonLd)=>{
    if (jsonLd['atlassian:dateViewed']) return jsonLd['atlassian:dateViewed'];
    return undefined;
};
const $ea05eb724aaf2d4b$export$c471ae5fddcf1392 = (person)=>{
    if (typeof person === 'string') throw Error('Link.person needs to be an object.');
    else if (person['@type'] === 'Link') {
        if (person.name) return {
            name: person.name
        };
    } else {
        if (person.name) return {
            name: person.name,
            src: person.icon && $ea05eb724aaf2d4b$export$67f3d92c824fd850(person.icon)
        };
    }
    return undefined;
};
const $ea05eb724aaf2d4b$export$6281d080d62a0719 = (jsonLd)=>{
    const members = jsonLd['atlassian:member'];
    if (members) {
        if (typeof members === 'string') throw Error('Link[atlassian:members] must be an array or object.');
        else if (members.hasOwnProperty('totalItems')) {
            const collection = members;
            if (collection.items) return collection.items.map((member)=>$ea05eb724aaf2d4b$export$c471ae5fddcf1392(member)).filter((member)=>!!member);
        } else {
            const memberItem = members;
            const memberItemForLink = $ea05eb724aaf2d4b$export$c471ae5fddcf1392(memberItem);
            if (memberItemForLink) return [
                memberItemForLink
            ];
        }
    }
    return undefined;
};
const $ea05eb724aaf2d4b$export$38a0979ebf273662 = (jsonLd)=>{
    const assignedTo = jsonLd['atlassian:assignedTo'];
    if (assignedTo) return $ea05eb724aaf2d4b$export$c471ae5fddcf1392(assignedTo);
    return undefined;
};
const $ea05eb724aaf2d4b$export$a66235cba0c9d11a = (jsonLd)=>{
    const attributedTo = jsonLd.attributedTo;
    if (attributedTo) {
        if (Array.isArray(attributedTo)) return attributedTo.map($ea05eb724aaf2d4b$export$c471ae5fddcf1392).filter((item)=>!!item);
        else {
            const item = $ea05eb724aaf2d4b$export$c471ae5fddcf1392(attributedTo);
            if (item) return [
                item
            ];
        }
    }
    return undefined;
};
const $ea05eb724aaf2d4b$export$19ee667f3f7a6ec3 = (jsonLd)=>{
    const ownedBy = jsonLd['atlassian:ownedBy'];
    if (ownedBy) {
        if (Array.isArray(ownedBy)) return ownedBy.map($ea05eb724aaf2d4b$export$c471ae5fddcf1392).filter((item)=>!!item);
        else {
            const item = $ea05eb724aaf2d4b$export$c471ae5fddcf1392(ownedBy);
            if (item) return [
                item
            ];
        }
    }
    return undefined;
};
const $ea05eb724aaf2d4b$export$8a2d1ed7e6f336f0 = (jsonLd)=>{
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) return $ea05eb724aaf2d4b$export$c471ae5fddcf1392(updatedBy);
    return undefined;
};
const $ea05eb724aaf2d4b$export$4c753a1297cb9805 = (jsonLd)=>{
    const image = jsonLd.image;
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return $ea05eb724aaf2d4b$export$396ba4ef2e37dc65(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return $ea05eb724aaf2d4b$export$396ba4ef2e37dc65(image.url);
        }
    }
    return undefined;
};
const $ea05eb724aaf2d4b$export$3e8ad908070b68b2 = (preview, platform)=>{
    if (preview) {
        // By default, we support previews everywhere.
        if (typeof preview === 'string') return true;
        else {
            const supportedPlatforms = preview['atlassian:supportedPlatforms'];
            if (supportedPlatforms) {
                const isWeb = platform === 'web';
                return isWeb && supportedPlatforms.includes('web') || !isWeb && supportedPlatforms.includes('mobile');
            }
            // No supported platforms - assume they are all supported.
            return true;
        }
    }
    // No preview, don't try and render it on any platforms.
    return false;
};
const $ea05eb724aaf2d4b$export$4b0d98b1b7f6d115 = (jsonLd, platform, iframeUrlType)=>{
    const preview = jsonLd?.preview;
    const isSupported = $ea05eb724aaf2d4b$export$3e8ad908070b68b2(preview, platform);
    if (preview && isSupported) {
        if (typeof preview === 'string') return {
            src: preview
        };
        else if (preview['@type'] === 'Link' && iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
            src: preview.interactiveHref,
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else if (preview['@type'] === 'Link') return {
            src: $ea05eb724aaf2d4b$export$396ba4ef2e37dc65(preview),
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else {
            // TODO, EDM-565: Remove this once the typings for Dropbox and Jira have been patched up.
            if (preview.url || preview.href) {
                if (iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                    src: preview.interactiveHref,
                    aspectRatio: preview['atlassian:aspectRatio']
                };
                return {
                    src: $ea05eb724aaf2d4b$export$396ba4ef2e37dc65(preview.url || preview.href),
                    aspectRatio: preview['atlassian:aspectRatio']
                };
            } else if (preview.content) return {
                content: preview.content
            };
        }
    }
    return undefined;
};
const $ea05eb724aaf2d4b$export$8beff7405d020ddf = (response)=>response?.entityData;
const $ea05eb724aaf2d4b$export$c7168210b81d9383 = (response)=>Boolean($ea05eb724aaf2d4b$export$8beff7405d020ddf(response));
const $ea05eb724aaf2d4b$var$extractEntityEmbedUrl = (response)=>{
    const entity = $ea05eb724aaf2d4b$export$8beff7405d020ddf(response);
    return entity && 'liveEmbedUrl' in entity && typeof entity?.liveEmbedUrl === 'string' ? entity?.liveEmbedUrl : undefined;
};
const $ea05eb724aaf2d4b$export$ad879f2c9d5100a0 = (response)=>{
    if (!response?.meta?.generator) return undefined;
    if ((0, $g9Jfe.fg)('platform_lp_use_entity_icon_url_for_icon')) {
        const entityIcon = $ea05eb724aaf2d4b$export$19346520e937a99f(response);
        if (entityIcon) return (0, $g9Jfe.fg)('platform_sl_google_rebrand') ? (0, $4TUdx.rebrandProvider)({
            text: response.meta.generator.name,
            icon: entityIcon.url,
            id: response.meta.generator.id,
            image: entityIcon.url,
            iconLabel: entityIcon.label
        }) : {
            text: response.meta.generator.name,
            icon: entityIcon.url,
            id: response.meta.generator.id,
            image: entityIcon.url,
            iconLabel: entityIcon.label
        };
    }
    const { icon: icon, id: id, image: image, name: name } = response.meta.generator;
    if (!name || !icon) throw Error('Link.generator requires a name and icon.');
    let providerIcon;
    switch(id){
        case 0, $kbte2.CONFLUENCE_GENERATOR_ID:
            providerIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4sZvs.ConfluenceIcon), {
                appearance: "brand",
                size: "xxsmall"
            });
            break;
        case 0, $kbte2.JIRA_GENERATOR_ID:
            providerIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.JiraIcon), {
                appearance: "brand",
                size: "xxsmall"
            });
            break;
        default:
            providerIcon = icon.url;
    }
    return (0, $g9Jfe.fg)('platform_sl_google_rebrand') ? (0, $4TUdx.rebrandProvider)({
        text: name,
        icon: providerIcon,
        id: id,
        image: image ? image : icon.url,
        ...(0, $g9Jfe.fg)('platform_lp_use_entity_icon_url_for_icon') ? {
            iconLabel: name
        } : undefined
    }) : {
        text: name,
        icon: providerIcon,
        id: id,
        image: image ? image : icon.url,
        ...(0, $g9Jfe.fg)('platform_lp_use_entity_icon_url_for_icon') ? {
            iconLabel: name
        } : undefined
    };
};
const $ea05eb724aaf2d4b$export$19346520e937a99f = (response)=>{
    if ((0, $g9Jfe.fg)('platform_lp_use_entity_icon_url_for_icon')) {
        const entity = $ea05eb724aaf2d4b$export$8beff7405d020ddf(response);
        if (!entity) return undefined;
        if (!(0, $8IyAG.isBaseEntity)(entity)) return undefined;
        if ((0, $8IyAG.isDesignEntity)(entity) && entity.iconUrl) return {
            url: entity.iconUrl,
            label: entity.type
        };
        if ((0, $8IyAG.isDocumentEntity)(entity) && entity.type.iconUrl) return {
            url: entity.type.iconUrl,
            label: entity.type.category
        };
        // When JSON-LD is deprecated, we can change this to returning entity provider icon.
        // For now code upstream will return better result when this method returns undefined.
        return undefined;
    } else {
        const entity = $ea05eb724aaf2d4b$export$8beff7405d020ddf(response);
        let url;
        if (entity) url = 'iconUrl' in entity && typeof entity?.iconUrl === 'string' ? entity.iconUrl : response?.meta.generator?.icon?.url;
        return {
            url: url,
            label: entity?.displayName
        };
    }
};
const $ea05eb724aaf2d4b$export$3eda18658b66108 = (response, removeTextHighlightingFromTitle)=>{
    if ($ea05eb724aaf2d4b$export$c7168210b81d9383(response)) return $ea05eb724aaf2d4b$export$8beff7405d020ddf(response)?.displayName;
    return $ea05eb724aaf2d4b$export$b05803156e5015b6(response?.data, removeTextHighlightingFromTitle);
};
const $ea05eb724aaf2d4b$export$7ba9b12c6a1b73de = (response)=>{
    if ($ea05eb724aaf2d4b$export$c7168210b81d9383(response)) return $ea05eb724aaf2d4b$export$8beff7405d020ddf(response)?.url;
    return $ea05eb724aaf2d4b$export$63f54cf4c5883620(response?.data);
};
const $ea05eb724aaf2d4b$export$16b02be3e2bb31ad = (response)=>{
    if ($ea05eb724aaf2d4b$export$c7168210b81d9383(response)) return $ea05eb724aaf2d4b$export$8beff7405d020ddf(response)?.ari || $ea05eb724aaf2d4b$export$8beff7405d020ddf(response)?.thirdPartyAri;
    const data = response?.data;
    return $ea05eb724aaf2d4b$export$be18a6294fd426ec(data);
};
const $ea05eb724aaf2d4b$export$864b719baf5d744d = (response, iframeUrlType)=>{
    if ($ea05eb724aaf2d4b$export$c7168210b81d9383(response)) {
        // TODO: Missing iframeUrlType
        const embedUrl = $ea05eb724aaf2d4b$var$extractEntityEmbedUrl(response);
        return embedUrl ? {
            src: embedUrl
        } : undefined;
    }
    return $ea05eb724aaf2d4b$export$4b0d98b1b7f6d115(response?.data, 'web', iframeUrlType);
};
const $ea05eb724aaf2d4b$export$ff753ed519e96e9e = (response)=>{
    if ($ea05eb724aaf2d4b$export$c7168210b81d9383(response)) return $ea05eb724aaf2d4b$export$ad879f2c9d5100a0(response);
    return response?.data && $ea05eb724aaf2d4b$export$a832871718466647(response?.data);
};
const $ea05eb724aaf2d4b$export$7a685df468cbf38f = (response)=>{
    if ($ea05eb724aaf2d4b$export$c7168210b81d9383(response)) return $ea05eb724aaf2d4b$export$8beff7405d020ddf(response)?.createdAt;
    return response?.data && $ea05eb724aaf2d4b$export$e1226a5e0bbbf862(response.data);
};
const $ea05eb724aaf2d4b$export$75047940e157fd1f = (response)=>{
    if ($ea05eb724aaf2d4b$export$c7168210b81d9383(response)) return $ea05eb724aaf2d4b$export$8beff7405d020ddf(response)?.lastUpdatedAt;
    return response?.data && $ea05eb724aaf2d4b$export$7fc2f5e6f9d22ae7(response.data);
};
const $ea05eb724aaf2d4b$export$242875b46118beb2 = (response)=>{
    if (!response || !response.data) return undefined;
    if ($ea05eb724aaf2d4b$export$c7168210b81d9383(response)) return $ea05eb724aaf2d4b$export$8beff7405d020ddf(response)?.createdBy?.displayName;
    const persons = $ea05eb724aaf2d4b$export$a66235cba0c9d11a(response.data);
    return !!persons?.length ? persons[0].name : undefined;
};
const $ea05eb724aaf2d4b$export$41fc716e1bc2dc90 = (response)=>{
    if (!response || !response.data) return undefined;
    if ($ea05eb724aaf2d4b$export$c7168210b81d9383(response)) {
        const entity = $ea05eb724aaf2d4b$export$8beff7405d020ddf(response);
        const owners = entity?.owners;
        if (owners) return owners.map((owner)=>({
                name: owner.displayName,
                src: owner.picture
            })).filter((item)=>!!item);
    }
    return $ea05eb724aaf2d4b$export$a66235cba0c9d11a(response.data);
};
const $ea05eb724aaf2d4b$export$7f099a839071a190 = (response)=>{
    if (!response || !response.data) return undefined;
    if ($ea05eb724aaf2d4b$export$c7168210b81d9383(response)) return $ea05eb724aaf2d4b$export$8beff7405d020ddf(response)?.lastUpdatedBy?.displayName;
    const person = $ea05eb724aaf2d4b$export$8a2d1ed7e6f336f0(response.data);
    return person ? person.name : undefined;
};
const $ea05eb724aaf2d4b$export$96ed4c1b14ac210a = (response)=>{
    if ($ea05eb724aaf2d4b$export$c7168210b81d9383(response)) {
        const entity = $ea05eb724aaf2d4b$export$8beff7405d020ddf(response);
        return entity && 'exportLinks' in entity && Array.isArray(entity.exportLinks) && entity.exportLinks.length > 0 ? entity?.exportLinks?.[0].url : undefined;
    }
    return response?.data?.['atlassian:downloadUrl'];
};
module.exports["genericExtractPropsFromJSONLD"] = $ea05eb724aaf2d4b$export$ab527c45f467d3f7;
module.exports["extractUrlFromLinkJsonLd"] = $ea05eb724aaf2d4b$export$396ba4ef2e37dc65;
module.exports["extractUrlFromIconJsonLd"] = $ea05eb724aaf2d4b$export$67f3d92c824fd850;
module.exports["extractType"] = $ea05eb724aaf2d4b$export$2e9ae379995d99e3;
module.exports["extractAri"] = $ea05eb724aaf2d4b$export$be18a6294fd426ec;
module.exports["extractLink"] = $ea05eb724aaf2d4b$export$63f54cf4c5883620;
module.exports["extractSummary"] = $ea05eb724aaf2d4b$export$db5a8500f6b6286e;
module.exports["extractTitle"] = $ea05eb724aaf2d4b$export$b05803156e5015b6;
module.exports["extractContext"] = $ea05eb724aaf2d4b$export$efdbd45f3e77a161;
module.exports["extractNameFromJsonLd"] = $ea05eb724aaf2d4b$export$3185b99040f72cfd;
module.exports["extractProvider"] = $ea05eb724aaf2d4b$export$a832871718466647;
module.exports["extractProviderIcon"] = $ea05eb724aaf2d4b$export$6fb636a2ac885215;
module.exports["isConfluenceGenerator"] = $ea05eb724aaf2d4b$export$38df542ff03a4183;
module.exports["extractDateCreated"] = $ea05eb724aaf2d4b$export$e1226a5e0bbbf862;
module.exports["extractDateUpdated"] = $ea05eb724aaf2d4b$export$7fc2f5e6f9d22ae7;
module.exports["extractDateViewed"] = $ea05eb724aaf2d4b$export$601b23e9cf369aed;
module.exports["extractPersonFromJsonLd"] = $ea05eb724aaf2d4b$export$c471ae5fddcf1392;
module.exports["extractMembers"] = $ea05eb724aaf2d4b$export$6281d080d62a0719;
module.exports["extractPersonAssignedTo"] = $ea05eb724aaf2d4b$export$38a0979ebf273662;
module.exports["extractPersonCreatedBy"] = $ea05eb724aaf2d4b$export$a66235cba0c9d11a;
module.exports["extractPersonOwnedBy"] = $ea05eb724aaf2d4b$export$19ee667f3f7a6ec3;
module.exports["extractPersonUpdatedBy"] = $ea05eb724aaf2d4b$export$8a2d1ed7e6f336f0;
module.exports["extractImage"] = $ea05eb724aaf2d4b$export$4c753a1297cb9805;
module.exports["extractPlatformIsSupported"] = $ea05eb724aaf2d4b$export$3e8ad908070b68b2;
module.exports["extractPreview"] = $ea05eb724aaf2d4b$export$4b0d98b1b7f6d115;
module.exports["extractEntity"] = $ea05eb724aaf2d4b$export$8beff7405d020ddf;
module.exports["isEntityPresent"] = $ea05eb724aaf2d4b$export$c7168210b81d9383;
module.exports["extractEntityProvider"] = $ea05eb724aaf2d4b$export$ad879f2c9d5100a0;
module.exports["extractEntityIcon"] = $ea05eb724aaf2d4b$export$19346520e937a99f;
module.exports["extractSmartLinkTitle"] = $ea05eb724aaf2d4b$export$3eda18658b66108;
module.exports["extractSmartLinkUrl"] = $ea05eb724aaf2d4b$export$7ba9b12c6a1b73de;
module.exports["extractSmartLinkAri"] = $ea05eb724aaf2d4b$export$16b02be3e2bb31ad;
module.exports["extractSmartLinkEmbed"] = $ea05eb724aaf2d4b$export$864b719baf5d744d;
module.exports["extractSmartLinkProvider"] = $ea05eb724aaf2d4b$export$ff753ed519e96e9e;
module.exports["extractSmartLinkCreatedOn"] = $ea05eb724aaf2d4b$export$7a685df468cbf38f;
module.exports["extractSmartLinkModifiedOn"] = $ea05eb724aaf2d4b$export$75047940e157fd1f;
module.exports["extractSmartLinkCreatedBy"] = $ea05eb724aaf2d4b$export$242875b46118beb2;
module.exports["extractSmartLinkAuthorGroup"] = $ea05eb724aaf2d4b$export$41fc716e1bc2dc90;
module.exports["extractSmartLinkModifiedBy"] = $ea05eb724aaf2d4b$export$7f099a839071a190;
module.exports["extractSmartLinkDownloadUrl"] = $ea05eb724aaf2d4b$export$96ed4c1b14ac210a;

});

parcelRegister("8IyAG", function(module, exports) {
const $1092512147c3e960$var$DESIGN_TYPES = [
    'FILE',
    'CANVAS',
    'GROUP',
    'NODE',
    'PROTOTYPE',
    'OTHER'
];
const $1092512147c3e960$var$DESIGN_STATUSES = [
    'READY_FOR_DEVELOPMENT',
    'UNKNOWN',
    'NONE'
];
const $1092512147c3e960$var$REMOTE_LINK_TYPES = [
    'document',
    'alert',
    'test',
    'security',
    'logFile',
    'prototype',
    'coverage',
    'bugReport',
    'releaseNotes',
    'other'
];
const $1092512147c3e960$var$APPEARANCES = [
    'default',
    'inprogress',
    'moved',
    'new',
    'removed',
    'success'
];
const $1092512147c3e960$var$WORK_ITEM_SUB_TYPES = [
    'task',
    'bug',
    'story',
    'epic',
    'feature',
    'question',
    'other',
    'incident',
    'problem',
    'approval',
    'section',
    'milestone',
    'work_item',
    'default_task'
];
const $1092512147c3e960$var$DOCUMENT_CATEGORIES = [
    'folder',
    'document',
    'presentation',
    'spreadsheet',
    'image',
    'audio',
    'video',
    'pdf',
    'shortcut',
    'code',
    'archive',
    'form',
    'web-page',
    'other'
];
/**
 * Runtime membership check for string literal tuples.
 * Keeps guard logic aligned with tuple-derived union types.
 */ const $1092512147c3e960$var$isOneOf = (values, value)=>typeof value === 'string' && values.includes(value);
const $1092512147c3e960$var$isObject = (value)=>typeof value === 'object' && value !== null;
const $1092512147c3e960$var$asRecord = (value)=>value;
const $1092512147c3e960$export$12af7c5462954d1e = (value)=>$1092512147c3e960$var$isObject(value) && typeof value.displayName === 'string' && typeof value.id === 'string' && typeof value.url === 'string';
const $1092512147c3e960$export$8dc9be81b5b6266b = (value)=>$1092512147c3e960$export$12af7c5462954d1e(value) && $1092512147c3e960$var$isOneOf($1092512147c3e960$var$DESIGN_STATUSES, $1092512147c3e960$var$asRecord(value).status) && $1092512147c3e960$var$isOneOf($1092512147c3e960$var$DESIGN_TYPES, $1092512147c3e960$var$asRecord(value).type);
const $1092512147c3e960$export$f16c4076686c1f5b = (value)=>{
    if (!$1092512147c3e960$export$12af7c5462954d1e(value)) return false;
    const entity = $1092512147c3e960$var$asRecord(value);
    const remoteLink = entity['atlassian:remote-link'];
    return $1092512147c3e960$var$isObject(remoteLink) && $1092512147c3e960$var$isOneOf($1092512147c3e960$var$REMOTE_LINK_TYPES, remoteLink.type);
};
const $1092512147c3e960$export$791f1b4852e2a184 = (value)=>$1092512147c3e960$export$12af7c5462954d1e(value) && $1092512147c3e960$var$isObject($1092512147c3e960$var$asRecord(value)['atlassian:project']);
const $1092512147c3e960$export$162dad7a1238d377 = (value)=>{
    if (!$1092512147c3e960$export$12af7c5462954d1e(value)) return false;
    const entity = $1092512147c3e960$var$asRecord(value);
    const workItem = entity['atlassian:work-item'];
    return $1092512147c3e960$var$isObject(workItem) && typeof workItem.status === 'string' && $1092512147c3e960$var$isOneOf($1092512147c3e960$var$WORK_ITEM_SUB_TYPES, workItem.subtype) && typeof workItem.team === 'string';
};
const $1092512147c3e960$export$32c06ee7e0e9b79e = (value)=>{
    if (!$1092512147c3e960$export$12af7c5462954d1e(value)) return false;
    const entityType = $1092512147c3e960$var$asRecord(value).type;
    return $1092512147c3e960$var$isObject(entityType) && (entityType.category === undefined || $1092512147c3e960$var$isOneOf($1092512147c3e960$var$DOCUMENT_CATEGORIES, entityType.category)) && (entityType.iconUrl === undefined || typeof entityType.iconUrl === 'string') && ($1092512147c3e960$var$isOneOf($1092512147c3e960$var$DOCUMENT_CATEGORIES, entityType.category) || typeof entityType.iconUrl === 'string');
};
const $1092512147c3e960$export$33e8c1bbf9148b0e = (value)=>$1092512147c3e960$export$12af7c5462954d1e(value) && ('attachments' in value || 'commentCount' in value || 'hidden' in value || 'isPinned' in value || 'lastActive' in value || 'reactions' in value);
const $1092512147c3e960$export$6c20afe8743cb761 = (value)=>$1092512147c3e960$export$12af7c5462954d1e(value) && ('isArchived' in value || 'lastActive' in value || 'memberCount' in value || 'members' in value || 'membershipType' in value || 'topic' in value || 'workspace' in value);
const $1092512147c3e960$export$fe785532d894f833 = (value)=>$1092512147c3e960$export$12af7c5462954d1e(value) && !$1092512147c3e960$export$8dc9be81b5b6266b(value) && !$1092512147c3e960$export$f16c4076686c1f5b(value) && !$1092512147c3e960$export$791f1b4852e2a184(value) && !$1092512147c3e960$export$162dad7a1238d377(value) && !$1092512147c3e960$export$32c06ee7e0e9b79e(value) && !$1092512147c3e960$export$33e8c1bbf9148b0e(value) && !$1092512147c3e960$export$6c20afe8743cb761(value);
const $1092512147c3e960$export$47565ffe58e56845 = (value)=>$1092512147c3e960$export$12af7c5462954d1e(value) && ($1092512147c3e960$export$8dc9be81b5b6266b(value) || $1092512147c3e960$export$f16c4076686c1f5b(value) || $1092512147c3e960$export$791f1b4852e2a184(value) || $1092512147c3e960$export$162dad7a1238d377(value) || $1092512147c3e960$export$32c06ee7e0e9b79e(value) || $1092512147c3e960$export$33e8c1bbf9148b0e(value) || $1092512147c3e960$export$6c20afe8743cb761(value) || $1092512147c3e960$export$fe785532d894f833(value));
module.exports["isBaseEntity"] = $1092512147c3e960$export$12af7c5462954d1e;
module.exports["isDesignEntity"] = $1092512147c3e960$export$8dc9be81b5b6266b;
module.exports["isDocumentEntity"] = $1092512147c3e960$export$32c06ee7e0e9b79e;

});

parcelRegister("4sZvs", function(module, exports) {

var $ldZvW = parcelRequire("ldZvW");


var $8akax = parcelRequire("8akax");


var $2i2Hp = parcelRequire("2i2Hp");

const $8bfb06df0501dc58$export$68f3db7f6af48bcb = (0, $8akax.createFeatureFlaggedComponent)((0, $2i2Hp.ConfluenceIcon), (0, $ldZvW.ConfluenceIcon));
module.exports["ConfluenceIcon"] = $8bfb06df0501dc58$export$68f3db7f6af48bcb;

});

parcelRegister("4TUdx", function(module, exports) {

var $g9Jfe = parcelRequire("g9Jfe");

const $3aa830dc3cf50928$var$GOOGLE_DRIVE = 'Google Drive';
const $3aa830dc3cf50928$export$df1b15aebbcf717e = (provider)=>{
    switch(provider?.text){
        case 'Google':
            return {
                ...provider,
                ...(0, $g9Jfe.fg)('platform_lp_use_entity_icon_url_for_icon') ? {
                    iconLabel: $3aa830dc3cf50928$var$GOOGLE_DRIVE
                } : undefined,
                text: $3aa830dc3cf50928$var$GOOGLE_DRIVE
            };
        default:
            return provider;
    }
};
module.exports["rebrandProvider"] = $3aa830dc3cf50928$export$df1b15aebbcf717e;

});

parcelRegister("kbte2", function(module, exports) {
const $4827a4a6130f9557$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $4827a4a6130f9557$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $4827a4a6130f9557$export$84a73a0383f58180 = 'JiraTask';
const $4827a4a6130f9557$export$c6c83963a9378a67 = 'JiraSubTask';
const $4827a4a6130f9557$export$58af3c426c111a6d = 'JiraStory';
const $4827a4a6130f9557$export$ac9898a63417219e = 'JiraBug';
const $4827a4a6130f9557$export$54db5e3fb12e39cd = 'JiraEpic';
const $4827a4a6130f9557$export$2f54a5a217202c85 = 'JiraIncident';
const $4827a4a6130f9557$export$d097371052bfc411 = 'JiraServiceRequest';
const $4827a4a6130f9557$export$efd9452ad16c6676 = 'JiraChange';
const $4827a4a6130f9557$export$2e7e70abb5d81f67 = 'JiraProblem';
const $4827a4a6130f9557$export$ce25cfc40b280dbc = 'JiraCustomTaskType';
var $4827a4a6130f9557$export$51f13ced115cbdae = /*#__PURE__*/ function(SmartLinkSize) {
    SmartLinkSize["XLarge"] = "xlarge";
    SmartLinkSize["Large"] = "large";
    SmartLinkSize["Medium"] = "medium";
    SmartLinkSize["Small"] = "small";
    return SmartLinkSize;
}({});
var $4827a4a6130f9557$export$13ff1290a9e22e77 = /*#__PURE__*/ function(IconType) {
    IconType["Archive"] = "FileType:Archive";
    IconType["Audio"] = "FileType:Audio";
    IconType["Code"] = "FileType:Code";
    IconType["Document"] = "FileType:Document";
    IconType["Executable"] = "FileType:Executable";
    IconType["File"] = "FileType:File";
    IconType["Folder"] = "FileType:Folder";
    IconType["Generic"] = "FileType:Generic";
    IconType["GIF"] = "FileType:GIF";
    IconType["GoogleDocs"] = "FileType:GoogleDocs";
    IconType["GoogleForms"] = "FileType:GoogleForms";
    IconType["GoogleSheets"] = "FileType:GoogleSheets";
    IconType["GoogleSlides"] = "FileType:GoogleSlides";
    IconType["Image"] = "FileType.Image";
    IconType["MSExcel"] = "FileType:Excel";
    IconType["MSPowerpoint"] = "FileType:Powerpoint";
    IconType["MSWord"] = "FileType:WordDocument";
    IconType["PDF"] = "FileType:PDF";
    IconType["Presentation"] = "FileType:Presentation";
    IconType["Sketch"] = "FileType:Sketch";
    IconType["Spreadsheet"] = "FileType:Spreadsheet";
    IconType["Video"] = "FileType:Video";
    return IconType;
}({});
module.exports["CONFLUENCE_GENERATOR_ID"] = $4827a4a6130f9557$export$cee224b5de4d6d66;
module.exports["JIRA_GENERATOR_ID"] = $4827a4a6130f9557$export$f654d825189934a7;
module.exports["JIRA_TASK"] = $4827a4a6130f9557$export$84a73a0383f58180;
module.exports["JIRA_SUB_TASK"] = $4827a4a6130f9557$export$c6c83963a9378a67;
module.exports["JIRA_STORY"] = $4827a4a6130f9557$export$58af3c426c111a6d;
module.exports["JIRA_BUG"] = $4827a4a6130f9557$export$ac9898a63417219e;
module.exports["JIRA_EPIC"] = $4827a4a6130f9557$export$54db5e3fb12e39cd;
module.exports["JIRA_INCIDENT"] = $4827a4a6130f9557$export$2f54a5a217202c85;
module.exports["JIRA_SERVICE_REQUEST"] = $4827a4a6130f9557$export$d097371052bfc411;
module.exports["JIRA_CHANGE"] = $4827a4a6130f9557$export$efd9452ad16c6676;
module.exports["JIRA_PROBLEM"] = $4827a4a6130f9557$export$2e7e70abb5d81f67;
module.exports["JIRA_CUSTOM_TASK_TYPE"] = $4827a4a6130f9557$export$ce25cfc40b280dbc;
module.exports["SmartLinkSize"] = $4827a4a6130f9557$export$51f13ced115cbdae;
module.exports["IconType"] = $4827a4a6130f9557$export$13ff1290a9e22e77;

});

parcelRegister("eoZW1", function(module, exports) {
/**
 * This function is being used to address locale discrepancies in Atlassian products:
 * see: https://hello.atlassian.net/wiki/spaces/i18n/pages/528623554/Locale+Discrepancies+Across+Atlassian+Products+and+Platform+Areas
 */ const $639791195d5194df$export$852ff24d0930c62f = (locale)=>{
    const standardizedLocale = locale.replace('_', '-');
    switch(standardizedLocale){
        case 'en-GB':
        case 'en-US':
        case 'en-XA':
        case 'en-XB':
        case 'en-ZZ':
        case 'pt-BR':
        case 'zh-CN':
        case 'zh-TW':
            return standardizedLocale;
        case 'en-UK':
            return 'en-GB';
        case 'en':
            return 'en-US';
        default:
            return standardizedLocale.split('-')[0];
    }
};
var $639791195d5194df$export$2e2bcd8739ae039 = $639791195d5194df$export$852ff24d0930c62f;
module.exports["default"] = $639791195d5194df$export$2e2bcd8739ae039;

});

parcelRegister("fP78j", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dRnqM = parcelRequire("dRnqM");


var $i7jPX = parcelRequire("i7jPX");

/**
 * __Object tile base__
 *
 * An object tile represents an Atlassian-specific content type.
 *
 */ const $fce53c8d1c9f5417$var$ObjectTileBase = (0, $4pOgL.isReactCompilerActivePlatform)() ? function ObjectTileBase(t0) {
    const $ = (0, $frIzR.c)(9);
    const { label: t1, size: t2, testId: testId, color: color, backgroundColor: backgroundColor, icon: Icon } = t0;
    const label = t1 === undefined ? "" : t1;
    const size = t2 === undefined ? "medium" : t2;
    const validSizes = [
        "xsmall",
        "small",
        "medium",
        "large",
        "xlarge"
    ];
    (0, $dRnqM.default)(validSizes.includes(size), `ObjectTile: size "${size}" is not valid. Valid sizes are: ${validSizes.join(", ")}`);
    let t3;
    if ($[0] !== Icon || $[1] !== color || $[2] !== label || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            label: label,
            color: color,
            testId: testId,
            shouldScale: true
        });
        $[0] = Icon;
        $[1] = color;
        $[2] = label;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== backgroundColor || $[6] !== size || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7jPX.default), {
            label: "",
            backgroundColor: backgroundColor,
            size: size
        }, t3);
        $[5] = backgroundColor;
        $[6] = size;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : function ObjectTileBase({ label: label = '', size: size = 'medium', testId: testId, color: color, backgroundColor: backgroundColor, icon: Icon }) {
    // Validate that size is a valid `ObjectTileSize` (and won't allow Tile's `xxsmall` size to be passed)
    const validSizes = [
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge'
    ];
    (0, $dRnqM.default)(validSizes.includes(size), `ObjectTile: size "${size}" is not valid. Valid sizes are: ${validSizes.join(', ')}`);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7jPX.default), {
        label: "",
        backgroundColor: backgroundColor,
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
        label: label,
        color: color,
        testId: testId,
        // @ts-expect-error - Internal, undocumented prop
        shouldScale: true
    }));
};
var $fce53c8d1c9f5417$export$2e2bcd8739ae039 = $fce53c8d1c9f5417$var$ObjectTileBase;
module.exports["default"] = $fce53c8d1c9f5417$export$2e2bcd8739ae039;

});

parcelRegister("2tvDK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $2ISy2 = parcelRequire("2ISy2");


var $fP78j = parcelRequire("fP78j");

const $ab5e2ffbeed9f2f4$var$BugObjectTile = (0, $4pOgL.isReactCompilerActivePlatform)() ? function BugObjectTile(t0) {
    const $ = (0, $frIzR.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Bug" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)";
    const t3 = isBold ? "color.background.accent.red.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($2ISy2))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function BugObjectTile({ label: label = 'Bug', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2ISy2))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)",
        backgroundColor: isBold ? 'color.background.accent.red.subtle' : undefined
    });
};
var $ab5e2ffbeed9f2f4$export$2e2bcd8739ae039 = $ab5e2ffbeed9f2f4$var$BugObjectTile;
module.exports["default"] = $ab5e2ffbeed9f2f4$export$2e2bcd8739ae039;

});

parcelRegister("9Q0L0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $4SWbm = parcelRequire("4SWbm");


var $fP78j = parcelRequire("fP78j");

const $4cf8a3e1f7af7bd1$var$EpicObjectTile = (0, $4pOgL.isReactCompilerActivePlatform)() ? function EpicObjectTile(t0) {
    const $ = (0, $frIzR.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Epic" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)";
    const t3 = isBold ? "color.background.accent.purple.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($4SWbm))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function EpicObjectTile({ label: label = 'Epic', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4SWbm))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)",
        backgroundColor: isBold ? 'color.background.accent.purple.subtle' : undefined
    });
};
var $4cf8a3e1f7af7bd1$export$2e2bcd8739ae039 = $4cf8a3e1f7af7bd1$var$EpicObjectTile;
module.exports["default"] = $4cf8a3e1f7af7bd1$export$2e2bcd8739ae039;

});

parcelRegister("kMqyt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $2qVkt = parcelRequire("2qVkt");


var $fP78j = parcelRequire("fP78j");

const $cb2f9539166b293e$var$WorkItemObjectTile = (0, $4pOgL.isReactCompilerActivePlatform)() ? function WorkItemObjectTile(t0) {
    const $ = (0, $frIzR.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Work Item" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($2qVkt))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function WorkItemObjectTile({ label: label = 'Work Item', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2qVkt))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $cb2f9539166b293e$export$2e2bcd8739ae039 = $cb2f9539166b293e$var$WorkItemObjectTile;
module.exports["default"] = $cb2f9539166b293e$export$2e2bcd8739ae039;

});

parcelRegister("lWQXA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $kR5QY = parcelRequire("kR5QY");


var $fP78j = parcelRequire("fP78j");

const $d00f1f002e9877f9$var$StoryObjectTile = (0, $4pOgL.isReactCompilerActivePlatform)() ? function StoryObjectTile(t0) {
    const $ = (0, $frIzR.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Story" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-green, #22A06B)";
    const t3 = isBold ? "color.background.accent.green.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kR5QY))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function StoryObjectTile({ label: label = 'Story', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kR5QY))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-green, #22A06B)",
        backgroundColor: isBold ? 'color.background.accent.green.subtle' : undefined
    });
};
var $d00f1f002e9877f9$export$2e2bcd8739ae039 = $d00f1f002e9877f9$var$StoryObjectTile;
module.exports["default"] = $d00f1f002e9877f9$export$2e2bcd8739ae039;

});

parcelRegister("fX4W8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dmbve = parcelRequire("dmbve");


var $fP78j = parcelRequire("fP78j");

const $042d51f21cf4898d$var$TaskObjectTile = (0, $4pOgL.isReactCompilerActivePlatform)() ? function TaskObjectTile(t0) {
    const $ = (0, $frIzR.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Task" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($dmbve))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function TaskObjectTile({ label: label = 'Task', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dmbve))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $042d51f21cf4898d$export$2e2bcd8739ae039 = $042d51f21cf4898d$var$TaskObjectTile;
module.exports["default"] = $042d51f21cf4898d$export$2e2bcd8739ae039;

});

parcelRegister("j6GAe", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $9RVmI = parcelRequire("9RVmI");


var $fP78j = parcelRequire("fP78j");

const $90028f2cad692a01$var$BlogObjectTile = (0, $4pOgL.isReactCompilerActivePlatform)() ? function BlogObjectTile(t0) {
    const $ = (0, $frIzR.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Blog" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function BlogObjectTile({ label: label = 'Blog', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $90028f2cad692a01$export$2e2bcd8739ae039 = $90028f2cad692a01$var$BlogObjectTile;
module.exports["default"] = $90028f2cad692a01$export$2e2bcd8739ae039;

});

parcelRegister("fAGae", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $e0ycV = parcelRequire("e0ycV");


var $fP78j = parcelRequire("fP78j");

const $0f3b40ffeda05888$var$PageLiveDocObjectTile = (0, $4pOgL.isReactCompilerActivePlatform)() ? function PageLiveDocObjectTile(t0) {
    const $ = (0, $frIzR.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Page Live Doc" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-magenta, #CD519D)";
    const t3 = isBold ? "color.background.accent.magenta.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function PageLiveDocObjectTile({ label: label = 'Page Live Doc', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-magenta, #CD519D)",
        backgroundColor: isBold ? 'color.background.accent.magenta.subtle' : undefined
    });
};
var $0f3b40ffeda05888$export$2e2bcd8739ae039 = $0f3b40ffeda05888$var$PageLiveDocObjectTile;
module.exports["default"] = $0f3b40ffeda05888$export$2e2bcd8739ae039;

});

parcelRegister("h7YX1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2131e07eab16a3d853e4806b506dca34>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c7825eb38d10cf15$var$_react = $c7825eb38d10cf15$var$_interopRequireDefault((parcelRequire("42omo")));

var $c7825eb38d10cf15$var$_baseNew = $c7825eb38d10cf15$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c7825eb38d10cf15$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeText".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/ai-generative-text
 * Usage guidance:
 * Reserved for auto draft functionality in Loom.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c7825eb38d10cf15$var$AiGenerativeTextIcon = (props)=>/*#__PURE__*/ $c7825eb38d10cf15$var$_react.default.createElement($c7825eb38d10cf15$var$_baseNew.default, Object.assign({
        name: "AiGenerativeTextIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12.617 9.011a.75.75 0 0 1 .588.483l.615 1.687 1.687.615a.75.75 0 0 1 0 1.41l-1.687.615-.615 1.686a.75.75 0 0 1-1.409 0l-.616-1.686-1.686-.616a.75.75 0 0 1 0-1.409l1.686-.615.616-1.687.048-.106A.75.75 0 0 1 12.5 9z"/><path fill="currentcolor" fill-rule="evenodd" d="M9.337.604a2 2 0 0 1 2.828 0l1.233 1.232a2 2 0 0 1 0 2.828l-8.1 8.099a2 2 0 0 1-1.022.547l-3.378.676a.75.75 0 0 1-.883-.883l.676-3.38a2 2 0 0 1 .546-1.02zm-7.04 9.159a.5.5 0 0 0-.136.256l-.456 2.275 2.278-.455a.5.5 0 0 0 .254-.137l6.078-6.078-1.94-1.94zm8.808-8.099a.5.5 0 0 0-.707 0l-.961.961 1.94 1.94.96-.961a.5.5 0 0 0 0-.707z" clip-rule="evenodd"/>`
    }, props));
$c7825eb38d10cf15$var$AiGenerativeTextIcon.displayName = 'AiGenerativeTextIcon';
var $c7825eb38d10cf15$var$_default = module.exports.default = $c7825eb38d10cf15$var$AiGenerativeTextIcon;

});

parcelRegister("9fywD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $5nBzc = parcelRequire("5nBzc");


var $3gadb = parcelRequire("3gadb");

const $43aed8c383cce8da$var$i18n = (0, $aXWIB.defineMessages)({
    externalUserLozengeText: {
        id: "external-collab-ui.user-guest-lozenge",
        defaultMessage: "Guest"
    },
    guestUserTooltip: {
        id: "external-collab-ui.user-guest-lozenge.tooltip",
        defaultMessage: "Guests can only access certain spaces and have limited access to user info."
    }
});
const $43aed8c383cce8da$export$4de00d985a23014d = {
    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $43aed8c383cce8da$var$i18n.guestUserTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $43aed8c383cce8da$var$i18n.externalUserLozengeText)),
    appearance: 'default',
    isBold: false
};
const $43aed8c383cce8da$export$aa87bb37f13b8b5 = ()=>{
    const { text: text, appearance: appearance, isBold: isBold } = $43aed8c383cce8da$export$4de00d985a23014d;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
        appearance: appearance,
        isBold: isBold
    }, text);
};
module.exports["ExternalUserLozengeProps"] = $43aed8c383cce8da$export$4de00d985a23014d;
module.exports["ExternalUserLozenge"] = $43aed8c383cce8da$export$aa87bb37f13b8b5;

});

parcelRegister("5qrxS", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $c6GJD = parcelRequire("c6GJD");


var $g9Jfe = parcelRequire("g9Jfe");


var $7dyLS = parcelRequire("7dyLS");

var $1C4cT = parcelRequire("1C4cT");


var $icARO = parcelRequire("icARO");


var $3FTlm = parcelRequire("3FTlm");


var $d4Mwr = parcelRequire("d4Mwr");

const $a7827c25df0a1c01$var$messages = (0, $aXWIB.defineMessages)({
    create: {
        id: "link-create.jira-plugin-create-config",
        defaultMessage: "Create"
    }
});
const $a7827c25df0a1c01$export$c0007b48d375a9ff = {
    tabConfig: {
        tabKey: 'jira',
        tabTitle: 'Jira'
    },
    products: [
        'jira'
    ],
    scope: (0, $7dyLS.Scope).JiraIssueDashboardBoardProjectFilter
};
const $a7827c25df0a1c01$export$af1b31f68dc05ab3 = (formatMessage)=>({
        ...$a7827c25df0a1c01$export$c0007b48d375a9ff,
        action: {
            label: formatMessage($a7827c25df0a1c01$var$messages.create),
            callback: ()=>{
                console.log('Placeholder for Jira Create');
            }
        }
    });
const $a7827c25df0a1c01$export$3fc43c5f39c4a529 = {
    tabConfig: {
        tabKey: 'confluence',
        tabTitle: 'Confluence'
    },
    products: [
        'confluence'
    ],
    scope: (0, $7dyLS.Scope).ConfluenceContentType
};
const $a7827c25df0a1c01$export$547f1973f56da40b = {
    tabConfig: {
        tabKey: 'atlas',
        tabTitle: 'Atlas'
    },
    products: [
        'townsquare'
    ],
    scope: (0, $7dyLS.Scope).TownsquareProject
};
const $a7827c25df0a1c01$export$32f102fef46346 = {
    tabConfig: {
        tabKey: 'home',
        tabTitle: 'Home'
    },
    products: [
        'townsquare'
    ],
    scope: (0, $7dyLS.Scope).TownsquareProject
};
const $a7827c25df0a1c01$export$b1b5e4959b6adcf2 = {
    tabConfig: {
        tabKey: 'loom',
        tabTitle: 'Loom'
    },
    products: [
        'loom'
    ],
    scope: (0, $7dyLS.Scope).Loom,
    disableActivityClient: true
};
const $a7827c25df0a1c01$var$currentProductToPluginMap = {
    jira: $a7827c25df0a1c01$export$c0007b48d375a9ff,
    confluence: $a7827c25df0a1c01$export$3fc43c5f39c4a529,
    atlas: $a7827c25df0a1c01$export$547f1973f56da40b,
    loom: $a7827c25df0a1c01$export$b1b5e4959b6adcf2,
    townsquare: $a7827c25df0a1c01$export$32f102fef46346
};
const $a7827c25df0a1c01$export$ede9abe489c9321b = (0, $4pOgL.isReactCompilerActivePlatform)() ? (config)=>{
    const $ = (0, $frIzR.c)(33);
    let t0;
    if ($[0] !== config) {
        t0 = config ?? {};
        $[0] = config;
        $[1] = t0;
    } else t0 = $[1];
    const { cloudId: cloudId, activityClientEndpoint: activityClientEndpoint, aggregatorUrl: aggregatorUrl } = t0;
    const { availableProducts: availableProducts, isLoading: isLoading } = (0, $d4Mwr.useAvailableProducts)(config?.cloudId);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let t1;
    if ($[2] !== config?.product) {
        t1 = config?.product?.toLowerCase();
        $[2] = config?.product;
        $[3] = t1;
    } else t1 = $[3];
    const currentProduct = t1;
    let t2;
    if ($[4] !== activityClientEndpoint || $[5] !== aggregatorUrl || $[6] !== cloudId) {
        t2 = (config_0)=>({
                cloudId: cloudId,
                activityClientEndpoint: activityClientEndpoint,
                aggregatorUrl: aggregatorUrl,
                ...config_0
            });
        $[4] = activityClientEndpoint;
        $[5] = aggregatorUrl;
        $[6] = cloudId;
        $[7] = t2;
    } else t2 = $[7];
    const createPluginConfig = t2;
    let t3;
    if ($[8] !== createPluginConfig || $[9] !== formatMessage) {
        t3 = createPluginConfig((0, $g9Jfe.fg)("platform.linking-platform.link-picker.enable-jira-create") ? $a7827c25df0a1c01$export$af1b31f68dc05ab3(formatMessage) : $a7827c25df0a1c01$var$currentProductToPluginMap.jira);
        $[8] = createPluginConfig;
        $[9] = formatMessage;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    let t5;
    let t6;
    let t7;
    if ($[11] !== createPluginConfig) {
        t4 = createPluginConfig($a7827c25df0a1c01$var$currentProductToPluginMap.confluence);
        t5 = createPluginConfig($a7827c25df0a1c01$var$currentProductToPluginMap.atlas);
        t6 = createPluginConfig($a7827c25df0a1c01$var$currentProductToPluginMap.townsquare);
        t7 = createPluginConfig($a7827c25df0a1c01$var$currentProductToPluginMap.loom);
        $[11] = createPluginConfig;
        $[12] = t4;
        $[13] = t5;
        $[14] = t6;
        $[15] = t7;
    } else {
        t4 = $[12];
        t5 = $[13];
        t6 = $[14];
        t7 = $[15];
    }
    let t8;
    if ($[16] !== t3 || $[17] !== t4 || $[18] !== t5 || $[19] !== t6 || $[20] !== t7) {
        t8 = {
            jira: t3,
            confluence: t4,
            atlas: t5,
            townsquare: t6,
            loom: t7
        };
        $[16] = t3;
        $[17] = t4;
        $[18] = t5;
        $[19] = t6;
        $[20] = t7;
        $[21] = t8;
    } else t8 = $[21];
    const configMap = t8;
    let t9;
    if ($[22] !== availableProducts || $[23] !== configMap || $[24] !== currentProduct || $[25] !== isLoading) {
        const plugins = [];
        const isLoomBetaEnabled = (0, $c6GJD.default).checkGate("confluence_loom_beta_enabled");
        const isLoomM25Enabled = (0, $c6GJD.default).checkGate("confluence_frontend_loom_cross_sell");
        if (currentProduct && (0, $3FTlm.isSupportedCurrentProduct)(currentProduct)) plugins.push(configMap[currentProduct]);
        let t10;
        if ($[27] !== currentProduct) {
            t10 = (product)=>currentProduct !== product;
            $[27] = currentProduct;
            $[28] = t10;
        } else t10 = $[28];
        let t11;
        if ($[29] !== currentProduct) {
            t11 = (product_0)=>{
                if (currentProduct === "townsquare") return product_0 !== "atlas";
                return !!product_0;
            };
            $[29] = currentProduct;
            $[30] = t11;
        } else t11 = $[30];
        let t12;
        if ($[31] !== configMap) {
            t12 = (product_2)=>configMap[product_2];
            $[31] = configMap;
            $[32] = t12;
        } else t12 = $[32];
        t9 = {
            isLoading: isLoading,
            atlassianPluginsConfig: [
                ...plugins,
                ...(0, $icARO.supportedCurrentProducts).filter(t10).filter(t11).filter((product_1)=>product_1 === "loom" && isLoomBetaEnabled || availableProducts.some((availableProduct)=>product_1 === (0, $3FTlm.lookupCurrentProductByProduct)(availableProduct) && (product_1 !== "loom" || isLoomM25Enabled))).map(t12)
            ]
        };
        $[22] = availableProducts;
        $[23] = configMap;
        $[24] = currentProduct;
        $[25] = isLoading;
        $[26] = t9;
    } else t9 = $[26];
    return t9;
} : (config)=>{
    const { cloudId: cloudId, activityClientEndpoint: activityClientEndpoint, aggregatorUrl: aggregatorUrl } = config ?? {};
    const { availableProducts: availableProducts, isLoading: isLoading } = (0, $d4Mwr.useAvailableProducts)(config?.cloudId);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    /**
   * Lower case possible name of product. Should be `confluence` or `jira`.
   * This typing is not ideal. An unknown current product will:
   * - in the case of no 1P tabs enabled, default to Scope.ConfluencePageBlog scope
   * - in the case of 1P tabs enabled, not ensure the first tab is the current product
   */ const currentProduct = config?.product?.toLowerCase();
    const createPluginConfig = (0, $42omo.useMemo)(()=>{
        return (config_0)=>({
                cloudId: cloudId,
                activityClientEndpoint: activityClientEndpoint,
                aggregatorUrl: aggregatorUrl,
                ...config_0
            });
    }, [
        cloudId,
        activityClientEndpoint,
        aggregatorUrl
    ]);
    const configMap = (0, $42omo.useMemo)(()=>{
        return {
            jira: createPluginConfig((0, $g9Jfe.fg)('platform.linking-platform.link-picker.enable-jira-create') ? $a7827c25df0a1c01$export$af1b31f68dc05ab3(formatMessage) : $a7827c25df0a1c01$var$currentProductToPluginMap.jira),
            confluence: createPluginConfig($a7827c25df0a1c01$var$currentProductToPluginMap.confluence),
            atlas: createPluginConfig($a7827c25df0a1c01$var$currentProductToPluginMap.atlas),
            townsquare: createPluginConfig($a7827c25df0a1c01$var$currentProductToPluginMap.townsquare),
            loom: createPluginConfig($a7827c25df0a1c01$var$currentProductToPluginMap.loom)
        };
    }, [
        createPluginConfig,
        formatMessage
    ]);
    return (0, $42omo.useMemo)(()=>{
        const plugins = [];
        // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        const isLoomBetaEnabled = (0, $c6GJD.default).checkGate('confluence_loom_beta_enabled');
        // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        const isLoomM25Enabled = (0, $c6GJD.default).checkGate('confluence_frontend_loom_cross_sell');
        // Add plugin for current product as the first tab, if we have a supported tab for it
        // We are assuming that if a product is the current product and we have a supported tab, it's in available products
        // (eg. we assume if you're in Jira, Jira will be in available products)
        if (currentProduct && (0, $3FTlm.isSupportedCurrentProduct)(currentProduct)) plugins.push(configMap[currentProduct]);
        return {
            isLoading: isLoading,
            atlassianPluginsConfig: [
                ...plugins,
                ...(0, $icARO.supportedCurrentProducts)// Exclude the current product, we've already included it above if theres a matching config available
                .filter((product)=>currentProduct !== product)// Exclude 'Atlas' tab is there is already a 'Home' tab
                .filter((product_0)=>{
                    if (currentProduct === 'townsquare') return product_0 !== 'atlas';
                    return !!product_0;
                })// Remove any products that did not appear in the list of availableProducts
                // Does not factor in the currentProduct, that will still be in the resulting array as it
                // has been included seperately above
                .filter((product_1)=>product_1 === 'loom' && isLoomBetaEnabled || availableProducts.some((availableProduct)=>product_1 === (0, $3FTlm.lookupCurrentProductByProduct)(availableProduct) && (product_1 !== 'loom' || isLoomM25Enabled)))// Map product strings to their defined config in the config map
                .map((product_2)=>configMap[product_2])
            ]
        };
    }, [
        configMap,
        availableProducts,
        currentProduct,
        isLoading
    ]);
};
const $a7827c25df0a1c01$export$45a18a62e79260ff = (0, $4pOgL.isReactCompilerActivePlatform)() ? (config)=>{
    const $ = (0, $frIzR.c)(3);
    const { atlassianPluginsConfig: atlassianPluginsConfig, isLoading: isLoading } = $a7827c25df0a1c01$export$ede9abe489c9321b(config);
    const plugins = (0, $1C4cT.useAtlassianPlugins)(atlassianPluginsConfig);
    let t0;
    if ($[0] !== isLoading || $[1] !== plugins) {
        t0 = {
            plugins: plugins,
            isLoading: isLoading
        };
        $[0] = isLoading;
        $[1] = plugins;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (config)=>{
    const { atlassianPluginsConfig: atlassianPluginsConfig, isLoading: isLoading } = $a7827c25df0a1c01$export$ede9abe489c9321b(config);
    const plugins = (0, $1C4cT.useAtlassianPlugins)(atlassianPluginsConfig);
    return {
        plugins: plugins,
        isLoading: isLoading
    };
};
module.exports["useLinkPickerPlugins"] = $a7827c25df0a1c01$export$45a18a62e79260ff;

});

parcelRegister("1C4cT", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $8fW0f = parcelRequire("8fW0f");

const $1ff157185fb6e44c$export$679584c8d36ab911 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (configs)=>{
    const $ = (0, $frIzR.c)(5);
    const [atlassianPlugins] = (0, $42omo.useState)($1ff157185fb6e44c$var$_temp);
    let t0;
    if ($[0] !== atlassianPlugins || $[1] !== configs) {
        let t1;
        if ($[3] !== atlassianPlugins) {
            t1 = (config)=>{
                const existingPlugin = atlassianPlugins.get(config);
                if (existingPlugin) return existingPlugin;
                const newPlugin = new (0, $8fW0f.default)(config);
                atlassianPlugins.set(config, newPlugin);
                return newPlugin;
            };
            $[3] = atlassianPlugins;
            $[4] = t1;
        } else t1 = $[4];
        t0 = configs.map(t1);
        $[0] = atlassianPlugins;
        $[1] = configs;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (configs)=>{
    const [atlassianPlugins] = (0, $42omo.useState)(()=>new WeakMap());
    return (0, $42omo.useMemo)(()=>configs.map((config)=>{
            const existingPlugin = atlassianPlugins.get(config);
            if (existingPlugin) return existingPlugin;
            // If we haven't already created a plugin for this config, create one now
            // and store it in the map.
            const newPlugin = new (0, $8fW0f.default)(config);
            atlassianPlugins.set(config, newPlugin);
            return newPlugin;
        }), [
        atlassianPlugins,
        configs
    ]);
};
function $1ff157185fb6e44c$var$_temp() {
    return new WeakMap();
}
module.exports["useAtlassianPlugins"] = $1ff157185fb6e44c$export$679584c8d36ab911;

});

parcelRegister("icARO", function(module, exports) {
/**
 * Possible values for the current product. This is the order that tabs will appear in - though the first tab will always be the current product.
 * This is currently typed in LinkPickerPluginsConfiguration as `string` so this is used for checking tab order.
 * `atlas` is used as it's a public API.
 * This is also documented in the docstring for `product` in LinkPickerPluginsConfiguration.
 */ const $b5f4a14afbf914da$export$15d6fc53154f51b3 = [
    'loom',
    'jira',
    'confluence',
    'atlas',
    'townsquare'
];
module.exports["supportedCurrentProducts"] = $b5f4a14afbf914da$export$15d6fc53154f51b3;

});

parcelRegister("3FTlm", function(module, exports) {

var $icARO = parcelRequire("icARO");

const $c011f3c2795ed007$var$suportedCurrentProductMap = {
    'jira-core.ondemand': 'jira',
    'jira-incident-manager.ondemand': 'jira',
    'jira-product-discovery': 'jira',
    'jira-servicedesk.ondemand': 'jira',
    'jira-software.ondemand': 'jira',
    'confluence.ondemand': 'confluence',
    townsquare: 'atlas',
    loom: 'loom'
};
function $c011f3c2795ed007$export$40cf7a2a01d13d9d(str) {
    const strings = (0, $icARO.supportedCurrentProducts);
    return strings.includes(str);
}
function $c011f3c2795ed007$export$7e250790d0036a52(product) {
    // Product may not be in supportedProducts array, that's what this is checking
    if (!(product in $c011f3c2795ed007$var$suportedCurrentProductMap)) return undefined;
    return $c011f3c2795ed007$var$suportedCurrentProductMap[product];
}
module.exports["isSupportedCurrentProduct"] = $c011f3c2795ed007$export$40cf7a2a01d13d9d;
module.exports["lookupCurrentProductByProduct"] = $c011f3c2795ed007$export$7e250790d0036a52;

});

parcelRegister("d4Mwr", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $kiOFr = parcelRequire("kiOFr");

const $30f10d0a027e62a0$export$5afbfe6edea8e998 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (cloudId)=>{
    const $ = (0, $frIzR.c)(9);
    const { data: data, loading: isLoading } = (0, $kiOFr.useAvailableSites)();
    let t0;
    bb0: {
        if (!data.length) {
            let t1;
            if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
                t1 = [];
                $[0] = t1;
            } else t1 = $[0];
            t0 = t1;
            break bb0;
        }
        if (cloudId) {
            let t1;
            if ($[1] !== cloudId || $[2] !== data) {
                t1 = data.find((site)=>site.cloudId === cloudId)?.products ?? [];
                $[1] = cloudId;
                $[2] = data;
                $[3] = t1;
            } else t1 = $[3];
            t0 = t1;
            break bb0;
        }
        let t1;
        if ($[4] !== data) {
            t1 = Array.from(data.reduce($30f10d0a027e62a0$var$_temp, new Set()));
            $[4] = data;
            $[5] = t1;
        } else t1 = $[5];
        t0 = t1;
    }
    let t1;
    if ($[6] !== isLoading || $[7] !== t0) {
        t1 = {
            availableProducts: t0,
            isLoading: isLoading
        };
        $[6] = isLoading;
        $[7] = t0;
        $[8] = t1;
    } else t1 = $[8];
    return t1;
} : (cloudId)=>{
    const { data: data, loading: isLoading } = (0, $kiOFr.useAvailableSites)();
    return {
        availableProducts: (0, $42omo.useMemo)(()=>{
            if (!data.length) return [];
            if (cloudId) return data.find((site)=>site.cloudId === cloudId)?.products ?? [];
            // Get all the products from all sites and deduplicate
            return Array.from(data.reduce((prev, curr)=>{
                return new Set([
                    ...curr.products,
                    ...Array.from(prev)
                ]);
            }, new Set()));
        }, [
            data,
            cloudId
        ]),
        isLoading: isLoading
    };
};
function $30f10d0a027e62a0$var$_temp(prev, curr) {
    return new Set([
        ...curr.products,
        ...Array.from(prev)
    ]);
}
module.exports["useAvailableProducts"] = $30f10d0a027e62a0$export$5afbfe6edea8e998;

});

parcelRegister("i8tPN", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $6f0Oj = parcelRequire("6f0Oj");


var $ecnYn = parcelRequire("ecnYn");


var $a3fRD = parcelRequire("a3fRD");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8940fb02b7c06f89$var$ErrorContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_zulp1b66 _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulp1b66 _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $8940fb02b7c06f89$var$PrimaryText = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_syazi7uo",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_syazi7uo",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8940fb02b7c06f89$var$SecondaryText = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_syaz1rpy",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_syaz1rpy",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8940fb02b7c06f89$var$RedText = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_syaz1tmw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_syaz1tmw",
            __cmplp.className
        ])
    });
});
const $8940fb02b7c06f89$var$errorIconStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.050',
    marginRight: 'space.050'
});
const $8940fb02b7c06f89$export$500ff750b69ba110 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { primaryText: primaryText, secondaryText: secondaryText, isSpaceSelectionError: isSpaceSelectionError, isTagDisplayError: isTagDisplayError } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $8940fb02b7c06f89$var$errorIconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
            label: "",
            color: "var(--ds-icon-danger, #C9372C)",
            spacing: "none"
        }));
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== isSpaceSelectionError || $[2] !== primaryText) {
        t2 = isSpaceSelectionError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8940fb02b7c06f89$var$RedText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), primaryText));
        $[1] = isSpaceSelectionError;
        $[2] = primaryText;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== isTagDisplayError || $[5] !== primaryText || $[6] !== secondaryText) {
        t3 = isTagDisplayError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8940fb02b7c06f89$var$PrimaryText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), primaryText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8940fb02b7c06f89$var$SecondaryText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), secondaryText)));
        $[4] = isTagDisplayError;
        $[5] = primaryText;
        $[6] = secondaryText;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== t2 || $[9] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8940fb02b7c06f89$var$ErrorContainer, {
            "data-testid": "classification-level-error"
        }, t1, t2, t3);
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
} : ({ primaryText: primaryText, secondaryText: secondaryText, isSpaceSelectionError: isSpaceSelectionError, isTagDisplayError: isTagDisplayError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8940fb02b7c06f89$var$ErrorContainer, {
        "data-testid": "classification-level-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $8940fb02b7c06f89$var$errorIconStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
        label: "",
        color: "var(--ds-icon-danger, #C9372C)",
        spacing: "none"
    })), isSpaceSelectionError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8940fb02b7c06f89$var$RedText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), primaryText)), isTagDisplayError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8940fb02b7c06f89$var$PrimaryText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), primaryText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8940fb02b7c06f89$var$SecondaryText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), secondaryText))));
module.exports["ClassificationLevelError"] = $8940fb02b7c06f89$export$500ff750b69ba110;

});

parcelRegister("2O7oS", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $b3j2Y = parcelRequire("b3j2Y");


var $i8tPN = parcelRequire("i8tPN");


var $earLp = parcelRequire("earLp");


var $93WhG = parcelRequire("93WhG");

const $0a7aa4ef87c7240f$export$91f86b39c4eb641 = ({ contentLevelError: contentLevelError, spaceLevelError: spaceLevelError, primaryText: primaryText, secondaryText: secondaryText })=>{
    const { trackRenderTagError: trackRenderTagError } = (0, $earLp.useTrackClassificationAnalytics)();
    (0, $42omo.useEffect)(()=>{
        const errorMessage = [
            contentLevelError?.message,
            spaceLevelError?.message
        ].filter(Boolean).join(' | ') || 'Unknown error';
        trackRenderTagError(errorMessage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, contentLevelError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: contentLevelError
    }) : null, spaceLevelError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: spaceLevelError
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i8tPN.ClassificationLevelError), {
        primaryText: primaryText || (0, $93WhG.sharedMessages).fetchErrorTextPrimary,
        secondaryText: secondaryText || (0, $93WhG.sharedMessages).fetchErrorTextSecondary,
        isTagDisplayError: true
    }));
};
module.exports["ClassificationTagButtonError"] = $0a7aa4ef87c7240f$export$91f86b39c4eb641;

});

parcelRegister("5RPbY", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $9ee3ba3f5fa2cebc$export$b00e22884b6dd9a = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "1hM5R",
    name: "EditorAppearanceButtonNext",
    loader: async ()=>{
        const { EditorAppearanceButtonNext: EditorAppearanceButtonNext } = await (parcelRequire("dEgoA"));
        return EditorAppearanceButtonNext;
    }
});
module.exports["EditorAppearanceButtonNext"] = $9ee3ba3f5fa2cebc$export$b00e22884b6dd9a;

});

parcelRegister("dEgoA", function(module, exports) {

let $9efbbaa0b2bfd029$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9efbbaa0b2bfd029$var$load("6wr18"),
    $9efbbaa0b2bfd029$var$load("dlm6q"),
    $9efbbaa0b2bfd029$var$load("ffEVr"),
    $9efbbaa0b2bfd029$var$load("7EorR"),
    $9efbbaa0b2bfd029$var$load("jbM5v"),
    $9efbbaa0b2bfd029$var$load("7GtpA")
]).then(()=>parcelRequire('Vjn6T'));

});

parcelRegister("jPcvk", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $7e7400ce50234362$export$a8e3305d336ef5aa = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "K14-x",
    name: "EditorContentModeButton",
    loader: async ()=>{
        const { EditorContentModeButton: EditorContentModeButton } = await (parcelRequire("23zuW"));
        return EditorContentModeButton;
    }
});
module.exports["EditorContentModeButton"] = $7e7400ce50234362$export$a8e3305d336ef5aa;

});

parcelRegister("23zuW", function(module, exports) {

let $17f765bed6de5092$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $17f765bed6de5092$var$load("4LnHi"),
    $17f765bed6de5092$var$load("cC68k")
]).then(()=>parcelRequire('iI06X'));

});

parcelRegister("5e34M", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $0c67d43e155b2cd3$export$8ce5c583c1fa5a96 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "rGXr0",
    name: "EmojiTitleButtonLoader",
    loader: async ()=>(await (parcelRequire("lHBXD"))).EmojiTitleButton
});
module.exports["EmojiTitleButtonLoader"] = $0c67d43e155b2cd3$export$8ce5c583c1fa5a96;

});

parcelRegister("lHBXD", function(module, exports) {

let $fccb0f61c8189a73$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fccb0f61c8189a73$var$load("6wr18"),
    $fccb0f61c8189a73$var$load("dlm6q"),
    $fccb0f61c8189a73$var$load("el56J"),
    $fccb0f61c8189a73$var$load("ffEVr"),
    $fccb0f61c8189a73$var$load("4izLy"),
    $fccb0f61c8189a73$var$load("daX4F"),
    $fccb0f61c8189a73$var$load("4LnHi"),
    $fccb0f61c8189a73$var$load("9Zd2C")
]).then(()=>parcelRequire('2FMo5'));

});


//# sourceMappingURL=SpaceOverviewSwitcher.b869a226.js.map
